/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './schema';
const defaultOptions = {} as const;
export type TAddressFieldsFragment = {
  id: string;
  companyId: string;
  _version: number;
  _deleted: boolean | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  zipCode: string | null;
  parentType: Types.TAddressParentTypes | null;
  useGoogleAddress: boolean | null;
  googleValidated: boolean | null;
  missingInfo: boolean | null;
  alert: string | null;
  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
};

export type TListAllAddressesQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListAllAddressesQuery = {
  listAddresses: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null>;
  };
};

export type TGetAddressByIdQueryVariables = Exact<{
  id: string;
}>;

export type TGetAddressByIdQuery = {
  getAddressById: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TAddressNewFieldsFragment = {
  parent: string | null;
  id: string;
  companyId: string;
  _version: number;
  _deleted: boolean | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  zipCode: string | null;
  parentType: Types.TAddressParentTypes | null;
  useGoogleAddress: boolean | null;
  googleValidated: boolean | null;
  missingInfo: boolean | null;
  alert: string | null;
  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
};

export type TListAddressesByCompanyIdQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListAddressesByCompanyIdQuery = {
  listAddressesByCompanyId: {
    nextToken: string | null;
    items: Array<{
      parent: string | null;
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null>;
  };
};

export type TListOneAddressQueryVariables = Exact<{
  id: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneAddressQuery = {
  listOneAddress: {
    nextToken: string | null;
    items: Array<{
      parent: string | null;
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null>;
  };
};

export type TCompanyFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  active: boolean | null;
  isLive: boolean | null;
  deliveryMethod: Types.TDeliveryMethod;
  name: string;
  fullyConfigured: boolean | null;
  employeeBirthdayActivated: boolean;
  employeeWorkAnniversaryActivated: boolean;
  employeeNewHireKitActivated: boolean;
  significantOtherBirthdayActivated: boolean;
  childBirthdayActivated: boolean;
  petBirthdayActivated: boolean;
  workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
  customWorkAnniversaryNotes: string | null;
  hasCustomOnboardBrick: boolean | null;
  tissueColor: string;
  legoColor: string | null;
  signAs: string | null;
  specialNote: string | null;
  swag: string | null;
  startDate: string | null;
  endDate: string | null;
  subscriptionPricePerUser: number | null;
  subscriptionPriceCurrency: string | null;
  accountManager: string | null;
  lastRosterUpload: string | null;
  rosterId: string | null;
  subdomain: string;
  emailDomains: Array<string>;
  googleLoginEnabled: boolean | null;
  logo: string | null;
  giftPacks: string | null;
  customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
  configuration: { authUserPoolId: string | null } | null;
  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TGetCompanyQueryVariables = Exact<{
  id: string;
}>;

export type TGetCompanyQuery = {
  getCompany: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    active: boolean | null;
    isLive: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    name: string;
    fullyConfigured: boolean | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    startDate: string | null;
    endDate: string | null;
    subscriptionPricePerUser: number | null;
    subscriptionPriceCurrency: string | null;
    accountManager: string | null;
    lastRosterUpload: string | null;
    rosterId: string | null;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    logo: string | null;
    giftPacks: string | null;
    customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    configuration: { authUserPoolId: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TCreateCompanyMutationVariables = Exact<{
  input: Types.TCreateCompanyMutationInput;
}>;

export type TCreateCompanyMutation = {
  createCompany: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    active: boolean | null;
    isLive: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    name: string;
    fullyConfigured: boolean | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    startDate: string | null;
    endDate: string | null;
    subscriptionPricePerUser: number | null;
    subscriptionPriceCurrency: string | null;
    accountManager: string | null;
    lastRosterUpload: string | null;
    rosterId: string | null;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    logo: string | null;
    giftPacks: string | null;
    customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    configuration: { authUserPoolId: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TUpdateCompanyMutationVariables = Exact<{
  id: string;
  _version: number;
  input: Types.TUpdateCompanyMutationInput;
}>;

export type TUpdateCompanyMutation = {
  updateCompany: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    active: boolean | null;
    isLive: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    name: string;
    fullyConfigured: boolean | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    startDate: string | null;
    endDate: string | null;
    subscriptionPricePerUser: number | null;
    subscriptionPriceCurrency: string | null;
    accountManager: string | null;
    lastRosterUpload: string | null;
    rosterId: string | null;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    logo: string | null;
    giftPacks: string | null;
    customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    configuration: { authUserPoolId: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TDeleteCompanyMutationVariables = Exact<{
  id: string;
  _version: number;
}>;

export type TDeleteCompanyMutation = {
  deleteCompany: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    active: boolean | null;
    isLive: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    name: string;
    fullyConfigured: boolean | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    startDate: string | null;
    endDate: string | null;
    subscriptionPricePerUser: number | null;
    subscriptionPriceCurrency: string | null;
    accountManager: string | null;
    lastRosterUpload: string | null;
    rosterId: string | null;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    logo: string | null;
    giftPacks: string | null;
    customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    configuration: { authUserPoolId: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TOnAnyCompanyChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyCompanyChangedSubscription = {
  onAnyCompanyChanged: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    active: boolean | null;
    isLive: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    name: string;
    fullyConfigured: boolean | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    startDate: string | null;
    endDate: string | null;
    subscriptionPricePerUser: number | null;
    subscriptionPriceCurrency: string | null;
    accountManager: string | null;
    lastRosterUpload: string | null;
    rosterId: string | null;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    logo: string | null;
    giftPacks: string | null;
    customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    configuration: { authUserPoolId: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TListAllCompaniesFieldsFragment = {
  __typename: 'Company';
  id: string;
  _version: number;
  name: string;
  employeeCount: number | null;
  endDate: string | null;
  active: boolean | null;
  isLive: boolean | null;
  deliveryMethod: Types.TDeliveryMethod;
  fullyConfigured: boolean | null;
  lastRosterUpload: string | null;
  accountManager: string | null;
  workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
};

export type TListAllCompaniesQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
  isScan?: boolean | null | undefined;
}>;

export type TListAllCompaniesQuery = {
  listAllCompanies: {
    nextToken: string | null;
    items: Array<{
      __typename: 'Company';
      id: string;
      _version: number;
      name: string;
      employeeCount: number | null;
      endDate: string | null;
      active: boolean | null;
      isLive: boolean | null;
      deliveryMethod: Types.TDeliveryMethod;
      fullyConfigured: boolean | null;
      lastRosterUpload: string | null;
      accountManager: string | null;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    } | null>;
  };
};

export type TListAllCompaniesOptionsFieldsFragment = {
  __typename: 'Company';
  id: string;
  _version: number;
  name: string;
  active: boolean | null;
  isLive: boolean | null;
  endDate: string | null;
  deliveryMethod: Types.TDeliveryMethod;
  workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
};

export type TListAllCompaniesOptionsQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
  isScan?: boolean | null | undefined;
}>;

export type TListAllCompaniesOptionsQuery = {
  listAllCompanies: {
    nextToken: string | null;
    items: Array<{
      __typename: 'Company';
      id: string;
      _version: number;
      name: string;
      active: boolean | null;
      isLive: boolean | null;
      endDate: string | null;
      deliveryMethod: Types.TDeliveryMethod;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    } | null>;
  };
};

export type TListOneCompanyFieldsFragment = {
  id: string;
  _version: number;
  name: string;
  active: boolean | null;
  isLive: boolean | null;
  accountManager: string | null;
  deliveryMethod: Types.TDeliveryMethod;
  subdomain: string;
  emailDomains: Array<string>;
  googleLoginEnabled: boolean | null;
  legoColor: string | null;
  tissueColor: string;
  startDate: string | null;
  endDate: string | null;
  subscriptionPricePerUser: number | null;
  subscriptionPriceCurrency: string | null;
  fullyConfigured: boolean | null;
  employeeNewHireKitActivated: boolean;
  employeeBirthdayActivated: boolean;
  significantOtherBirthdayActivated: boolean;
  childBirthdayActivated: boolean;
  petBirthdayActivated: boolean;
  employeeWorkAnniversaryActivated: boolean;
  workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
  customWorkAnniversaryNotes: string | null;
  hasCustomOnboardBrick: boolean | null;
  signAs: string | null;
  specialNote: string | null;
  swag: string | null;
  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
  configuration: { authUserPoolId: string | null } | null;
  customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
};

export type TListOneCompanyQueryVariables = Exact<{
  id: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
  isScan?: boolean | null | undefined;
}>;

export type TListOneCompanyQuery = {
  listOneCompany: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      name: string;
      active: boolean | null;
      isLive: boolean | null;
      accountManager: string | null;
      deliveryMethod: Types.TDeliveryMethod;
      subdomain: string;
      emailDomains: Array<string>;
      googleLoginEnabled: boolean | null;
      legoColor: string | null;
      tissueColor: string;
      startDate: string | null;
      endDate: string | null;
      subscriptionPricePerUser: number | null;
      subscriptionPriceCurrency: string | null;
      fullyConfigured: boolean | null;
      employeeNewHireKitActivated: boolean;
      employeeBirthdayActivated: boolean;
      significantOtherBirthdayActivated: boolean;
      childBirthdayActivated: boolean;
      petBirthdayActivated: boolean;
      employeeWorkAnniversaryActivated: boolean;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
      customWorkAnniversaryNotes: string | null;
      hasCustomOnboardBrick: boolean | null;
      signAs: string | null;
      specialNote: string | null;
      swag: string | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      configuration: { authUserPoolId: string | null } | null;
      customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    } | null>;
  };
};

export type TSoftDeleteCompanyMutationVariables = Exact<{
  id: string;
  _version: number;
}>;

export type TSoftDeleteCompanyMutation = {
  softDeleteCompany: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    active: boolean | null;
    isLive: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    name: string;
    fullyConfigured: boolean | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    startDate: string | null;
    endDate: string | null;
    subscriptionPricePerUser: number | null;
    subscriptionPriceCurrency: string | null;
    accountManager: string | null;
    lastRosterUpload: string | null;
    rosterId: string | null;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    logo: string | null;
    giftPacks: string | null;
    customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    configuration: { authUserPoolId: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TRefreshCompanyEmployeeCountMutationVariables = Exact<{
  id: string;
}>;

export type TRefreshCompanyEmployeeCountMutation = { refreshCompanyEmployeeCount: { id: string; _version: number; employeeCount: number | null } | null };

export type TContactFieldsFragment = { name: string | null; email: string | null; phoneNumber: string | null };

export type TDependantFieldsFragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  firstName: string | null;
  fullName: string | null;
  lastName: string | null;
  birthDate: string | null;
  type: Types.TDependantType;
  petType: string | null;
  foodPreferences: string | null;
  donateBirthdayGift: boolean | null;
};

export type TDependantFieldsHydratedFragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  firstName: string | null;
  fullName: string | null;
  lastName: string | null;
  birthDate: string | null;
  type: Types.TDependantType;
  petType: string | null;
  foodPreferences: string | null;
  donateBirthdayGift: boolean | null;
  employee: {
    id: string;
    companyId: string;
    officeId: string | null;
    externalId: string | null;
    fullName: string | null;
    email: string | null;
    hireDate: string | null;
    birthDate: string | null;
    isPaused: boolean | null;
    createdAt: string | null;
    active: boolean | null;
    foodPreferences: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    company: { id: string; name: string; normalizedName: string | null } | null;
    office: { id: string; name: string } | null;
    address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
  } | null;
};

export type TListDependantsQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListDependantsQuery = {
  listDependants: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      firstName: string | null;
      fullName: string | null;
      lastName: string | null;
      birthDate: string | null;
      type: Types.TDependantType;
      petType: string | null;
      foodPreferences: string | null;
      donateBirthdayGift: boolean | null;
    } | null>;
  };
};

export type TListEmployeeDependantsQueryVariables = Exact<{
  companyId: string;
  employeeId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListEmployeeDependantsQuery = {
  listEmployeeDependants: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      firstName: string | null;
      fullName: string | null;
      lastName: string | null;
      birthDate: string | null;
      type: Types.TDependantType;
      petType: string | null;
      foodPreferences: string | null;
      donateBirthdayGift: boolean | null;
    } | null>;
  };
};

export type TOnAnyDependantChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyDependantChangedSubscription = {
  onAnyDependantChanged: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    firstName: string | null;
    fullName: string | null;
    lastName: string | null;
    birthDate: string | null;
    type: Types.TDependantType;
    petType: string | null;
    foodPreferences: string | null;
    donateBirthdayGift: boolean | null;
  } | null;
};

export type TEmployeeFieldsFragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  createdAt: string | null;
  updatedAt: string | null;
  active: boolean | null;
  externalId: string | null;
  companyId: string;
  officeId: string | null;
  firstName: string | null;
  lastName: string | null;
  preferredFirstName: string | null;
  fullName: string | null;
  hireDate: string | null;
  birthDate: string | null;
  email: string | null;
  phoneNumber: Array<string | null> | null;
  foodPreferences: string | null;
  customOnboardBrick: string | null;
  title: string | null;
  organization: string | null;
  tShirtSize: string | null;
  sweaterSize: string | null;
  donateBirthdayGift: boolean | null;
  donateWorkAnniversaryGift: boolean | null;
  isPaused: boolean | null;
  office: { id: string; name: string } | null;
  pausePeriod: { fromDate: string; toDate: string | null } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TEmployeeFieldsHydratedFragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  createdAt: string | null;
  updatedAt: string | null;
  active: boolean | null;
  externalId: string | null;
  companyId: string;
  officeId: string | null;
  firstName: string | null;
  lastName: string | null;
  preferredFirstName: string | null;
  fullName: string | null;
  hireDate: string | null;
  birthDate: string | null;
  email: string | null;
  phoneNumber: Array<string | null> | null;
  foodPreferences: string | null;
  customOnboardBrick: string | null;
  title: string | null;
  organization: string | null;
  tShirtSize: string | null;
  sweaterSize: string | null;
  donateBirthdayGift: boolean | null;
  donateWorkAnniversaryGift: boolean | null;
  isPaused: boolean | null;
  dependants: {
    items: Array<{
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      firstName: string | null;
      fullName: string | null;
      lastName: string | null;
      birthDate: string | null;
      type: Types.TDependantType;
      petType: string | null;
      foodPreferences: string | null;
      donateBirthdayGift: boolean | null;
    } | null>;
  };
  office: { id: string; name: string } | null;
  pausePeriod: { fromDate: string; toDate: string | null } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TGetEmployeeQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetEmployeeQuery = {
  getEmployee: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    active: boolean | null;
    externalId: string | null;
    companyId: string;
    officeId: string | null;
    firstName: string | null;
    lastName: string | null;
    preferredFirstName: string | null;
    fullName: string | null;
    hireDate: string | null;
    birthDate: string | null;
    email: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    customOnboardBrick: string | null;
    title: string | null;
    organization: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    isPaused: boolean | null;
    dependants: {
      items: Array<{
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        firstName: string | null;
        fullName: string | null;
        lastName: string | null;
        birthDate: string | null;
        type: Types.TDependantType;
        petType: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
      } | null>;
    };
    office: { id: string; name: string } | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TOnAnyEmployeeChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyEmployeeChangedSubscription = {
  onAnyEmployeeChanged: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    active: boolean | null;
    externalId: string | null;
    companyId: string;
    officeId: string | null;
    firstName: string | null;
    lastName: string | null;
    preferredFirstName: string | null;
    fullName: string | null;
    hireDate: string | null;
    birthDate: string | null;
    email: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    customOnboardBrick: string | null;
    title: string | null;
    organization: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    isPaused: boolean | null;
    office: { id: string; name: string } | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TEmployeeNewFieldsFragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  createdAt: string | null;
  updatedAt: string | null;
  active: boolean | null;
  externalId: string | null;
  companyId: string;
  officeId: string | null;
  firstName: string | null;
  lastName: string | null;
  preferredFirstName: string | null;
  fullName: string | null;
  hireDate: string | null;
  birthDate: string | null;
  email: string | null;
  phoneNumber: Array<string | null> | null;
  foodPreferences: string | null;
  customOnboardBrick: string | null;
  title: string | null;
  organization: string | null;
  tShirtSize: string | null;
  sweaterSize: string | null;
  donateBirthdayGift: boolean | null;
  donateWorkAnniversaryGift: boolean | null;
  isPaused: boolean | null;
  company: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    active: boolean | null;
    isLive: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    name: string;
    fullyConfigured: boolean | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    startDate: string | null;
    endDate: string | null;
    subscriptionPricePerUser: number | null;
    subscriptionPriceCurrency: string | null;
    accountManager: string | null;
    lastRosterUpload: string | null;
    rosterId: string | null;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    logo: string | null;
    giftPacks: string | null;
    customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    configuration: { authUserPoolId: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  office: {
    id: string;
    name: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
  dependants: {
    items: Array<{
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      firstName: string | null;
      fullName: string | null;
      lastName: string | null;
      birthDate: string | null;
      type: Types.TDependantType;
      petType: string | null;
      foodPreferences: string | null;
      donateBirthdayGift: boolean | null;
    } | null>;
  };
  pausePeriod: { fromDate: string; toDate: string | null } | null;
};

export type TListAllEmployeesFieldsFragment = {
  id: string;
  companyId: string;
  officeId: string | null;
  externalId: string | null;
  fullName: string | null;
  email: string | null;
  hireDate: string | null;
  birthDate: string | null;
  isPaused: boolean | null;
  createdAt: string | null;
  active: boolean | null;
  foodPreferences: string | null;
  tShirtSize: string | null;
  sweaterSize: string | null;
  company: { id: string; name: string; normalizedName: string | null } | null;
  office: { id: string; name: string } | null;
  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  pausePeriod: { fromDate: string; toDate: string | null } | null;
};

export type TListAllEmployeesQueryVariables = Exact<{
  isScan?: boolean | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListAllEmployeesQuery = {
  listAllEmployees: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      officeId: string | null;
      externalId: string | null;
      fullName: string | null;
      email: string | null;
      hireDate: string | null;
      birthDate: string | null;
      isPaused: boolean | null;
      createdAt: string | null;
      active: boolean | null;
      foodPreferences: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      dependants: {
        items: Array<{
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          firstName: string | null;
          fullName: string | null;
          lastName: string | null;
          birthDate: string | null;
          type: Types.TDependantType;
          petType: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
        } | null>;
      };
      company: { id: string; name: string; normalizedName: string | null } | null;
      office: { id: string; name: string } | null;
      address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
    } | null>;
  };
};

export type TListOneEmployeeFieldsFragment = {
  id: string;
  companyId: string;
  officeId: string | null;
  externalId: string | null;
  fullName: string | null;
  email: string | null;
  hireDate: string | null;
  birthDate: string | null;
  isPaused: boolean | null;
  createdAt: string | null;
  active: boolean | null;
  firstName: string | null;
  lastName: string | null;
  preferredFirstName: string | null;
  phoneNumber: Array<string | null> | null;
  foodPreferences: string | null;
  tShirtSize: string | null;
  sweaterSize: string | null;
  donateBirthdayGift: boolean | null;
  donateWorkAnniversaryGift: boolean | null;
  company: { id: string; name: string } | null;
  office: { id: string; name: string } | null;
  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  pausePeriod: { fromDate: string; toDate: string | null } | null;
};

export type TListOneEmployeeQueryVariables = Exact<{
  id: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneEmployeeQuery = {
  listOneEmployee: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      officeId: string | null;
      externalId: string | null;
      fullName: string | null;
      email: string | null;
      hireDate: string | null;
      birthDate: string | null;
      isPaused: boolean | null;
      createdAt: string | null;
      active: boolean | null;
      firstName: string | null;
      lastName: string | null;
      preferredFirstName: string | null;
      phoneNumber: Array<string | null> | null;
      foodPreferences: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      donateBirthdayGift: boolean | null;
      donateWorkAnniversaryGift: boolean | null;
      company: { id: string; name: string } | null;
      office: { id: string; name: string } | null;
      address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
    } | null>;
  };
};

export type TListOneOfficeEmployeesFieldsFragment = {
  id: string;
  companyId: string;
  officeId: string | null;
  externalId: string | null;
  fullName: string | null;
  email: string | null;
  hireDate: string | null;
  birthDate: string | null;
  isPaused: boolean | null;
  createdAt: string | null;
  active: boolean | null;
  company: { id: string; name: string } | null;
  pausePeriod: { fromDate: string; toDate: string | null } | null;
};

export type TListOneOfficeEmployeesQueryVariables = Exact<{
  officeId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneOfficeEmployeesQuery = {
  listOneOfficeEmployees: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      officeId: string | null;
      externalId: string | null;
      fullName: string | null;
      email: string | null;
      hireDate: string | null;
      birthDate: string | null;
      isPaused: boolean | null;
      createdAt: string | null;
      active: boolean | null;
      company: { id: string; name: string } | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
    } | null>;
  };
};

export type TListOneCompanyEmployeesFieldsFragment = {
  id: string;
  companyId: string;
  externalId: string | null;
  firstName: string | null;
  lastName: string | null;
  preferredFirstName: string | null;
  fullName: string | null;
  company: { id: string; name: string } | null;
  dependants: {
    items: Array<{
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      firstName: string | null;
      fullName: string | null;
      lastName: string | null;
      birthDate: string | null;
      type: Types.TDependantType;
      petType: string | null;
      foodPreferences: string | null;
      donateBirthdayGift: boolean | null;
    } | null>;
  };
  pausePeriod: { fromDate: string; toDate: string | null } | null;
};

export type TListOneCompanyEmployeesQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneCompanyEmployeesQuery = {
  listOneCompanyEmployees: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      externalId: string | null;
      firstName: string | null;
      lastName: string | null;
      preferredFirstName: string | null;
      fullName: string | null;
      company: { id: string; name: string } | null;
      dependants: {
        items: Array<{
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          firstName: string | null;
          fullName: string | null;
          lastName: string | null;
          birthDate: string | null;
          type: Types.TDependantType;
          petType: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
        } | null>;
      };
      pausePeriod: { fromDate: string; toDate: string | null } | null;
    } | null>;
  };
};

export type TReferenceEventFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  _lastChangedAt: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  companyId: string;
  employeeId: string;
  recipientId: string;
  addressId: string | null;
  fullDate: string;
  date: string;
  type: Types.TReferenceEventTypes;
  company: { name: string } | null;
  employee: { fullName: string | null } | null;
  recipient:
    | {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        firstName: string | null;
        fullName: string | null;
        lastName: string | null;
        birthDate: string | null;
        type: Types.TDependantType;
        petType: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
        employee: {
          id: string;
          companyId: string;
          officeId: string | null;
          externalId: string | null;
          fullName: string | null;
          email: string | null;
          hireDate: string | null;
          birthDate: string | null;
          isPaused: boolean | null;
          createdAt: string | null;
          active: boolean | null;
          foodPreferences: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          company: { id: string; name: string; normalizedName: string | null } | null;
          office: { id: string; name: string } | null;
          address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
        } | null;
      }
    | {
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      }
    | null;
  address: { id: string; address1: string | null } | null;
};

export type TEventFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  recipientId: string;
  addressId: string | null;
  referenceEventId: string | null;
  giftId: string | null;
  eventDate: string;
  shippingDate: string | null;
  type: Types.TEventTypes;
  customType: string | null;
  notes: string | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  age: number | null;
  skippedAt: string | null;
  deliveredAt: string | null;
  groupedToEventId: string | null;
  isPaused: boolean | null;
  wasPaused: boolean | null;
};

export type TGetEventQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetEventQuery = {
  getEvent: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    referenceEventId: string | null;
    giftId: string | null;
    eventDate: string;
    shippingDate: string | null;
    type: Types.TEventTypes;
    customType: string | null;
    notes: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    age: number | null;
    skippedAt: string | null;
    deliveredAt: string | null;
    groupedToEventId: string | null;
    isPaused: boolean | null;
    wasPaused: boolean | null;
  } | null;
};

export type TListNotSkippedEventsWithoutGiftQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListNotSkippedEventsWithoutGiftQuery = {
  listNotSkippedEventsWithoutGift: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      referenceEventId: string | null;
      giftId: string | null;
      eventDate: string;
      shippingDate: string | null;
      type: Types.TEventTypes;
      customType: string | null;
      notes: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      age: number | null;
      skippedAt: string | null;
      deliveredAt: string | null;
      groupedToEventId: string | null;
      isPaused: boolean | null;
      wasPaused: boolean | null;
    } | null>;
  };
};

export type TListSkippedEventsQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListSkippedEventsQuery = {
  listSkippedEvents: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      referenceEventId: string | null;
      giftId: string | null;
      eventDate: string;
      shippingDate: string | null;
      type: Types.TEventTypes;
      customType: string | null;
      notes: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      age: number | null;
      skippedAt: string | null;
      deliveredAt: string | null;
      groupedToEventId: string | null;
      isPaused: boolean | null;
      wasPaused: boolean | null;
    } | null>;
  };
};

export type TListEmployeeReferenceEventsQueryVariables = Exact<{
  employeeId: string;
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListEmployeeReferenceEventsQuery = {
  listEmployeeReferenceEvents: {
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      createdAt: string | null;
      updatedAt: string | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      fullDate: string;
      date: string;
      type: Types.TReferenceEventTypes;
      company: { name: string } | null;
      employee: { fullName: string | null } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      address: { id: string; address1: string | null } | null;
    } | null>;
  };
};

export type TCreateEventMutationVariables = Exact<{
  input: Types.TCreateEventMutationInput;
}>;

export type TCreateEventMutation = {
  createEvent: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    referenceEventId: string | null;
    giftId: string | null;
    eventDate: string;
    shippingDate: string | null;
    type: Types.TEventTypes;
    customType: string | null;
    notes: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    age: number | null;
    skippedAt: string | null;
    deliveredAt: string | null;
    groupedToEventId: string | null;
    isPaused: boolean | null;
    wasPaused: boolean | null;
  } | null;
};

export type TDeleteEventMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TDeleteEventMutation = {
  deleteEvent: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    referenceEventId: string | null;
    giftId: string | null;
    eventDate: string;
    shippingDate: string | null;
    type: Types.TEventTypes;
    customType: string | null;
    notes: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    age: number | null;
    skippedAt: string | null;
    deliveredAt: string | null;
    groupedToEventId: string | null;
    isPaused: boolean | null;
    wasPaused: boolean | null;
  } | null;
};

export type TCreateReferenceEventMutationVariables = Exact<{
  input: Types.TCreateReferenceEventMutationInput;
}>;

export type TCreateReferenceEventMutation = {
  createReferenceEvent: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    createdAt: string | null;
    updatedAt: string | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    fullDate: string;
    date: string;
    type: Types.TReferenceEventTypes;
    company: { name: string } | null;
    employee: { fullName: string | null } | null;
    recipient:
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          firstName: string | null;
          fullName: string | null;
          lastName: string | null;
          birthDate: string | null;
          type: Types.TDependantType;
          petType: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          } | null;
        }
      | {
          id: string;
          companyId: string;
          officeId: string | null;
          externalId: string | null;
          fullName: string | null;
          email: string | null;
          hireDate: string | null;
          birthDate: string | null;
          isPaused: boolean | null;
          createdAt: string | null;
          active: boolean | null;
          foodPreferences: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          company: { id: string; name: string; normalizedName: string | null } | null;
          office: { id: string; name: string } | null;
          address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
        }
      | null;
    address: { id: string; address1: string | null } | null;
  } | null;
};

export type TSkipEventMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TSkipEventMutation = {
  skipEvent: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    referenceEventId: string | null;
    giftId: string | null;
    eventDate: string;
    shippingDate: string | null;
    type: Types.TEventTypes;
    customType: string | null;
    notes: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    age: number | null;
    skippedAt: string | null;
    deliveredAt: string | null;
    groupedToEventId: string | null;
    isPaused: boolean | null;
    wasPaused: boolean | null;
  } | null;
};

export type TUnskipEventMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TUnskipEventMutation = {
  unskipEvent: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    referenceEventId: string | null;
    giftId: string | null;
    eventDate: string;
    shippingDate: string | null;
    type: Types.TEventTypes;
    customType: string | null;
    notes: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    age: number | null;
    skippedAt: string | null;
    deliveredAt: string | null;
    groupedToEventId: string | null;
    isPaused: boolean | null;
    wasPaused: boolean | null;
  } | null;
};

export type TOnAnyEventChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyEventChangedSubscription = {
  onAnyEventChanged: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    referenceEventId: string | null;
    giftId: string | null;
    eventDate: string;
    shippingDate: string | null;
    type: Types.TEventTypes;
    customType: string | null;
    notes: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    age: number | null;
    skippedAt: string | null;
    deliveredAt: string | null;
    groupedToEventId: string | null;
    isPaused: boolean | null;
    wasPaused: boolean | null;
  } | null;
};

export type TCreateOneOffEventMutationVariables = Exact<{
  input: string;
}>;

export type TCreateOneOffEventMutation = { createOneOffEvent: { status: number; error: boolean; message: string; data: string | null } | null };

export type TEventNewFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  recipientId: string;
  addressId: string | null;
  referenceEventId: string | null;
  giftId: string | null;
  eventDate: string;
  shippingDate: string | null;
  type: Types.TEventTypes;
  customType: string | null;
  notes: string | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  age: number | null;
  skippedAt: string | null;
  deliveredAt: string | null;
  groupedToEventId: string | null;
  isPaused: boolean | null;
  wasPaused: boolean | null;
  company: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    active: boolean | null;
    isLive: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    name: string;
    fullyConfigured: boolean | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    startDate: string | null;
    endDate: string | null;
    subscriptionPricePerUser: number | null;
    subscriptionPriceCurrency: string | null;
    accountManager: string | null;
    lastRosterUpload: string | null;
    rosterId: string | null;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    logo: string | null;
    giftPacks: string | null;
    customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    configuration: { authUserPoolId: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  recipient:
    | {
        __typename: 'Dependant';
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        firstName: string | null;
        fullName: string | null;
        lastName: string | null;
        birthDate: string | null;
        type: Types.TDependantType;
        petType: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
        employee: {
          id: string;
          companyId: string;
          officeId: string | null;
          externalId: string | null;
          fullName: string | null;
          email: string | null;
          hireDate: string | null;
          birthDate: string | null;
          isPaused: boolean | null;
          createdAt: string | null;
          active: boolean | null;
          foodPreferences: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          company: { id: string; name: string; normalizedName: string | null } | null;
          office: { id: string; name: string } | null;
          address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
        } | null;
      }
    | {
        __typename: 'Employee';
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      }
    | null;
  employee: {
    id: string;
    companyId: string;
    officeId: string | null;
    externalId: string | null;
    fullName: string | null;
    email: string | null;
    hireDate: string | null;
    birthDate: string | null;
    isPaused: boolean | null;
    createdAt: string | null;
    active: boolean | null;
    foodPreferences: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    company: { id: string; name: string; normalizedName: string | null } | null;
    office: { id: string; name: string } | null;
    address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
  } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TListEventFieldsFragment = {
  id: string;
  companyId: string;
  _version: number;
  addressId: string | null;
  eventDate: string;
  type: Types.TEventTypes;
  customType: string | null;
  notes: string | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  shippingDate: string | null;
  skippedAt: string | null;
  wasPaused: boolean | null;
  company: { id: string; name: string; accountManager: string | null } | null;
  recipient: { id: string; fullName: string | null } | { id: string; fullName: string | null } | null;
  employee: { id: string; fullName: string | null; isPaused: boolean | null; office: { id: string; name: string } | null; pausePeriod: { fromDate: string; toDate: string | null; unpausedAt: string | null } | null } | null;
  address: {
    id: string;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TListEventsQueryVariables = Exact<{
  type: string;
  eventPage: string;
  nextToken?: string | null | undefined;
  includingLastDays?: number | null | undefined;
  includingNextDays?: number | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListEventsQuery = {
  listEvents: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      addressId: string | null;
      eventDate: string;
      type: Types.TEventTypes;
      customType: string | null;
      notes: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      shippingDate: string | null;
      skippedAt: string | null;
      wasPaused: boolean | null;
      company: { id: string; name: string; accountManager: string | null } | null;
      recipient: { id: string; fullName: string | null } | { id: string; fullName: string | null } | null;
      employee: { id: string; fullName: string | null; isPaused: boolean | null; office: { id: string; name: string } | null; pausePeriod: { fromDate: string; toDate: string | null; unpausedAt: string | null } | null } | null;
      address: {
        id: string;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null>;
  };
};

export type TListClientOneOffEventsQueryVariables = Exact<{
  eventPage: string;
  nextToken?: string | null | undefined;
  includingLastDays?: number | null | undefined;
  includingNextDays?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListClientOneOffEventsQuery = {
  listClientOneOffEvents: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      addressId: string | null;
      eventDate: string;
      type: Types.TEventTypes;
      customType: string | null;
      notes: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      shippingDate: string | null;
      skippedAt: string | null;
      wasPaused: boolean | null;
      company: { id: string; name: string; accountManager: string | null } | null;
      recipient: { id: string; fullName: string | null } | { id: string; fullName: string | null } | null;
      employee: { id: string; fullName: string | null; isPaused: boolean | null; office: { id: string; name: string } | null; pausePeriod: { fromDate: string; toDate: string | null; unpausedAt: string | null } | null } | null;
      address: {
        id: string;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null>;
  };
};

export type TListSkippedEventsNewQueryVariables = Exact<{
  eventPage: string;
  includingLastDays?: number | null | undefined;
  includingNextDays?: number | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListSkippedEventsNewQuery = {
  listSkippedEventsNew: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      addressId: string | null;
      eventDate: string;
      type: Types.TEventTypes;
      customType: string | null;
      notes: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      shippingDate: string | null;
      skippedAt: string | null;
      wasPaused: boolean | null;
      company: { id: string; name: string; accountManager: string | null } | null;
      recipient: { id: string; fullName: string | null } | { id: string; fullName: string | null } | null;
      employee: { id: string; fullName: string | null; isPaused: boolean | null; office: { id: string; name: string } | null; pausePeriod: { fromDate: string; toDate: string | null; unpausedAt: string | null } | null } | null;
      address: {
        id: string;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null>;
  };
};

export type TSearchEventsByRecipientQueryVariables = Exact<{
  companyId?: string | null | undefined;
  recipientName: string;
  eventPage?: string | null | undefined;
  type?: string | null | undefined;
  includingLastDays?: number | null | undefined;
  includingNextDays?: number | null | undefined;
}>;

export type TSearchEventsByRecipientQuery = {
  searchEventsByRecipient: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      addressId: string | null;
      eventDate: string;
      type: Types.TEventTypes;
      customType: string | null;
      notes: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      shippingDate: string | null;
      skippedAt: string | null;
      wasPaused: boolean | null;
      company: { id: string; name: string; accountManager: string | null } | null;
      recipient: { id: string; fullName: string | null } | { id: string; fullName: string | null } | null;
      employee: { id: string; fullName: string | null; isPaused: boolean | null; office: { id: string; name: string } | null; pausePeriod: { fromDate: string; toDate: string | null; unpausedAt: string | null } | null } | null;
      address: {
        id: string;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null>;
  };
};

export type TGiftPackageFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  createdAt: string | null;
  updatedAt: string | null;
  companyId: string | null;
  name: string;
  type: Types.TGiftPackageType;
  subType: string | null;
  isDefault: number | null;
  products: Array<string | null>;
  hydratedProducts: string | null;
  company: { id: string; name: string } | null;
};

export type TGetGiftPackageQueryVariables = Exact<{
  id: string;
}>;

export type TGetGiftPackageQuery = {
  getGiftPackage: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    companyId: string | null;
    name: string;
    type: Types.TGiftPackageType;
    subType: string | null;
    isDefault: number | null;
    products: Array<string | null>;
    hydratedProducts: string | null;
    company: { id: string; name: string } | null;
  } | null;
};

export type TCreateGiftPackageMutationVariables = Exact<{
  input: Types.TCreateGiftPackageMutationInput;
}>;

export type TCreateGiftPackageMutation = {
  createGiftPackage: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    companyId: string | null;
    name: string;
    type: Types.TGiftPackageType;
    subType: string | null;
    isDefault: number | null;
    products: Array<string | null>;
    hydratedProducts: string | null;
    company: { id: string; name: string } | null;
  } | null;
};

export type TUpdateGiftPackageMutationVariables = Exact<{
  id: string;
  version: number;
  input: Types.TUpdateGiftPackageMutationInput;
}>;

export type TUpdateGiftPackageMutation = {
  updateGiftPackage: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    companyId: string | null;
    name: string;
    type: Types.TGiftPackageType;
    subType: string | null;
    isDefault: number | null;
    products: Array<string | null>;
    hydratedProducts: string | null;
    company: { id: string; name: string } | null;
  } | null;
};

export type TDeleteGiftPackageMutationVariables = Exact<{
  id: string;
  version: number;
}>;

export type TDeleteGiftPackageMutation = {
  deleteGiftPackage: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    companyId: string | null;
    name: string;
    type: Types.TGiftPackageType;
    subType: string | null;
    isDefault: number | null;
    products: Array<string | null>;
    hydratedProducts: string | null;
    company: { id: string; name: string } | null;
  } | null;
};

export type TOnAnyGiftPackageChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyGiftPackageChangedSubscription = {
  onAnyGiftPackageChanged: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    companyId: string | null;
    name: string;
    type: Types.TGiftPackageType;
    subType: string | null;
    isDefault: number | null;
    products: Array<string | null>;
    hydratedProducts: string | null;
    company: { id: string; name: string } | null;
  } | null;
};

export type TListGiftPackagesQueryVariables = Exact<{
  isScan?: boolean | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListGiftPackagesQuery = {
  listGiftPackages: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      createdAt: string | null;
      updatedAt: string | null;
      companyId: string | null;
      name: string;
      type: Types.TGiftPackageType;
      subType: string | null;
      isDefault: number | null;
      products: Array<string | null>;
      hydratedProducts: string | null;
      company: { id: string; name: string } | null;
    } | null>;
  };
};

export type TListDefaultGiftPackagesQueryVariables = Exact<{
  filter?: Types.TFilterInput | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListDefaultGiftPackagesQuery = {
  listDefaultGiftPackages: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      createdAt: string | null;
      updatedAt: string | null;
      companyId: string | null;
      name: string;
      type: Types.TGiftPackageType;
      subType: string | null;
      isDefault: number | null;
      products: Array<string | null>;
      hydratedProducts: string | null;
      company: { id: string; name: string } | null;
    } | null>;
  };
};

export type TListOneGiftPackageQueryVariables = Exact<{
  id: string;
  filter?: Types.TFilterInput | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneGiftPackageQuery = {
  listOneGiftPackage: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      createdAt: string | null;
      updatedAt: string | null;
      companyId: string | null;
      name: string;
      type: Types.TGiftPackageType;
      subType: string | null;
      isDefault: number | null;
      products: Array<string | null>;
      hydratedProducts: string | null;
      company: { id: string; name: string } | null;
    } | null>;
  };
};

export type TListOneCompanyGiftPackagesQueryVariables = Exact<{
  companyId: string;
  filter?: Types.TFilterInput | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneCompanyGiftPackagesQuery = {
  listOneCompanyGiftPackages: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      createdAt: string | null;
      updatedAt: string | null;
      companyId: string | null;
      name: string;
      type: Types.TGiftPackageType;
      subType: string | null;
      isDefault: number | null;
      products: Array<string | null>;
      hydratedProducts: string | null;
      company: { id: string; name: string } | null;
    } | null>;
  };
};

export type TListOneTypeGiftPackagesQueryVariables = Exact<{
  type: string;
  filter?: Types.TFilterInput | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneTypeGiftPackagesQuery = {
  listOneTypeGiftPackages: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      createdAt: string | null;
      updatedAt: string | null;
      companyId: string | null;
      name: string;
      type: Types.TGiftPackageType;
      subType: string | null;
      isDefault: number | null;
      products: Array<string | null>;
      hydratedProducts: string | null;
      company: { id: string; name: string } | null;
    } | null>;
  };
};

export type TListOneSubTypeGiftPackagesQueryVariables = Exact<{
  subType: string;
  filter?: Types.TFilterInput | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneSubTypeGiftPackagesQuery = {
  listOneSubTypeGiftPackages: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      createdAt: string | null;
      updatedAt: string | null;
      companyId: string | null;
      name: string;
      type: Types.TGiftPackageType;
      subType: string | null;
      isDefault: number | null;
      products: Array<string | null>;
      hydratedProducts: string | null;
      company: { id: string; name: string } | null;
    } | null>;
  };
};

export type TGiftEventFieldsFragment = { age: number | null };

export type TBaseGiftFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  recipientId: string;
  addressId: string | null;
  eventId: string;
  shipmentId: string | null;
  status: Types.TGiftStatuses;
  type: Types.TGiftTypes;
  customType: string | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  eventDate: string;
  shippingDate: string | null;
  referenceEventDate: string | null;
  rack: string | null;
  notes: string | null;
  group: string | null;
  doneAt: string | null;
  isDone: number | null;
  recreatedFromId: string | null;
  recipientData: string | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
};

export type TGiftFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  recipientId: string;
  addressId: string | null;
  eventId: string;
  shipmentId: string | null;
  status: Types.TGiftStatuses;
  type: Types.TGiftTypes;
  customType: string | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  eventDate: string;
  shippingDate: string | null;
  referenceEventDate: string | null;
  rack: string | null;
  notes: string | null;
  group: string | null;
  doneAt: string | null;
  isDone: number | null;
  recreatedFromId: string | null;
  recipientData: string | null;
  event: { age: number | null } | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
};

export type TGiftFieldsHydratedFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  recipientId: string;
  addressId: string | null;
  eventId: string;
  shipmentId: string | null;
  status: Types.TGiftStatuses;
  type: Types.TGiftTypes;
  customType: string | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  eventDate: string;
  shippingDate: string | null;
  referenceEventDate: string | null;
  rack: string | null;
  notes: string | null;
  group: string | null;
  doneAt: string | null;
  isDone: number | null;
  recreatedFromId: string | null;
  recipientData: string | null;
  shipment: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  event: { age: number | null } | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
};

export type TListEmployeeAndDependatsGiftsQueryVariables = Exact<{
  employeeId: string;
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListEmployeeAndDependatsGiftsQuery = {
  listEmployeeAndDependatsGifts: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      shipment: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        addressId: string;
        oldAddressId: string | null;
        addressVerified: Types.TShipStationAddressVerified | null;
        useGoogleAddress: boolean | null;
        status: Types.TShipmentStatuses;
        giftPacks: string | null;
        rack: string | null;
        notes: string | null;
        actualShippingDate: string | null;
        shippingDate: string | null;
        trackingNumber: string | null;
        trackingURL: string | null;
        shippedAt: string | null;
        setForPickupAt: string | null;
        pickedUpAt: string | null;
        isPrintedPhysically: boolean | null;
        isPrintedCUSMA: boolean | null;
        shipStationOrderId: number | null;
        shipStationShipmentId: number | null;
        lastShipStationResyncStartedAt: string | null;
        shipStationError: string | null;
        overrideCarrier: string | null;
        overrideService: string | null;
        alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
        packageInfo: { length: number; width: number; height: number; weight: number } | null;
        customsData: Array<{
          value: number;
          hsCode: string;
          quantity: number;
          description: string;
          country: string;
          originCriterion: string | null;
          sku: string | null;
          manufacturerNsProductId: string | null;
          manufacturerProductId: string | null;
          manufacturerProductIdType: Types.TManufacturerProductIdType | null;
        } | null> | null;
        label: {
          cost: number;
          createdAt: string | null;
          carrier: string;
          isThirdParty: boolean | null;
          labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
          addressData: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
        history: Array<{
          trackingNumber: string | null;
          trackingURL: string | null;
          label: {
            cost: number;
            createdAt: string | null;
            carrier: string;
            labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
            addressData: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  };
};

export type TListNotDoneGiftsQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListNotDoneGiftsQuery = {
  listNotDoneGifts: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  };
};

export type TListRecentlyDoneGiftsQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListRecentlyDoneGiftsQuery = {
  listRecentlyDoneGifts: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  };
};

export type TListShipmentGiftsQueryVariables = Exact<{
  shipmentId: string;
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListShipmentGiftsQuery = {
  listShipmentGifts: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  };
};

export type TGetGiftQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetGiftQuery = {
  getGift: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    eventId: string;
    shipmentId: string | null;
    status: Types.TGiftStatuses;
    type: Types.TGiftTypes;
    customType: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    eventDate: string;
    shippingDate: string | null;
    referenceEventDate: string | null;
    rack: string | null;
    notes: string | null;
    group: string | null;
    doneAt: string | null;
    isDone: number | null;
    recreatedFromId: string | null;
    recipientData: string | null;
    event: { age: number | null } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
  } | null;
};

export type TCreateEventGiftMutationVariables = Exact<{
  eventId: string;
  companyId: string;
  eventVersion: number;
  group?: string | null | undefined;
  shippingDate?: string | null | undefined;
  referenceEventDate?: string | null | undefined;
}>;

export type TCreateEventGiftMutation = {
  createEventGift: {
    companyId: string;
    event: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      referenceEventId: string | null;
      giftId: string | null;
      eventDate: string;
      shippingDate: string | null;
      type: Types.TEventTypes;
      customType: string | null;
      notes: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      age: number | null;
      skippedAt: string | null;
      deliveredAt: string | null;
      groupedToEventId: string | null;
      isPaused: boolean | null;
      wasPaused: boolean | null;
    } | null;
    gift: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null;
  } | null;
};

export type TMoveGiftMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
  input: Types.TMoveGiftMutationInput;
}>;

export type TMoveGiftMutation = {
  moveGift: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    eventId: string;
    shipmentId: string | null;
    status: Types.TGiftStatuses;
    type: Types.TGiftTypes;
    customType: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    eventDate: string;
    shippingDate: string | null;
    referenceEventDate: string | null;
    rack: string | null;
    notes: string | null;
    group: string | null;
    doneAt: string | null;
    isDone: number | null;
    recreatedFromId: string | null;
    recipientData: string | null;
    event: { age: number | null } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
  } | null;
};

export type TUpdateGiftMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
  input: Types.TUpdateGiftMutationInput;
}>;

export type TUpdateGiftMutation = {
  updateGift: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    eventId: string;
    shipmentId: string | null;
    status: Types.TGiftStatuses;
    type: Types.TGiftTypes;
    customType: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    eventDate: string;
    shippingDate: string | null;
    referenceEventDate: string | null;
    rack: string | null;
    notes: string | null;
    group: string | null;
    doneAt: string | null;
    isDone: number | null;
    recreatedFromId: string | null;
    recipientData: string | null;
    event: { age: number | null } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
  } | null;
};

export type TRemoveGiftFromGroupMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TRemoveGiftFromGroupMutation = {
  removeGiftFromGroup: {
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  } | null;
};

export type TDeleteGiftMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TDeleteGiftMutation = {
  deleteGift: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    eventId: string;
    shipmentId: string | null;
    status: Types.TGiftStatuses;
    type: Types.TGiftTypes;
    customType: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    eventDate: string;
    shippingDate: string | null;
    referenceEventDate: string | null;
    rack: string | null;
    notes: string | null;
    group: string | null;
    doneAt: string | null;
    isDone: number | null;
    recreatedFromId: string | null;
    recipientData: string | null;
    event: { age: number | null } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
  } | null;
};

export type TNotifyNewHiresMutationVariables = Exact<{
  events: Array<Types.TNotifyNewHireMutationInput | null | undefined> | Types.TNotifyNewHireMutationInput;
}>;

export type TNotifyNewHiresMutation = { notifyNewHires: boolean | null };

export type TOnAnyEventGiftCreatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyEventGiftCreatedSubscription = {
  onAnyEventGiftCreated: {
    event: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      referenceEventId: string | null;
      giftId: string | null;
      eventDate: string;
      shippingDate: string | null;
      type: Types.TEventTypes;
      customType: string | null;
      notes: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      age: number | null;
      skippedAt: string | null;
      deliveredAt: string | null;
      groupedToEventId: string | null;
      isPaused: boolean | null;
      wasPaused: boolean | null;
    } | null;
    gift: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null;
  } | null;
};

export type TOnAnyGiftRemovedFromGroupSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyGiftRemovedFromGroupSubscription = {
  onAnyGiftRemovedFromGroup: {
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  } | null;
};

export type TOnAnyGiftChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyGiftChangedSubscription = {
  onAnyGiftChanged: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    employeeId: string;
    recipientId: string;
    addressId: string | null;
    eventId: string;
    shipmentId: string | null;
    status: Types.TGiftStatuses;
    type: Types.TGiftTypes;
    customType: string | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    eventDate: string;
    shippingDate: string | null;
    referenceEventDate: string | null;
    rack: string | null;
    notes: string | null;
    group: string | null;
    doneAt: string | null;
    isDone: number | null;
    recreatedFromId: string | null;
    recipientData: string | null;
    event: { age: number | null } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
  } | null;
};

export type TGiftNewFieldsFragment = {
  groupedGifts: string | null;
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  recipientId: string;
  addressId: string | null;
  eventId: string;
  shipmentId: string | null;
  status: Types.TGiftStatuses;
  type: Types.TGiftTypes;
  customType: string | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  eventDate: string;
  shippingDate: string | null;
  referenceEventDate: string | null;
  rack: string | null;
  notes: string | null;
  group: string | null;
  doneAt: string | null;
  isDone: number | null;
  recreatedFromId: string | null;
  recipientData: string | null;
  event: { age: number | null } | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
};

export type TGiftNewFieldsWithShipmentFragment = {
  groupedGifts: string | null;
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  recipientId: string;
  addressId: string | null;
  eventId: string;
  shipmentId: string | null;
  status: Types.TGiftStatuses;
  type: Types.TGiftTypes;
  customType: string | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  eventDate: string;
  shippingDate: string | null;
  referenceEventDate: string | null;
  rack: string | null;
  notes: string | null;
  group: string | null;
  doneAt: string | null;
  isDone: number | null;
  recreatedFromId: string | null;
  recipientData: string | null;
  shipment: {
    addressTypeIcon: string | null;
    readableAddressType: string | null;
    recipientName: string | null;
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    gifts: {
      items: Array<{
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        recipientId: string;
        addressId: string | null;
        eventId: string;
        shipmentId: string | null;
        status: Types.TGiftStatuses;
        type: Types.TGiftTypes;
        customType: string | null;
        oneOffSource: string | null;
        brickQuantity: number | null;
        brickSize: string | null;
        brickColor: string | null;
        brickText: string | null;
        eventDate: string;
        shippingDate: string | null;
        referenceEventDate: string | null;
        rack: string | null;
        notes: string | null;
        group: string | null;
        doneAt: string | null;
        isDone: number | null;
        recreatedFromId: string | null;
        recipientData: string | null;
        recipient:
          | {
              __typename: 'Dependant';
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              companyId: string;
              employeeId: string;
              firstName: string | null;
              fullName: string | null;
              lastName: string | null;
              birthDate: string | null;
              type: Types.TDependantType;
              petType: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              } | null;
            }
          | {
              __typename: 'Employee';
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            }
          | null;
        alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      } | null>;
    } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  event: { age: number | null } | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
};

export type TGiftNewFieldsAndHydrationFragment = {
  groupedGifts: string | null;
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  recipientId: string;
  addressId: string | null;
  eventId: string;
  shipmentId: string | null;
  status: Types.TGiftStatuses;
  type: Types.TGiftTypes;
  customType: string | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  eventDate: string;
  shippingDate: string | null;
  referenceEventDate: string | null;
  rack: string | null;
  notes: string | null;
  group: string | null;
  doneAt: string | null;
  isDone: number | null;
  recreatedFromId: string | null;
  recipientData: string | null;
  company: {
    id: string;
    name: string;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    accountManager: string | null;
  } | null;
  recipient:
    | {
        __typename: 'Dependant';
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        firstName: string | null;
        fullName: string | null;
        lastName: string | null;
        birthDate: string | null;
        type: Types.TDependantType;
        petType: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
        employee: {
          id: string;
          companyId: string;
          officeId: string | null;
          externalId: string | null;
          fullName: string | null;
          email: string | null;
          hireDate: string | null;
          birthDate: string | null;
          isPaused: boolean | null;
          createdAt: string | null;
          active: boolean | null;
          foodPreferences: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          company: { id: string; name: string; normalizedName: string | null } | null;
          office: { id: string; name: string } | null;
          address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
        } | null;
      }
    | {
        __typename: 'Employee';
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      }
    | null;
  employee: {
    id: string;
    companyId: string;
    officeId: string | null;
    externalId: string | null;
    fullName: string | null;
    email: string | null;
    hireDate: string | null;
    birthDate: string | null;
    isPaused: boolean | null;
    createdAt: string | null;
    active: boolean | null;
    foodPreferences: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    company: { id: string; name: string; normalizedName: string | null } | null;
    office: { id: string; name: string } | null;
    address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
  } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
  event: { age: number | null } | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
};

export type TListGiftsAssemblingQueryVariables = Exact<{
  type?: string | null | undefined;
  isDone?: number | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListGiftsAssemblingQuery = {
  listGiftsAssembling: {
    nextToken: string | null;
    items: Array<{
      groupedGifts: string | null;
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      company: {
        id: string;
        name: string;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        customWorkAnniversaryNotes: string | null;
        hasCustomOnboardBrick: boolean | null;
        tissueColor: string;
        legoColor: string | null;
        signAs: string | null;
        specialNote: string | null;
        swag: string | null;
        accountManager: string | null;
      } | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      employee: {
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  };
};

export type TListOneGiftQueryVariables = Exact<{
  id: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneGiftQuery = {
  listOneGift: {
    nextToken: string | null;
    items: Array<{
      groupedGifts: string | null;
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      company: {
        id: string;
        name: string;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        customWorkAnniversaryNotes: string | null;
        hasCustomOnboardBrick: boolean | null;
        tissueColor: string;
        legoColor: string | null;
        signAs: string | null;
        specialNote: string | null;
        swag: string | null;
        accountManager: string | null;
      } | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      employee: {
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  };
};

export type TListOneShipmentGiftsQueryVariables = Exact<{
  shipmentId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneShipmentGiftsQuery = {
  listOneShipmentGifts: {
    nextToken: string | null;
    items: Array<{
      groupedGifts: string | null;
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      company: {
        id: string;
        name: string;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        customWorkAnniversaryNotes: string | null;
        hasCustomOnboardBrick: boolean | null;
        tissueColor: string;
        legoColor: string | null;
        signAs: string | null;
        specialNote: string | null;
        swag: string | null;
        accountManager: string | null;
      } | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      employee: {
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      event: { age: number | null } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  };
};

export type TLogFieldsFragment = {
  id: string;
  occurredAt: string | null;
  arguments: string | null;
  companyId: string | null;
  fieldName: string | null;
  identity: string | null;
  parentTypeName: string | null;
  resourceId: string | null;
  response: string | null;
  selectionSetGraphQL: string | null;
  type: string | null;
  userId: string | null;
  userType: Types.TLogUserTypes | null;
  variables: string | null;
  action: string | null;
  entity: string | null;
  identityUserName: string | null;
  identityUserEmail: string | null;
  company: { id: string; name: string } | null;
  employee: { id: string; firstName: string | null; preferredFirstName: string | null; lastName: string | null; fullName: string | null } | null;
};

export type TListAllLogsQueryVariables = Exact<{
  userType: string;
  occurredAt?: string | null | undefined;
  userPoolId?: string | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListAllLogsQuery = {
  listAllLogs: {
    nextToken: string | null;
    items: Array<{
      id: string;
      occurredAt: string | null;
      arguments: string | null;
      companyId: string | null;
      fieldName: string | null;
      identity: string | null;
      parentTypeName: string | null;
      resourceId: string | null;
      response: string | null;
      selectionSetGraphQL: string | null;
      type: string | null;
      userId: string | null;
      userType: Types.TLogUserTypes | null;
      variables: string | null;
      action: string | null;
      entity: string | null;
      identityUserName: string | null;
      identityUserEmail: string | null;
      company: { id: string; name: string } | null;
      employee: { id: string; firstName: string | null; preferredFirstName: string | null; lastName: string | null; fullName: string | null } | null;
    } | null>;
  };
};

export type TOfficeFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  name: string;
  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TGetOfficeQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetOfficeQuery = {
  getOffice: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    name: string;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TListAllOfficesQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListAllOfficesQuery = {
  listAllOffices: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      name: string;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null>;
  };
};

export type TListCompanyOfficesQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListCompanyOfficesQuery = {
  listOffices: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      name: string;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null>;
  };
};

export type TOnAnyOfficeChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyOfficeChangedSubscription = {
  onAnyOfficeChanged: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    name: string;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TProductFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  createdAt: string | null;
  updatedAt: string | null;
  value: number;
  hsCode: string;
  quantity: number;
  description: string;
  country: string;
  originCriterion: string | null;
  sku: string | null;
  manufacturerNsProductId: string | null;
  manufacturerProductId: string | null;
  manufacturerProductIdType: Types.TManufacturerProductIdType | null;
};

export type TListProductsQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListProductsQuery = {
  listProducts: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      createdAt: string | null;
      updatedAt: string | null;
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null>;
  };
};

export type TGetProductQueryVariables = Exact<{
  id: string;
}>;

export type TGetProductQuery = {
  getProduct: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    value: number;
    hsCode: string;
    quantity: number;
    description: string;
    country: string;
    originCriterion: string | null;
    sku: string | null;
    manufacturerNsProductId: string | null;
    manufacturerProductId: string | null;
    manufacturerProductIdType: Types.TManufacturerProductIdType | null;
  } | null;
};

export type TCreateProductMutationVariables = Exact<{
  input: Types.TCreateProductMutationInput;
}>;

export type TCreateProductMutation = {
  createProduct: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    value: number;
    hsCode: string;
    quantity: number;
    description: string;
    country: string;
    originCriterion: string | null;
    sku: string | null;
    manufacturerNsProductId: string | null;
    manufacturerProductId: string | null;
    manufacturerProductIdType: Types.TManufacturerProductIdType | null;
  } | null;
};

export type TUpdateProductMutationVariables = Exact<{
  id: string;
  version: number;
  input: Types.TUpdateProductMutationInput;
}>;

export type TUpdateProductMutation = {
  updateProduct: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    value: number;
    hsCode: string;
    quantity: number;
    description: string;
    country: string;
    originCriterion: string | null;
    sku: string | null;
    manufacturerNsProductId: string | null;
    manufacturerProductId: string | null;
    manufacturerProductIdType: Types.TManufacturerProductIdType | null;
  } | null;
};

export type TDeleteProductMutationVariables = Exact<{
  id: string;
  version: number;
}>;

export type TDeleteProductMutation = {
  deleteProduct: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    value: number;
    hsCode: string;
    quantity: number;
    description: string;
    country: string;
    originCriterion: string | null;
    sku: string | null;
    manufacturerNsProductId: string | null;
    manufacturerProductId: string | null;
    manufacturerProductIdType: Types.TManufacturerProductIdType | null;
  } | null;
};

export type TOnAnyProductChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyProductChangedSubscription = {
  onAnyProductChanged: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    value: number;
    hsCode: string;
    quantity: number;
    description: string;
    country: string;
    originCriterion: string | null;
    sku: string | null;
    manufacturerNsProductId: string | null;
    manufacturerProductId: string | null;
    manufacturerProductIdType: Types.TManufacturerProductIdType | null;
  } | null;
};

export type TRecipientFields_Dependant_Fragment = {
  __typename: 'Dependant';
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  companyId: string;
  employeeId: string;
  firstName: string | null;
  fullName: string | null;
  lastName: string | null;
  birthDate: string | null;
  type: Types.TDependantType;
  petType: string | null;
  foodPreferences: string | null;
  donateBirthdayGift: boolean | null;
  employee: {
    id: string;
    companyId: string;
    officeId: string | null;
    externalId: string | null;
    fullName: string | null;
    email: string | null;
    hireDate: string | null;
    birthDate: string | null;
    isPaused: boolean | null;
    createdAt: string | null;
    active: boolean | null;
    foodPreferences: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    company: { id: string; name: string; normalizedName: string | null } | null;
    office: { id: string; name: string } | null;
    address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
  } | null;
};

export type TRecipientFields_Employee_Fragment = {
  __typename: 'Employee';
  id: string;
  companyId: string;
  officeId: string | null;
  externalId: string | null;
  fullName: string | null;
  email: string | null;
  hireDate: string | null;
  birthDate: string | null;
  isPaused: boolean | null;
  createdAt: string | null;
  active: boolean | null;
  foodPreferences: string | null;
  tShirtSize: string | null;
  sweaterSize: string | null;
  company: { id: string; name: string; normalizedName: string | null } | null;
  office: { id: string; name: string } | null;
  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  pausePeriod: { fromDate: string; toDate: string | null } | null;
};

export type TRecipientFieldsFragment = TRecipientFields_Dependant_Fragment | TRecipientFields_Employee_Fragment;

export type TGetRecipientQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetRecipientQuery = {
  getRecipient:
    | {
        __typename: 'Dependant';
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        firstName: string | null;
        fullName: string | null;
        lastName: string | null;
        birthDate: string | null;
        type: Types.TDependantType;
        petType: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
        employee: {
          id: string;
          companyId: string;
          officeId: string | null;
          externalId: string | null;
          fullName: string | null;
          email: string | null;
          hireDate: string | null;
          birthDate: string | null;
          isPaused: boolean | null;
          createdAt: string | null;
          active: boolean | null;
          foodPreferences: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          company: { id: string; name: string; normalizedName: string | null } | null;
          office: { id: string; name: string } | null;
          address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
        } | null;
      }
    | {
        __typename: 'Employee';
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      }
    | null;
};

export type TFinancialReportQueryVariables = Exact<{
  month: string;
  companyId?: string | null | undefined;
}>;

export type TFinancialReportQuery = {
  financialReport: Array<{ companyId: string; companyName: string; previousYear: number; actual: number | null; forecast: number | null; gifts: number | null; shipmentCost: number | null; clientCost: number | null }>;
};

export type TEventsReportQueryVariables = Exact<{
  month: string;
  companyId?: string | null | undefined;
}>;

export type TEventsReportQuery = { eventsReport: Array<{ companyId: string; companyName: string; eventType: string; count: number }> };

export type TGiftsReportQueryVariables = Exact<{
  month: string;
  companyId?: string | null | undefined;
}>;

export type TGiftsReportQuery = {
  giftsReport: Array<{
    companyId: string;
    companyName: string;
    isTotal: boolean;
    newHire: number;
    workAnniversaryDeluxe: number;
    workAnniversaryMini: number;
    workAnniversaryBrickOnly: number;
    workAnniversaryCustom: number;
    workAnniversaryLegoOnly: number;
    employeeBirthday: number;
    dependantBirthday: number;
    babyGift: number;
    bereavement: number;
    wedding: number;
    replacementWorkAnniversary: number;
    replacementEmployeeBirthday: number;
    carePackage: number;
    customBricks: number;
    other: number;
    total: number;
  }>;
};

export type TShipmentsReportQueryVariables = Exact<{
  month: string;
  companyId?: string | null | undefined;
}>;

export type TShipmentsReportQuery = {
  shipmentsReport: Array<{
    status: string;
    companyId: string;
    companyName: string;
    giftCount: number;
    shipmentCost: number;
    clientCost: number;
    date: string;
    recipient: string;
    shipmentType: string;
    trackingNumber: string;
    carrier: string;
  }>;
};

export type TRosterFilesReportQueryVariables = Exact<{
  month: string;
  companyId?: string | null | undefined;
}>;

export type TRosterFilesReportQuery = {
  rosterFilesReport: Array<{
    companyId: string;
    companyName: string;
    createdAt: string;
    createdBy: string;
    mapping: string;
    changelog: string | null;
    importStartedAt: string | null;
    impoortEndedAt: string | null;
    importErrors: string | null;
    headerMapping: string | null;
    officeMapping: string | null;
    file: { key: string; region: string; bucket: string; version: string | null };
    changelogFile: { key: string; region: string; bucket: string; version: string | null } | null;
  }>;
};

export type TCustomReportQueryVariables = Exact<{
  input: Types.TCustomReportInput;
}>;

export type TCustomReportQuery = { customReport: Array<{ companyId: string; companyName: string; count: number }> };

export type TRosterFileFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  createdAt: string | null;
  updatedAt: string | null;
  companyId: string;
  headerMapping: string | null;
  mapping: string;
  officeMapping: string | null;
  changelog: string | null;
  importStartedAt: string | null;
  impoortEndedAt: string | null;
  importErrors: string | null;
  createdBy: { username: string | null; sub: string | null } | null;
  file: { bucket: string; region: string; key: string; version: string | null };
  changelogFile: { bucket: string; region: string; key: string; version: string | null } | null;
};

export type TListRosterFilesQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListRosterFilesQuery = {
  listRosterFiles: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      createdAt: string | null;
      updatedAt: string | null;
      companyId: string;
      headerMapping: string | null;
      mapping: string;
      officeMapping: string | null;
      changelog: string | null;
      importStartedAt: string | null;
      impoortEndedAt: string | null;
      importErrors: string | null;
      createdBy: { username: string | null; sub: string | null } | null;
      file: { bucket: string; region: string; key: string; version: string | null };
      changelogFile: { bucket: string; region: string; key: string; version: string | null } | null;
    } | null>;
  };
};

export type TListRosterFilesByCompanyIdQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListRosterFilesByCompanyIdQuery = {
  listRosterFilesByCompanyId: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      createdAt: string | null;
      updatedAt: string | null;
      companyId: string;
      headerMapping: string | null;
      mapping: string;
      officeMapping: string | null;
      changelog: string | null;
      importStartedAt: string | null;
      impoortEndedAt: string | null;
      importErrors: string | null;
      createdBy: { username: string | null; sub: string | null } | null;
      file: { bucket: string; region: string; key: string; version: string | null };
      changelogFile: { bucket: string; region: string; key: string; version: string | null } | null;
    } | null>;
  };
};

export type TCreateRosterFileMutationVariables = Exact<{
  input: Types.TCreateRosterFileInput;
}>;

export type TCreateRosterFileMutation = {
  createRosterFile: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    companyId: string;
    headerMapping: string | null;
    mapping: string;
    officeMapping: string | null;
    changelog: string | null;
    importStartedAt: string | null;
    impoortEndedAt: string | null;
    importErrors: string | null;
    createdBy: { username: string | null; sub: string | null } | null;
    file: { bucket: string; region: string; key: string; version: string | null };
    changelogFile: { bucket: string; region: string; key: string; version: string | null } | null;
  } | null;
};

export type TOnAnyRosterFileChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyRosterFileChangedSubscription = {
  onAnyRosterFileChanged: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    createdAt: string | null;
    updatedAt: string | null;
    companyId: string;
    headerMapping: string | null;
    mapping: string;
    officeMapping: string | null;
    changelog: string | null;
    importStartedAt: string | null;
    impoortEndedAt: string | null;
    importErrors: string | null;
    createdBy: { username: string | null; sub: string | null } | null;
    file: { bucket: string; region: string; key: string; version: string | null };
    changelogFile: { bucket: string; region: string; key: string; version: string | null } | null;
  } | null;
};

export type TShipmentFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  addressId: string;
  oldAddressId: string | null;
  addressVerified: Types.TShipStationAddressVerified | null;
  useGoogleAddress: boolean | null;
  status: Types.TShipmentStatuses;
  giftPacks: string | null;
  rack: string | null;
  notes: string | null;
  actualShippingDate: string | null;
  shippingDate: string | null;
  trackingNumber: string | null;
  trackingURL: string | null;
  shippedAt: string | null;
  setForPickupAt: string | null;
  pickedUpAt: string | null;
  isPrintedPhysically: boolean | null;
  isPrintedCUSMA: boolean | null;
  shipStationOrderId: number | null;
  shipStationShipmentId: number | null;
  lastShipStationResyncStartedAt: string | null;
  shipStationError: string | null;
  overrideCarrier: string | null;
  overrideService: string | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
  packageInfo: { length: number; width: number; height: number; weight: number } | null;
  customsData: Array<{
    value: number;
    hsCode: string;
    quantity: number;
    description: string;
    country: string;
    originCriterion: string | null;
    sku: string | null;
    manufacturerNsProductId: string | null;
    manufacturerProductId: string | null;
    manufacturerProductIdType: Types.TManufacturerProductIdType | null;
  } | null> | null;
  label: {
    cost: number;
    createdAt: string | null;
    carrier: string;
    isThirdParty: boolean | null;
    labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
    addressData: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  history: Array<{
    trackingNumber: string | null;
    trackingURL: string | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null> | null;
};

export type TShipmentFieldsHydratedFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  addressId: string;
  oldAddressId: string | null;
  addressVerified: Types.TShipStationAddressVerified | null;
  useGoogleAddress: boolean | null;
  status: Types.TShipmentStatuses;
  giftPacks: string | null;
  rack: string | null;
  notes: string | null;
  actualShippingDate: string | null;
  shippingDate: string | null;
  trackingNumber: string | null;
  trackingURL: string | null;
  shippedAt: string | null;
  setForPickupAt: string | null;
  pickedUpAt: string | null;
  isPrintedPhysically: boolean | null;
  isPrintedCUSMA: boolean | null;
  shipStationOrderId: number | null;
  shipStationShipmentId: number | null;
  lastShipStationResyncStartedAt: string | null;
  shipStationError: string | null;
  overrideCarrier: string | null;
  overrideService: string | null;
  gifts: {
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  } | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
  packageInfo: { length: number; width: number; height: number; weight: number } | null;
  customsData: Array<{
    value: number;
    hsCode: string;
    quantity: number;
    description: string;
    country: string;
    originCriterion: string | null;
    sku: string | null;
    manufacturerNsProductId: string | null;
    manufacturerProductId: string | null;
    manufacturerProductIdType: Types.TManufacturerProductIdType | null;
  } | null> | null;
  label: {
    cost: number;
    createdAt: string | null;
    carrier: string;
    isThirdParty: boolean | null;
    labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
    addressData: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  history: Array<{
    trackingNumber: string | null;
    trackingURL: string | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null> | null;
};

export type TListOpenShipmentsQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOpenShipmentsQuery = {
  listOpenShipments: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      addressId: string;
      oldAddressId: string | null;
      addressVerified: Types.TShipStationAddressVerified | null;
      useGoogleAddress: boolean | null;
      status: Types.TShipmentStatuses;
      giftPacks: string | null;
      rack: string | null;
      notes: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      trackingNumber: string | null;
      trackingURL: string | null;
      shippedAt: string | null;
      setForPickupAt: string | null;
      pickedUpAt: string | null;
      isPrintedPhysically: boolean | null;
      isPrintedCUSMA: boolean | null;
      shipStationOrderId: number | null;
      shipStationShipmentId: number | null;
      lastShipStationResyncStartedAt: string | null;
      shipStationError: string | null;
      overrideCarrier: string | null;
      overrideService: string | null;
      gifts: {
        items: Array<{
          id: string;
          _version: number;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          recipientId: string;
          addressId: string | null;
          eventId: string;
          shipmentId: string | null;
          status: Types.TGiftStatuses;
          type: Types.TGiftTypes;
          customType: string | null;
          oneOffSource: string | null;
          brickQuantity: number | null;
          brickSize: string | null;
          brickColor: string | null;
          brickText: string | null;
          eventDate: string;
          shippingDate: string | null;
          referenceEventDate: string | null;
          rack: string | null;
          notes: string | null;
          group: string | null;
          doneAt: string | null;
          isDone: number | null;
          recreatedFromId: string | null;
          recipientData: string | null;
          recipient:
            | {
                __typename: 'Dependant';
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                companyId: string;
                employeeId: string;
                firstName: string | null;
                fullName: string | null;
                lastName: string | null;
                birthDate: string | null;
                type: Types.TDependantType;
                petType: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  companyId: string;
                  officeId: string | null;
                  externalId: string | null;
                  fullName: string | null;
                  email: string | null;
                  hireDate: string | null;
                  birthDate: string | null;
                  isPaused: boolean | null;
                  createdAt: string | null;
                  active: boolean | null;
                  foodPreferences: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  company: { id: string; name: string; normalizedName: string | null } | null;
                  office: { id: string; name: string } | null;
                  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                } | null;
              }
            | {
                __typename: 'Employee';
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              }
            | null;
          alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
        } | null>;
      } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      packageInfo: { length: number; width: number; height: number; weight: number } | null;
      customsData: Array<{
        value: number;
        hsCode: string;
        quantity: number;
        description: string;
        country: string;
        originCriterion: string | null;
        sku: string | null;
        manufacturerNsProductId: string | null;
        manufacturerProductId: string | null;
        manufacturerProductIdType: Types.TManufacturerProductIdType | null;
      } | null> | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        isThirdParty: boolean | null;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      history: Array<{
        trackingNumber: string | null;
        trackingURL: string | null;
        label: {
          cost: number;
          createdAt: string | null;
          carrier: string;
          labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
          addressData: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null>;
  };
};

export type TListShippedShipmentsQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListShippedShipmentsQuery = {
  listShippedShipments: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      addressId: string;
      oldAddressId: string | null;
      addressVerified: Types.TShipStationAddressVerified | null;
      useGoogleAddress: boolean | null;
      status: Types.TShipmentStatuses;
      giftPacks: string | null;
      rack: string | null;
      notes: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      trackingNumber: string | null;
      trackingURL: string | null;
      shippedAt: string | null;
      setForPickupAt: string | null;
      pickedUpAt: string | null;
      isPrintedPhysically: boolean | null;
      isPrintedCUSMA: boolean | null;
      shipStationOrderId: number | null;
      shipStationShipmentId: number | null;
      lastShipStationResyncStartedAt: string | null;
      shipStationError: string | null;
      overrideCarrier: string | null;
      overrideService: string | null;
      gifts: {
        items: Array<{
          id: string;
          _version: number;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          recipientId: string;
          addressId: string | null;
          eventId: string;
          shipmentId: string | null;
          status: Types.TGiftStatuses;
          type: Types.TGiftTypes;
          customType: string | null;
          oneOffSource: string | null;
          brickQuantity: number | null;
          brickSize: string | null;
          brickColor: string | null;
          brickText: string | null;
          eventDate: string;
          shippingDate: string | null;
          referenceEventDate: string | null;
          rack: string | null;
          notes: string | null;
          group: string | null;
          doneAt: string | null;
          isDone: number | null;
          recreatedFromId: string | null;
          recipientData: string | null;
          recipient:
            | {
                __typename: 'Dependant';
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                companyId: string;
                employeeId: string;
                firstName: string | null;
                fullName: string | null;
                lastName: string | null;
                birthDate: string | null;
                type: Types.TDependantType;
                petType: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  companyId: string;
                  officeId: string | null;
                  externalId: string | null;
                  fullName: string | null;
                  email: string | null;
                  hireDate: string | null;
                  birthDate: string | null;
                  isPaused: boolean | null;
                  createdAt: string | null;
                  active: boolean | null;
                  foodPreferences: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  company: { id: string; name: string; normalizedName: string | null } | null;
                  office: { id: string; name: string } | null;
                  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                } | null;
              }
            | {
                __typename: 'Employee';
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              }
            | null;
          alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
        } | null>;
      } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      packageInfo: { length: number; width: number; height: number; weight: number } | null;
      customsData: Array<{
        value: number;
        hsCode: string;
        quantity: number;
        description: string;
        country: string;
        originCriterion: string | null;
        sku: string | null;
        manufacturerNsProductId: string | null;
        manufacturerProductId: string | null;
        manufacturerProductIdType: Types.TManufacturerProductIdType | null;
      } | null> | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        isThirdParty: boolean | null;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      history: Array<{
        trackingNumber: string | null;
        trackingURL: string | null;
        label: {
          cost: number;
          createdAt: string | null;
          carrier: string;
          labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
          addressData: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null>;
  } | null;
};

export type TListSetForPickupShipmentsQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListSetForPickupShipmentsQuery = {
  listSetForPickupShipments: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      addressId: string;
      oldAddressId: string | null;
      addressVerified: Types.TShipStationAddressVerified | null;
      useGoogleAddress: boolean | null;
      status: Types.TShipmentStatuses;
      giftPacks: string | null;
      rack: string | null;
      notes: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      trackingNumber: string | null;
      trackingURL: string | null;
      shippedAt: string | null;
      setForPickupAt: string | null;
      pickedUpAt: string | null;
      isPrintedPhysically: boolean | null;
      isPrintedCUSMA: boolean | null;
      shipStationOrderId: number | null;
      shipStationShipmentId: number | null;
      lastShipStationResyncStartedAt: string | null;
      shipStationError: string | null;
      overrideCarrier: string | null;
      overrideService: string | null;
      gifts: {
        items: Array<{
          id: string;
          _version: number;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          recipientId: string;
          addressId: string | null;
          eventId: string;
          shipmentId: string | null;
          status: Types.TGiftStatuses;
          type: Types.TGiftTypes;
          customType: string | null;
          oneOffSource: string | null;
          brickQuantity: number | null;
          brickSize: string | null;
          brickColor: string | null;
          brickText: string | null;
          eventDate: string;
          shippingDate: string | null;
          referenceEventDate: string | null;
          rack: string | null;
          notes: string | null;
          group: string | null;
          doneAt: string | null;
          isDone: number | null;
          recreatedFromId: string | null;
          recipientData: string | null;
          recipient:
            | {
                __typename: 'Dependant';
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                companyId: string;
                employeeId: string;
                firstName: string | null;
                fullName: string | null;
                lastName: string | null;
                birthDate: string | null;
                type: Types.TDependantType;
                petType: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  companyId: string;
                  officeId: string | null;
                  externalId: string | null;
                  fullName: string | null;
                  email: string | null;
                  hireDate: string | null;
                  birthDate: string | null;
                  isPaused: boolean | null;
                  createdAt: string | null;
                  active: boolean | null;
                  foodPreferences: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  company: { id: string; name: string; normalizedName: string | null } | null;
                  office: { id: string; name: string } | null;
                  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                } | null;
              }
            | {
                __typename: 'Employee';
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              }
            | null;
          alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
        } | null>;
      } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      packageInfo: { length: number; width: number; height: number; weight: number } | null;
      customsData: Array<{
        value: number;
        hsCode: string;
        quantity: number;
        description: string;
        country: string;
        originCriterion: string | null;
        sku: string | null;
        manufacturerNsProductId: string | null;
        manufacturerProductId: string | null;
        manufacturerProductIdType: Types.TManufacturerProductIdType | null;
      } | null> | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        isThirdParty: boolean | null;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      history: Array<{
        trackingNumber: string | null;
        trackingURL: string | null;
        label: {
          cost: number;
          createdAt: string | null;
          carrier: string;
          labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
          addressData: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null>;
  } | null;
};

export type TListShipmentsByAddressAndStatusQueryVariables = Exact<{
  addressId: string;
  status: Types.TShipmentStatuses;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListShipmentsByAddressAndStatusQuery = {
  listShipmentsByAddressAndStatus: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      addressId: string;
      oldAddressId: string | null;
      addressVerified: Types.TShipStationAddressVerified | null;
      useGoogleAddress: boolean | null;
      status: Types.TShipmentStatuses;
      giftPacks: string | null;
      rack: string | null;
      notes: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      trackingNumber: string | null;
      trackingURL: string | null;
      shippedAt: string | null;
      setForPickupAt: string | null;
      pickedUpAt: string | null;
      isPrintedPhysically: boolean | null;
      isPrintedCUSMA: boolean | null;
      shipStationOrderId: number | null;
      shipStationShipmentId: number | null;
      lastShipStationResyncStartedAt: string | null;
      shipStationError: string | null;
      overrideCarrier: string | null;
      overrideService: string | null;
      gifts: {
        items: Array<{
          id: string;
          _version: number;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          recipientId: string;
          addressId: string | null;
          eventId: string;
          shipmentId: string | null;
          status: Types.TGiftStatuses;
          type: Types.TGiftTypes;
          customType: string | null;
          oneOffSource: string | null;
          brickQuantity: number | null;
          brickSize: string | null;
          brickColor: string | null;
          brickText: string | null;
          eventDate: string;
          shippingDate: string | null;
          referenceEventDate: string | null;
          rack: string | null;
          notes: string | null;
          group: string | null;
          doneAt: string | null;
          isDone: number | null;
          recreatedFromId: string | null;
          recipientData: string | null;
          recipient:
            | {
                __typename: 'Dependant';
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                companyId: string;
                employeeId: string;
                firstName: string | null;
                fullName: string | null;
                lastName: string | null;
                birthDate: string | null;
                type: Types.TDependantType;
                petType: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  companyId: string;
                  officeId: string | null;
                  externalId: string | null;
                  fullName: string | null;
                  email: string | null;
                  hireDate: string | null;
                  birthDate: string | null;
                  isPaused: boolean | null;
                  createdAt: string | null;
                  active: boolean | null;
                  foodPreferences: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  company: { id: string; name: string; normalizedName: string | null } | null;
                  office: { id: string; name: string } | null;
                  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                } | null;
              }
            | {
                __typename: 'Employee';
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              }
            | null;
          alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
        } | null>;
      } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      packageInfo: { length: number; width: number; height: number; weight: number } | null;
      customsData: Array<{
        value: number;
        hsCode: string;
        quantity: number;
        description: string;
        country: string;
        originCriterion: string | null;
        sku: string | null;
        manufacturerNsProductId: string | null;
        manufacturerProductId: string | null;
        manufacturerProductIdType: Types.TManufacturerProductIdType | null;
      } | null> | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        isThirdParty: boolean | null;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      history: Array<{
        trackingNumber: string | null;
        trackingURL: string | null;
        label: {
          cost: number;
          createdAt: string | null;
          carrier: string;
          labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
          addressData: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null>;
  };
};

export type TGetShipmentQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetShipmentQuery = {
  getShipment: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    gifts: {
      items: Array<{
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        recipientId: string;
        addressId: string | null;
        eventId: string;
        shipmentId: string | null;
        status: Types.TGiftStatuses;
        type: Types.TGiftTypes;
        customType: string | null;
        oneOffSource: string | null;
        brickQuantity: number | null;
        brickSize: string | null;
        brickColor: string | null;
        brickText: string | null;
        eventDate: string;
        shippingDate: string | null;
        referenceEventDate: string | null;
        rack: string | null;
        notes: string | null;
        group: string | null;
        doneAt: string | null;
        isDone: number | null;
        recreatedFromId: string | null;
        recipientData: string | null;
        recipient:
          | {
              __typename: 'Dependant';
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              companyId: string;
              employeeId: string;
              firstName: string | null;
              fullName: string | null;
              lastName: string | null;
              birthDate: string | null;
              type: Types.TDependantType;
              petType: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              } | null;
            }
          | {
              __typename: 'Employee';
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            }
          | null;
        alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      } | null>;
    } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TCreateShipmentWithGiftsMutationVariables = Exact<{
  input: Types.TCreateShipmentWithGiftsMutationInput;
}>;

export type TCreateShipmentWithGiftsMutation = {
  createShipmentWithGifts: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    gifts: {
      items: Array<{
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        recipientId: string;
        addressId: string | null;
        eventId: string;
        shipmentId: string | null;
        status: Types.TGiftStatuses;
        type: Types.TGiftTypes;
        customType: string | null;
        oneOffSource: string | null;
        brickQuantity: number | null;
        brickSize: string | null;
        brickColor: string | null;
        brickText: string | null;
        eventDate: string;
        shippingDate: string | null;
        referenceEventDate: string | null;
        rack: string | null;
        notes: string | null;
        group: string | null;
        doneAt: string | null;
        isDone: number | null;
        recreatedFromId: string | null;
        recipientData: string | null;
        recipient:
          | {
              __typename: 'Dependant';
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              companyId: string;
              employeeId: string;
              firstName: string | null;
              fullName: string | null;
              lastName: string | null;
              birthDate: string | null;
              type: Types.TDependantType;
              petType: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              } | null;
            }
          | {
              __typename: 'Employee';
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            }
          | null;
        alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      } | null>;
    } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TAddGiftsToShipmentMutationVariables = Exact<{
  shipmentId: string;
  companyId: string;
  giftsIds: Array<string> | string;
}>;

export type TAddGiftsToShipmentMutation = {
  addGiftsToShipment: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    gifts: {
      items: Array<{
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        recipientId: string;
        addressId: string | null;
        eventId: string;
        shipmentId: string | null;
        status: Types.TGiftStatuses;
        type: Types.TGiftTypes;
        customType: string | null;
        oneOffSource: string | null;
        brickQuantity: number | null;
        brickSize: string | null;
        brickColor: string | null;
        brickText: string | null;
        eventDate: string;
        shippingDate: string | null;
        referenceEventDate: string | null;
        rack: string | null;
        notes: string | null;
        group: string | null;
        doneAt: string | null;
        isDone: number | null;
        recreatedFromId: string | null;
        recipientData: string | null;
        recipient:
          | {
              __typename: 'Dependant';
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              companyId: string;
              employeeId: string;
              firstName: string | null;
              fullName: string | null;
              lastName: string | null;
              birthDate: string | null;
              type: Types.TDependantType;
              petType: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              } | null;
            }
          | {
              __typename: 'Employee';
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            }
          | null;
        alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      } | null>;
    } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TUpdateShipmentMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
  input: Types.TUpdateShipmentMutationInput;
}>;

export type TUpdateShipmentMutation = {
  updateShipment: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TSetShipmentForPickupMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TSetShipmentForPickupMutation = {
  setShipmentForPickup: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TSetShipmentAsPickedUpMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TSetShipmentAsPickedUpMutation = {
  setShipmentAsPickedUp: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TCancelShipmentForPickupMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TCancelShipmentForPickupMutation = {
  cancelShipmentForPickup: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TSetShipmentAsReadyToShipMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
  input: Types.TSetShipmentAsReadyToShipMutationInput;
}>;

export type TSetShipmentAsReadyToShipMutation = {
  setShipmentAsReadyToShip: {
    addressTypeIcon: string | null;
    readableAddressType: string | null;
    recipientName: string | null;
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    company: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      active: boolean | null;
      isLive: boolean | null;
      deliveryMethod: Types.TDeliveryMethod;
      name: string;
      fullyConfigured: boolean | null;
      employeeBirthdayActivated: boolean;
      employeeWorkAnniversaryActivated: boolean;
      employeeNewHireKitActivated: boolean;
      significantOtherBirthdayActivated: boolean;
      childBirthdayActivated: boolean;
      petBirthdayActivated: boolean;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
      customWorkAnniversaryNotes: string | null;
      hasCustomOnboardBrick: boolean | null;
      tissueColor: string;
      legoColor: string | null;
      signAs: string | null;
      specialNote: string | null;
      swag: string | null;
      startDate: string | null;
      endDate: string | null;
      subscriptionPricePerUser: number | null;
      subscriptionPriceCurrency: string | null;
      accountManager: string | null;
      lastRosterUpload: string | null;
      rosterId: string | null;
      subdomain: string;
      emailDomains: Array<string>;
      googleLoginEnabled: boolean | null;
      logo: string | null;
      giftPacks: string | null;
      customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
      configuration: { authUserPoolId: string | null } | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    office: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      name: string;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    employee: {
      id: string;
      companyId: string;
      officeId: string | null;
      externalId: string | null;
      fullName: string | null;
      email: string | null;
      hireDate: string | null;
      birthDate: string | null;
      isPaused: boolean | null;
      createdAt: string | null;
      active: boolean | null;
      foodPreferences: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      company: { id: string; name: string; normalizedName: string | null } | null;
      office: { id: string; name: string } | null;
      address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
    } | null;
    recipient:
      | {
          __typename: 'Dependant';
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          firstName: string | null;
          fullName: string | null;
          lastName: string | null;
          birthDate: string | null;
          type: Types.TDependantType;
          petType: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          } | null;
        }
      | {
          __typename: 'Employee';
          id: string;
          companyId: string;
          officeId: string | null;
          externalId: string | null;
          fullName: string | null;
          email: string | null;
          hireDate: string | null;
          birthDate: string | null;
          isPaused: boolean | null;
          createdAt: string | null;
          active: boolean | null;
          foodPreferences: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          company: { id: string; name: string; normalizedName: string | null } | null;
          office: { id: string; name: string } | null;
          address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
        }
      | null;
    gifts: {
      items: Array<{
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        recipientId: string;
        addressId: string | null;
        eventId: string;
        shipmentId: string | null;
        status: Types.TGiftStatuses;
        type: Types.TGiftTypes;
        customType: string | null;
        oneOffSource: string | null;
        brickQuantity: number | null;
        brickSize: string | null;
        brickColor: string | null;
        brickText: string | null;
        eventDate: string;
        shippingDate: string | null;
        referenceEventDate: string | null;
        rack: string | null;
        notes: string | null;
        group: string | null;
        doneAt: string | null;
        isDone: number | null;
        recreatedFromId: string | null;
        recipientData: string | null;
        recipient:
          | {
              __typename: 'Dependant';
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              companyId: string;
              employeeId: string;
              firstName: string | null;
              fullName: string | null;
              lastName: string | null;
              birthDate: string | null;
              type: Types.TDependantType;
              petType: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              } | null;
            }
          | {
              __typename: 'Employee';
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            }
          | null;
        alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      } | null>;
    } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TPrintShipmentLabelMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
  input: Types.TPrintShipmentLabelMutationInput;
}>;

export type TPrintShipmentLabelMutation = {
  printShipmentLabel: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TSetShipmentAsShippedMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TSetShipmentAsShippedMutation = {
  setShipmentAsShipped: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    gifts: {
      items: Array<{
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        recipientId: string;
        addressId: string | null;
        eventId: string;
        shipmentId: string | null;
        status: Types.TGiftStatuses;
        type: Types.TGiftTypes;
        customType: string | null;
        oneOffSource: string | null;
        brickQuantity: number | null;
        brickSize: string | null;
        brickColor: string | null;
        brickText: string | null;
        eventDate: string;
        shippingDate: string | null;
        referenceEventDate: string | null;
        rack: string | null;
        notes: string | null;
        group: string | null;
        doneAt: string | null;
        isDone: number | null;
        recreatedFromId: string | null;
        recipientData: string | null;
        recipient:
          | {
              __typename: 'Dependant';
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              companyId: string;
              employeeId: string;
              firstName: string | null;
              fullName: string | null;
              lastName: string | null;
              birthDate: string | null;
              type: Types.TDependantType;
              petType: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              } | null;
            }
          | {
              __typename: 'Employee';
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            }
          | null;
        alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      } | null>;
    } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TDeleteShipmentMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TDeleteShipmentMutation = {
  deleteShipment: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TRecreateShipmentMutationVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TRecreateShipmentMutation = {
  recreateShipment: {
    companyId: string;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  } | null;
};

export type TReshipShipmentMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TReshipShipmentMutation = {
  reshipShipment: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TResyncShipmentWithShipStationMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TResyncShipmentWithShipStationMutation = {
  resyncShipmentWithShipStation: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TPrintLabelPhysicallyMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TPrintLabelPhysicallyMutation = {
  printLabelPhysically: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TPrintCusmaMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TPrintCusmaMutation = {
  printCUSMA: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TOnAnyShipmentChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyShipmentChangedSubscription = {
  onAnyShipmentChanged: {
    addressTypeIcon: string | null;
    readableAddressType: string | null;
    recipientName: string | null;
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    addressId: string;
    oldAddressId: string | null;
    addressVerified: Types.TShipStationAddressVerified | null;
    useGoogleAddress: boolean | null;
    status: Types.TShipmentStatuses;
    giftPacks: string | null;
    rack: string | null;
    notes: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    trackingNumber: string | null;
    trackingURL: string | null;
    shippedAt: string | null;
    setForPickupAt: string | null;
    pickedUpAt: string | null;
    isPrintedPhysically: boolean | null;
    isPrintedCUSMA: boolean | null;
    shipStationOrderId: number | null;
    shipStationShipmentId: number | null;
    lastShipStationResyncStartedAt: string | null;
    shipStationError: string | null;
    overrideCarrier: string | null;
    overrideService: string | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    company: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      active: boolean | null;
      isLive: boolean | null;
      deliveryMethod: Types.TDeliveryMethod;
      name: string;
      fullyConfigured: boolean | null;
      employeeBirthdayActivated: boolean;
      employeeWorkAnniversaryActivated: boolean;
      employeeNewHireKitActivated: boolean;
      significantOtherBirthdayActivated: boolean;
      childBirthdayActivated: boolean;
      petBirthdayActivated: boolean;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
      customWorkAnniversaryNotes: string | null;
      hasCustomOnboardBrick: boolean | null;
      tissueColor: string;
      legoColor: string | null;
      signAs: string | null;
      specialNote: string | null;
      swag: string | null;
      startDate: string | null;
      endDate: string | null;
      subscriptionPricePerUser: number | null;
      subscriptionPriceCurrency: string | null;
      accountManager: string | null;
      lastRosterUpload: string | null;
      rosterId: string | null;
      subdomain: string;
      emailDomains: Array<string>;
      googleLoginEnabled: boolean | null;
      logo: string | null;
      giftPacks: string | null;
      customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
      configuration: { authUserPoolId: string | null } | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    office: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      name: string;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    employee: {
      id: string;
      companyId: string;
      officeId: string | null;
      externalId: string | null;
      fullName: string | null;
      email: string | null;
      hireDate: string | null;
      birthDate: string | null;
      isPaused: boolean | null;
      createdAt: string | null;
      active: boolean | null;
      foodPreferences: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      company: { id: string; name: string; normalizedName: string | null } | null;
      office: { id: string; name: string } | null;
      address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
    } | null;
    recipient:
      | {
          __typename: 'Dependant';
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          firstName: string | null;
          fullName: string | null;
          lastName: string | null;
          birthDate: string | null;
          type: Types.TDependantType;
          petType: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          } | null;
        }
      | {
          __typename: 'Employee';
          id: string;
          companyId: string;
          officeId: string | null;
          externalId: string | null;
          fullName: string | null;
          email: string | null;
          hireDate: string | null;
          birthDate: string | null;
          isPaused: boolean | null;
          createdAt: string | null;
          active: boolean | null;
          foodPreferences: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          company: { id: string; name: string; normalizedName: string | null } | null;
          office: { id: string; name: string } | null;
          address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
        }
      | null;
    gifts: {
      items: Array<{
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        recipientId: string;
        addressId: string | null;
        eventId: string;
        shipmentId: string | null;
        status: Types.TGiftStatuses;
        type: Types.TGiftTypes;
        customType: string | null;
        oneOffSource: string | null;
        brickQuantity: number | null;
        brickSize: string | null;
        brickColor: string | null;
        brickText: string | null;
        eventDate: string;
        shippingDate: string | null;
        referenceEventDate: string | null;
        rack: string | null;
        notes: string | null;
        group: string | null;
        doneAt: string | null;
        isDone: number | null;
        recreatedFromId: string | null;
        recipientData: string | null;
        recipient:
          | {
              __typename: 'Dependant';
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              companyId: string;
              employeeId: string;
              firstName: string | null;
              fullName: string | null;
              lastName: string | null;
              birthDate: string | null;
              type: Types.TDependantType;
              petType: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              } | null;
            }
          | {
              __typename: 'Employee';
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            }
          | null;
        alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      } | null>;
    } | null;
    alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    packageInfo: { length: number; width: number; height: number; weight: number } | null;
    customsData: Array<{
      value: number;
      hsCode: string;
      quantity: number;
      description: string;
      country: string;
      originCriterion: string | null;
      sku: string | null;
      manufacturerNsProductId: string | null;
      manufacturerProductId: string | null;
      manufacturerProductIdType: Types.TManufacturerProductIdType | null;
    } | null> | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      isThirdParty: boolean | null;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    history: Array<{
      trackingNumber: string | null;
      trackingURL: string | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type TOnAnyShipmentRecreatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type TOnAnyShipmentRecreatedSubscription = {
  onAnyShipmentRecreated: {
    companyId: string;
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  } | null;
};

export type TShipmentNewFieldsFragment = {
  addressTypeIcon: string | null;
  readableAddressType: string | null;
  recipientName: string | null;
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  addressId: string;
  oldAddressId: string | null;
  addressVerified: Types.TShipStationAddressVerified | null;
  useGoogleAddress: boolean | null;
  status: Types.TShipmentStatuses;
  giftPacks: string | null;
  rack: string | null;
  notes: string | null;
  actualShippingDate: string | null;
  shippingDate: string | null;
  trackingNumber: string | null;
  trackingURL: string | null;
  shippedAt: string | null;
  setForPickupAt: string | null;
  pickedUpAt: string | null;
  isPrintedPhysically: boolean | null;
  isPrintedCUSMA: boolean | null;
  shipStationOrderId: number | null;
  shipStationShipmentId: number | null;
  lastShipStationResyncStartedAt: string | null;
  shipStationError: string | null;
  overrideCarrier: string | null;
  overrideService: string | null;
  gifts: {
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  } | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
  packageInfo: { length: number; width: number; height: number; weight: number } | null;
  customsData: Array<{
    value: number;
    hsCode: string;
    quantity: number;
    description: string;
    country: string;
    originCriterion: string | null;
    sku: string | null;
    manufacturerNsProductId: string | null;
    manufacturerProductId: string | null;
    manufacturerProductIdType: Types.TManufacturerProductIdType | null;
  } | null> | null;
  label: {
    cost: number;
    createdAt: string | null;
    carrier: string;
    isThirdParty: boolean | null;
    labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
    addressData: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  history: Array<{
    trackingNumber: string | null;
    trackingURL: string | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null> | null;
};

export type TShipmentNewFieldsAndHydrationFragment = {
  addressTypeIcon: string | null;
  readableAddressType: string | null;
  recipientName: string | null;
  id: string;
  _version: number;
  _deleted: boolean | null;
  companyId: string;
  addressId: string;
  oldAddressId: string | null;
  addressVerified: Types.TShipStationAddressVerified | null;
  useGoogleAddress: boolean | null;
  status: Types.TShipmentStatuses;
  giftPacks: string | null;
  rack: string | null;
  notes: string | null;
  actualShippingDate: string | null;
  shippingDate: string | null;
  trackingNumber: string | null;
  trackingURL: string | null;
  shippedAt: string | null;
  setForPickupAt: string | null;
  pickedUpAt: string | null;
  isPrintedPhysically: boolean | null;
  isPrintedCUSMA: boolean | null;
  shipStationOrderId: number | null;
  shipStationShipmentId: number | null;
  lastShipStationResyncStartedAt: string | null;
  shipStationError: string | null;
  overrideCarrier: string | null;
  overrideService: string | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
  company: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    active: boolean | null;
    isLive: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    name: string;
    fullyConfigured: boolean | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    customWorkAnniversaryNotes: string | null;
    hasCustomOnboardBrick: boolean | null;
    tissueColor: string;
    legoColor: string | null;
    signAs: string | null;
    specialNote: string | null;
    swag: string | null;
    startDate: string | null;
    endDate: string | null;
    subscriptionPricePerUser: number | null;
    subscriptionPriceCurrency: string | null;
    accountManager: string | null;
    lastRosterUpload: string | null;
    rosterId: string | null;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    logo: string | null;
    giftPacks: string | null;
    customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
    configuration: { authUserPoolId: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  office: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    companyId: string;
    name: string;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  employee: {
    id: string;
    companyId: string;
    officeId: string | null;
    externalId: string | null;
    fullName: string | null;
    email: string | null;
    hireDate: string | null;
    birthDate: string | null;
    isPaused: boolean | null;
    createdAt: string | null;
    active: boolean | null;
    foodPreferences: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    company: { id: string; name: string; normalizedName: string | null } | null;
    office: { id: string; name: string } | null;
    address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
  } | null;
  recipient:
    | {
        __typename: 'Dependant';
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        companyId: string;
        employeeId: string;
        firstName: string | null;
        fullName: string | null;
        lastName: string | null;
        birthDate: string | null;
        type: Types.TDependantType;
        petType: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
        employee: {
          id: string;
          companyId: string;
          officeId: string | null;
          externalId: string | null;
          fullName: string | null;
          email: string | null;
          hireDate: string | null;
          birthDate: string | null;
          isPaused: boolean | null;
          createdAt: string | null;
          active: boolean | null;
          foodPreferences: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          company: { id: string; name: string; normalizedName: string | null } | null;
          office: { id: string; name: string } | null;
          address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
        } | null;
      }
    | {
        __typename: 'Employee';
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      }
    | null;
  gifts: {
    items: Array<{
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      employeeId: string;
      recipientId: string;
      addressId: string | null;
      eventId: string;
      shipmentId: string | null;
      status: Types.TGiftStatuses;
      type: Types.TGiftTypes;
      customType: string | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      eventDate: string;
      shippingDate: string | null;
      referenceEventDate: string | null;
      rack: string | null;
      notes: string | null;
      group: string | null;
      doneAt: string | null;
      isDone: number | null;
      recreatedFromId: string | null;
      recipientData: string | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
    } | null>;
  } | null;
  alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
  packageInfo: { length: number; width: number; height: number; weight: number } | null;
  customsData: Array<{
    value: number;
    hsCode: string;
    quantity: number;
    description: string;
    country: string;
    originCriterion: string | null;
    sku: string | null;
    manufacturerNsProductId: string | null;
    manufacturerProductId: string | null;
    manufacturerProductIdType: Types.TManufacturerProductIdType | null;
  } | null> | null;
  label: {
    cost: number;
    createdAt: string | null;
    carrier: string;
    isThirdParty: boolean | null;
    labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
    addressData: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  history: Array<{
    trackingNumber: string | null;
    trackingURL: string | null;
    label: {
      cost: number;
      createdAt: string | null;
      carrier: string;
      labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
      addressData: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null> | null;
};

export type TListOpenShipmentsNewQueryVariables = Exact<{
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOpenShipmentsNewQuery = {
  listOpenShipmentsNEW: {
    nextToken: string | null;
    items: Array<{
      addressTypeIcon: string | null;
      readableAddressType: string | null;
      recipientName: string | null;
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      addressId: string;
      oldAddressId: string | null;
      addressVerified: Types.TShipStationAddressVerified | null;
      useGoogleAddress: boolean | null;
      status: Types.TShipmentStatuses;
      giftPacks: string | null;
      rack: string | null;
      notes: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      trackingNumber: string | null;
      trackingURL: string | null;
      shippedAt: string | null;
      setForPickupAt: string | null;
      pickedUpAt: string | null;
      isPrintedPhysically: boolean | null;
      isPrintedCUSMA: boolean | null;
      shipStationOrderId: number | null;
      shipStationShipmentId: number | null;
      lastShipStationResyncStartedAt: string | null;
      shipStationError: string | null;
      overrideCarrier: string | null;
      overrideService: string | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        active: boolean | null;
        isLive: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        name: string;
        fullyConfigured: boolean | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        customWorkAnniversaryNotes: string | null;
        hasCustomOnboardBrick: boolean | null;
        tissueColor: string;
        legoColor: string | null;
        signAs: string | null;
        specialNote: string | null;
        swag: string | null;
        startDate: string | null;
        endDate: string | null;
        subscriptionPricePerUser: number | null;
        subscriptionPriceCurrency: string | null;
        accountManager: string | null;
        lastRosterUpload: string | null;
        rosterId: string | null;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        logo: string | null;
        giftPacks: string | null;
        customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
        configuration: { authUserPoolId: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      office: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        name: string;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      employee: {
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      } | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      gifts: {
        items: Array<{
          id: string;
          _version: number;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          recipientId: string;
          addressId: string | null;
          eventId: string;
          shipmentId: string | null;
          status: Types.TGiftStatuses;
          type: Types.TGiftTypes;
          customType: string | null;
          oneOffSource: string | null;
          brickQuantity: number | null;
          brickSize: string | null;
          brickColor: string | null;
          brickText: string | null;
          eventDate: string;
          shippingDate: string | null;
          referenceEventDate: string | null;
          rack: string | null;
          notes: string | null;
          group: string | null;
          doneAt: string | null;
          isDone: number | null;
          recreatedFromId: string | null;
          recipientData: string | null;
          recipient:
            | {
                __typename: 'Dependant';
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                companyId: string;
                employeeId: string;
                firstName: string | null;
                fullName: string | null;
                lastName: string | null;
                birthDate: string | null;
                type: Types.TDependantType;
                petType: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  companyId: string;
                  officeId: string | null;
                  externalId: string | null;
                  fullName: string | null;
                  email: string | null;
                  hireDate: string | null;
                  birthDate: string | null;
                  isPaused: boolean | null;
                  createdAt: string | null;
                  active: boolean | null;
                  foodPreferences: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  company: { id: string; name: string; normalizedName: string | null } | null;
                  office: { id: string; name: string } | null;
                  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                } | null;
              }
            | {
                __typename: 'Employee';
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              }
            | null;
          alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
        } | null>;
      } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      packageInfo: { length: number; width: number; height: number; weight: number } | null;
      customsData: Array<{
        value: number;
        hsCode: string;
        quantity: number;
        description: string;
        country: string;
        originCriterion: string | null;
        sku: string | null;
        manufacturerNsProductId: string | null;
        manufacturerProductId: string | null;
        manufacturerProductIdType: Types.TManufacturerProductIdType | null;
      } | null> | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        isThirdParty: boolean | null;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      history: Array<{
        trackingNumber: string | null;
        trackingURL: string | null;
        label: {
          cost: number;
          createdAt: string | null;
          carrier: string;
          labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
          addressData: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null>;
  };
};

export type TListShipmentsTrackingNewQueryVariables = Exact<{
  shippedAt?: string | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListShipmentsTrackingNewQuery = {
  listShipmentsTrackingNEW: {
    nextToken: string | null;
    items: Array<{
      addressTypeIcon: string | null;
      readableAddressType: string | null;
      recipientName: string | null;
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      addressId: string;
      oldAddressId: string | null;
      addressVerified: Types.TShipStationAddressVerified | null;
      useGoogleAddress: boolean | null;
      status: Types.TShipmentStatuses;
      giftPacks: string | null;
      rack: string | null;
      notes: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      trackingNumber: string | null;
      trackingURL: string | null;
      shippedAt: string | null;
      setForPickupAt: string | null;
      pickedUpAt: string | null;
      isPrintedPhysically: boolean | null;
      isPrintedCUSMA: boolean | null;
      shipStationOrderId: number | null;
      shipStationShipmentId: number | null;
      lastShipStationResyncStartedAt: string | null;
      shipStationError: string | null;
      overrideCarrier: string | null;
      overrideService: string | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        active: boolean | null;
        isLive: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        name: string;
        fullyConfigured: boolean | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        customWorkAnniversaryNotes: string | null;
        hasCustomOnboardBrick: boolean | null;
        tissueColor: string;
        legoColor: string | null;
        signAs: string | null;
        specialNote: string | null;
        swag: string | null;
        startDate: string | null;
        endDate: string | null;
        subscriptionPricePerUser: number | null;
        subscriptionPriceCurrency: string | null;
        accountManager: string | null;
        lastRosterUpload: string | null;
        rosterId: string | null;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        logo: string | null;
        giftPacks: string | null;
        customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
        configuration: { authUserPoolId: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      office: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        name: string;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      employee: {
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      } | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      gifts: {
        items: Array<{
          id: string;
          _version: number;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          recipientId: string;
          addressId: string | null;
          eventId: string;
          shipmentId: string | null;
          status: Types.TGiftStatuses;
          type: Types.TGiftTypes;
          customType: string | null;
          oneOffSource: string | null;
          brickQuantity: number | null;
          brickSize: string | null;
          brickColor: string | null;
          brickText: string | null;
          eventDate: string;
          shippingDate: string | null;
          referenceEventDate: string | null;
          rack: string | null;
          notes: string | null;
          group: string | null;
          doneAt: string | null;
          isDone: number | null;
          recreatedFromId: string | null;
          recipientData: string | null;
          recipient:
            | {
                __typename: 'Dependant';
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                companyId: string;
                employeeId: string;
                firstName: string | null;
                fullName: string | null;
                lastName: string | null;
                birthDate: string | null;
                type: Types.TDependantType;
                petType: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  companyId: string;
                  officeId: string | null;
                  externalId: string | null;
                  fullName: string | null;
                  email: string | null;
                  hireDate: string | null;
                  birthDate: string | null;
                  isPaused: boolean | null;
                  createdAt: string | null;
                  active: boolean | null;
                  foodPreferences: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  company: { id: string; name: string; normalizedName: string | null } | null;
                  office: { id: string; name: string } | null;
                  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                } | null;
              }
            | {
                __typename: 'Employee';
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              }
            | null;
          alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
        } | null>;
      } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      packageInfo: { length: number; width: number; height: number; weight: number } | null;
      customsData: Array<{
        value: number;
        hsCode: string;
        quantity: number;
        description: string;
        country: string;
        originCriterion: string | null;
        sku: string | null;
        manufacturerNsProductId: string | null;
        manufacturerProductId: string | null;
        manufacturerProductIdType: Types.TManufacturerProductIdType | null;
      } | null> | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        isThirdParty: boolean | null;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      history: Array<{
        trackingNumber: string | null;
        trackingURL: string | null;
        label: {
          cost: number;
          createdAt: string | null;
          carrier: string;
          labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
          addressData: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null>;
  };
};

export type TListShipmentsPickupNewQueryVariables = Exact<{
  setForPickupAt?: string | null | undefined;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListShipmentsPickupNewQuery = {
  listShipmentsPickupNEW: {
    nextToken: string | null;
    items: Array<{
      addressTypeIcon: string | null;
      readableAddressType: string | null;
      recipientName: string | null;
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      addressId: string;
      oldAddressId: string | null;
      addressVerified: Types.TShipStationAddressVerified | null;
      useGoogleAddress: boolean | null;
      status: Types.TShipmentStatuses;
      giftPacks: string | null;
      rack: string | null;
      notes: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      trackingNumber: string | null;
      trackingURL: string | null;
      shippedAt: string | null;
      setForPickupAt: string | null;
      pickedUpAt: string | null;
      isPrintedPhysically: boolean | null;
      isPrintedCUSMA: boolean | null;
      shipStationOrderId: number | null;
      shipStationShipmentId: number | null;
      lastShipStationResyncStartedAt: string | null;
      shipStationError: string | null;
      overrideCarrier: string | null;
      overrideService: string | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        active: boolean | null;
        isLive: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        name: string;
        fullyConfigured: boolean | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        customWorkAnniversaryNotes: string | null;
        hasCustomOnboardBrick: boolean | null;
        tissueColor: string;
        legoColor: string | null;
        signAs: string | null;
        specialNote: string | null;
        swag: string | null;
        startDate: string | null;
        endDate: string | null;
        subscriptionPricePerUser: number | null;
        subscriptionPriceCurrency: string | null;
        accountManager: string | null;
        lastRosterUpload: string | null;
        rosterId: string | null;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        logo: string | null;
        giftPacks: string | null;
        customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
        configuration: { authUserPoolId: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      office: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        name: string;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      employee: {
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      } | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      gifts: {
        items: Array<{
          id: string;
          _version: number;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          recipientId: string;
          addressId: string | null;
          eventId: string;
          shipmentId: string | null;
          status: Types.TGiftStatuses;
          type: Types.TGiftTypes;
          customType: string | null;
          oneOffSource: string | null;
          brickQuantity: number | null;
          brickSize: string | null;
          brickColor: string | null;
          brickText: string | null;
          eventDate: string;
          shippingDate: string | null;
          referenceEventDate: string | null;
          rack: string | null;
          notes: string | null;
          group: string | null;
          doneAt: string | null;
          isDone: number | null;
          recreatedFromId: string | null;
          recipientData: string | null;
          recipient:
            | {
                __typename: 'Dependant';
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                companyId: string;
                employeeId: string;
                firstName: string | null;
                fullName: string | null;
                lastName: string | null;
                birthDate: string | null;
                type: Types.TDependantType;
                petType: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  companyId: string;
                  officeId: string | null;
                  externalId: string | null;
                  fullName: string | null;
                  email: string | null;
                  hireDate: string | null;
                  birthDate: string | null;
                  isPaused: boolean | null;
                  createdAt: string | null;
                  active: boolean | null;
                  foodPreferences: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  company: { id: string; name: string; normalizedName: string | null } | null;
                  office: { id: string; name: string } | null;
                  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                } | null;
              }
            | {
                __typename: 'Employee';
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              }
            | null;
          alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
        } | null>;
      } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      packageInfo: { length: number; width: number; height: number; weight: number } | null;
      customsData: Array<{
        value: number;
        hsCode: string;
        quantity: number;
        description: string;
        country: string;
        originCriterion: string | null;
        sku: string | null;
        manufacturerNsProductId: string | null;
        manufacturerProductId: string | null;
        manufacturerProductIdType: Types.TManufacturerProductIdType | null;
      } | null> | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        isThirdParty: boolean | null;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      history: Array<{
        trackingNumber: string | null;
        trackingURL: string | null;
        label: {
          cost: number;
          createdAt: string | null;
          carrier: string;
          labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
          addressData: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null>;
  };
};

export type TListOneShipmentQueryVariables = Exact<{
  id: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOneShipmentQuery = {
  listOneShipment: {
    nextToken: string | null;
    items: Array<{
      addressTypeIcon: string | null;
      readableAddressType: string | null;
      recipientName: string | null;
      id: string;
      _version: number;
      _deleted: boolean | null;
      companyId: string;
      addressId: string;
      oldAddressId: string | null;
      addressVerified: Types.TShipStationAddressVerified | null;
      useGoogleAddress: boolean | null;
      status: Types.TShipmentStatuses;
      giftPacks: string | null;
      rack: string | null;
      notes: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      trackingNumber: string | null;
      trackingURL: string | null;
      shippedAt: string | null;
      setForPickupAt: string | null;
      pickedUpAt: string | null;
      isPrintedPhysically: boolean | null;
      isPrintedCUSMA: boolean | null;
      shipStationOrderId: number | null;
      shipStationShipmentId: number | null;
      lastShipStationResyncStartedAt: string | null;
      shipStationError: string | null;
      overrideCarrier: string | null;
      overrideService: string | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        active: boolean | null;
        isLive: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        name: string;
        fullyConfigured: boolean | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        customWorkAnniversaryNotes: string | null;
        hasCustomOnboardBrick: boolean | null;
        tissueColor: string;
        legoColor: string | null;
        signAs: string | null;
        specialNote: string | null;
        swag: string | null;
        startDate: string | null;
        endDate: string | null;
        subscriptionPricePerUser: number | null;
        subscriptionPriceCurrency: string | null;
        accountManager: string | null;
        lastRosterUpload: string | null;
        rosterId: string | null;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        logo: string | null;
        giftPacks: string | null;
        customShippingConfiguration: Array<{ carrier: string | null; accountNumber: string | null; postalCode: string | null; countryCode: string | null; overrideInternationalOnly: boolean | null } | null> | null;
        configuration: { authUserPoolId: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      office: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        companyId: string;
        name: string;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      employee: {
        id: string;
        companyId: string;
        officeId: string | null;
        externalId: string | null;
        fullName: string | null;
        email: string | null;
        hireDate: string | null;
        birthDate: string | null;
        isPaused: boolean | null;
        createdAt: string | null;
        active: boolean | null;
        foodPreferences: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        company: { id: string; name: string; normalizedName: string | null } | null;
        office: { id: string; name: string } | null;
        address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
      } | null;
      recipient:
        | {
            __typename: 'Dependant';
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            companyId: string;
            employeeId: string;
            firstName: string | null;
            fullName: string | null;
            lastName: string | null;
            birthDate: string | null;
            type: Types.TDependantType;
            petType: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              companyId: string;
              officeId: string | null;
              externalId: string | null;
              fullName: string | null;
              email: string | null;
              hireDate: string | null;
              birthDate: string | null;
              isPaused: boolean | null;
              createdAt: string | null;
              active: boolean | null;
              foodPreferences: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              company: { id: string; name: string; normalizedName: string | null } | null;
              office: { id: string; name: string } | null;
              address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
            } | null;
          }
        | {
            __typename: 'Employee';
            id: string;
            companyId: string;
            officeId: string | null;
            externalId: string | null;
            fullName: string | null;
            email: string | null;
            hireDate: string | null;
            birthDate: string | null;
            isPaused: boolean | null;
            createdAt: string | null;
            active: boolean | null;
            foodPreferences: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            company: { id: string; name: string; normalizedName: string | null } | null;
            office: { id: string; name: string } | null;
            address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
          }
        | null;
      gifts: {
        items: Array<{
          id: string;
          _version: number;
          _deleted: boolean | null;
          companyId: string;
          employeeId: string;
          recipientId: string;
          addressId: string | null;
          eventId: string;
          shipmentId: string | null;
          status: Types.TGiftStatuses;
          type: Types.TGiftTypes;
          customType: string | null;
          oneOffSource: string | null;
          brickQuantity: number | null;
          brickSize: string | null;
          brickColor: string | null;
          brickText: string | null;
          eventDate: string;
          shippingDate: string | null;
          referenceEventDate: string | null;
          rack: string | null;
          notes: string | null;
          group: string | null;
          doneAt: string | null;
          isDone: number | null;
          recreatedFromId: string | null;
          recipientData: string | null;
          recipient:
            | {
                __typename: 'Dependant';
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                companyId: string;
                employeeId: string;
                firstName: string | null;
                fullName: string | null;
                lastName: string | null;
                birthDate: string | null;
                type: Types.TDependantType;
                petType: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  companyId: string;
                  officeId: string | null;
                  externalId: string | null;
                  fullName: string | null;
                  email: string | null;
                  hireDate: string | null;
                  birthDate: string | null;
                  isPaused: boolean | null;
                  createdAt: string | null;
                  active: boolean | null;
                  foodPreferences: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  company: { id: string; name: string; normalizedName: string | null } | null;
                  office: { id: string; name: string } | null;
                  address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                } | null;
              }
            | {
                __typename: 'Employee';
                id: string;
                companyId: string;
                officeId: string | null;
                externalId: string | null;
                fullName: string | null;
                email: string | null;
                hireDate: string | null;
                birthDate: string | null;
                isPaused: boolean | null;
                createdAt: string | null;
                active: boolean | null;
                foodPreferences: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                company: { id: string; name: string; normalizedName: string | null } | null;
                office: { id: string; name: string } | null;
                address: { id: string; address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
              }
            | null;
          alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
        } | null>;
      } | null;
      alerts: Array<{ message: string; oldItem: string | null; newItem: string | null; acknowledgedBy: string | null; acknowledgedAt: string | null } | null> | null;
      packageInfo: { length: number; width: number; height: number; weight: number } | null;
      customsData: Array<{
        value: number;
        hsCode: string;
        quantity: number;
        description: string;
        country: string;
        originCriterion: string | null;
        sku: string | null;
        manufacturerNsProductId: string | null;
        manufacturerProductId: string | null;
        manufacturerProductIdType: Types.TManufacturerProductIdType | null;
      } | null> | null;
      label: {
        cost: number;
        createdAt: string | null;
        carrier: string;
        isThirdParty: boolean | null;
        labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
        addressData: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      history: Array<{
        trackingNumber: string | null;
        trackingURL: string | null;
        label: {
          cost: number;
          createdAt: string | null;
          carrier: string;
          labelFile: { bucket: string; key: string; region: string; version: string | null } | null;
          addressData: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null>;
  };
};

export type TUserFieldsFragment = {
  _version: number;
  _deleted: boolean | null;
  _lastChangedAt: number | null;
  email: string;
  companyId: string;
  name: string;
  type: Types.TUserType;
  title: string | null;
  isCompanyOwner: boolean;
  userId: string | null;
};

export type TListUsersQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListUsersQuery = {
  listUsers: {
    nextToken: string | null;
    items: Array<{
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      email: string;
      companyId: string;
      name: string;
      type: Types.TUserType;
      title: string | null;
      isCompanyOwner: boolean;
      userId: string | null;
    } | null>;
  };
};

export type TListUsersIncludingCsUsersQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListUsersIncludingCsUsersQuery = {
  listUsersIncludingCSUsers: {
    nextToken: string | null;
    items: Array<{
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      email: string;
      companyId: string;
      name: string;
      type: Types.TUserType;
      title: string | null;
      isCompanyOwner: boolean;
      userId: string | null;
    } | null>;
  };
};

export type TCreateUserMutationVariables = Exact<{
  input: Types.TCreateUserMutationInput;
}>;

export type TCreateUserMutation = {
  createUser: { _version: number; _deleted: boolean | null; _lastChangedAt: number | null; email: string; companyId: string; name: string; type: Types.TUserType; title: string | null; isCompanyOwner: boolean; userId: string | null } | null;
};

export type TDeleteUserMutationVariables = Exact<{
  email: string;
  companyId: string;
  version: number;
}>;

export type TDeleteUserMutation = {
  deleteUser: { _version: number; _deleted: boolean | null; _lastChangedAt: number | null; email: string; companyId: string; name: string; type: Types.TUserType; title: string | null; isCompanyOwner: boolean; userId: string | null } | null;
};

export type TListAdminCognitoUsersQueryVariables = Exact<{
  userPoolId: string;
  onlyCS?: boolean | null | undefined;
}>;

export type TListAdminCognitoUsersQuery = { listAdminCognitoUsers: string | null };

export type TOnCompanyUserChangedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyUserChangedSubscription = {
  onCompanyUserChanged: {
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    email: string;
    companyId: string;
    name: string;
    type: Types.TUserType;
    title: string | null;
    isCompanyOwner: boolean;
    userId: string | null;
  } | null;
};

export const AddressFieldsFragmentDoc = gql`
  fragment AddressFields on Address {
    id
    companyId
    _version
    _deleted
    address1
    address2
    city
    state
    country
    zipCode
    parentType
    useGoogleAddress
    googleValidated
    missingInfo
    alert
    addressFromGoogle {
      address1
      address2
      city
      state
      country
      zipCode
    }
  }
`;
export const AddressNewFieldsFragmentDoc = gql`
  fragment AddressNewFields on Address {
    ...AddressFields
    parent
  }
`;
export const ListAllCompaniesFieldsFragmentDoc = gql`
  fragment ListAllCompaniesFields on Company {
    __typename
    id
    _version
    name
    employeeCount
    endDate
    active
    isLive
    deliveryMethod
    fullyConfigured
    lastRosterUpload
    accountManager
    workAnniversaryGiftVariation
  }
`;
export const ListAllCompaniesOptionsFieldsFragmentDoc = gql`
  fragment ListAllCompaniesOptionsFields on Company {
    __typename
    id
    _version
    name
    active
    isLive
    endDate
    deliveryMethod
    workAnniversaryGiftVariation
  }
`;
export const ContactFieldsFragmentDoc = gql`
  fragment ContactFields on Contact {
    name
    email
    phoneNumber
  }
`;
export const ListOneCompanyFieldsFragmentDoc = gql`
  fragment ListOneCompanyFields on Company {
    id
    _version
    name
    active
    isLive
    accountManager
    deliveryMethod
    subdomain
    emailDomains
    googleLoginEnabled
    legoColor
    tissueColor
    startDate
    endDate
    contact {
      ...ContactFields
    }
    address {
      ...AddressFields
    }
    subscriptionPricePerUser
    subscriptionPriceCurrency
    fullyConfigured
    employeeNewHireKitActivated
    employeeBirthdayActivated
    significantOtherBirthdayActivated
    childBirthdayActivated
    petBirthdayActivated
    employeeWorkAnniversaryActivated
    workAnniversaryGiftVariation
    customWorkAnniversaryNotes
    hasCustomOnboardBrick
    signAs
    specialNote
    swag
    configuration {
      authUserPoolId
    }
    customShippingConfiguration {
      carrier
      accountNumber
      postalCode
      countryCode
      overrideInternationalOnly
    }
  }
`;
export const EmployeeFieldsFragmentDoc = gql`
  fragment EmployeeFields on Employee {
    id
    _version
    _deleted
    createdAt
    updatedAt
    active
    externalId
    companyId
    officeId
    office {
      id
      name
    }
    firstName
    lastName
    preferredFirstName
    fullName
    hireDate
    birthDate
    email
    phoneNumber
    foodPreferences
    customOnboardBrick
    title
    organization
    tShirtSize
    sweaterSize
    donateBirthdayGift
    donateWorkAnniversaryGift
    isPaused
    pausePeriod {
      fromDate
      toDate
    }
    address {
      ...AddressFields
    }
  }
`;
export const DependantFieldsFragmentDoc = gql`
  fragment DependantFields on Dependant {
    id
    _version
    _deleted
    companyId
    employeeId
    firstName
    fullName
    lastName
    birthDate
    type
    petType
    foodPreferences
    donateBirthdayGift
  }
`;
export const EmployeeFieldsHydratedFragmentDoc = gql`
  fragment EmployeeFieldsHydrated on Employee {
    ...EmployeeFields
    dependants {
      items {
        ...DependantFields
      }
    }
  }
`;
export const CompanyFieldsFragmentDoc = gql`
  fragment CompanyFields on Company {
    id
    _version
    _deleted
    active
    isLive
    deliveryMethod
    name
    fullyConfigured
    employeeBirthdayActivated
    employeeWorkAnniversaryActivated
    employeeNewHireKitActivated
    significantOtherBirthdayActivated
    childBirthdayActivated
    petBirthdayActivated
    workAnniversaryGiftVariation
    customWorkAnniversaryNotes
    hasCustomOnboardBrick
    tissueColor
    legoColor
    signAs
    specialNote
    swag
    startDate
    endDate
    subscriptionPricePerUser
    subscriptionPriceCurrency
    customShippingConfiguration {
      carrier
      accountNumber
      postalCode
      countryCode
      overrideInternationalOnly
    }
    configuration {
      authUserPoolId
    }
    accountManager
    lastRosterUpload
    rosterId
    subdomain
    emailDomains
    googleLoginEnabled
    logo
    giftPacks
    contact {
      ...ContactFields
    }
    address {
      ...AddressFields
    }
  }
`;
export const OfficeFieldsFragmentDoc = gql`
  fragment OfficeFields on Office {
    id
    _version
    _deleted
    companyId
    name
    contact {
      ...ContactFields
    }
    address {
      ...AddressFields
    }
  }
`;
export const EmployeeNewFieldsFragmentDoc = gql`
  fragment EmployeeNewFields on Employee {
    ...EmployeeFields
    company {
      ...CompanyFields
    }
    office {
      ...OfficeFields
    }
    address {
      ...AddressFields
    }
    dependants {
      items {
        ...DependantFields
      }
    }
  }
`;
export const ListOneEmployeeFieldsFragmentDoc = gql`
  fragment ListOneEmployeeFields on Employee {
    id
    companyId
    officeId
    externalId
    fullName
    email
    hireDate
    birthDate
    isPaused
    createdAt
    active
    firstName
    lastName
    preferredFirstName
    birthDate
    phoneNumber
    foodPreferences
    tShirtSize
    sweaterSize
    donateBirthdayGift
    donateWorkAnniversaryGift
    company {
      id
      name
    }
    office {
      id
      name
    }
    address {
      id
      address1
      address2
      city
      state
      country
      zipCode
    }
    pausePeriod {
      fromDate
      toDate
    }
  }
`;
export const ListOneOfficeEmployeesFieldsFragmentDoc = gql`
  fragment ListOneOfficeEmployeesFields on Employee {
    id
    companyId
    officeId
    externalId
    fullName
    email
    hireDate
    birthDate
    isPaused
    createdAt
    active
    company {
      id
      name
    }
    pausePeriod {
      fromDate
      toDate
    }
  }
`;
export const ListOneCompanyEmployeesFieldsFragmentDoc = gql`
  fragment ListOneCompanyEmployeesFields on Employee {
    id
    companyId
    externalId
    firstName
    lastName
    preferredFirstName
    fullName
    company {
      id
      name
    }
    dependants {
      items {
        ...DependantFields
      }
    }
    pausePeriod {
      fromDate
      toDate
    }
  }
`;
export const ListAllEmployeesFieldsFragmentDoc = gql`
  fragment ListAllEmployeesFields on Employee {
    id
    companyId
    officeId
    externalId
    fullName
    email
    hireDate
    birthDate
    isPaused
    createdAt
    active
    foodPreferences
    tShirtSize
    sweaterSize
    company {
      id
      name
      normalizedName
    }
    office {
      id
      name
    }
    address {
      id
      address1
      address2
      city
      state
      country
      zipCode
    }
    pausePeriod {
      fromDate
      toDate
    }
  }
`;
export const DependantFieldsHydratedFragmentDoc = gql`
  fragment DependantFieldsHydrated on Dependant {
    ...DependantFields
    employee {
      ...ListAllEmployeesFields
    }
  }
`;
export const ReferenceEventFieldsFragmentDoc = gql`
  fragment ReferenceEventFields on ReferenceEvent {
    id
    _version
    _deleted
    _lastChangedAt
    createdAt
    updatedAt
    companyId
    company {
      name
    }
    employeeId
    employee {
      fullName
    }
    recipientId
    recipient {
      ... on Dependant {
        ...DependantFieldsHydrated
      }
      ... on Employee {
        ...ListAllEmployeesFields
      }
    }
    addressId
    address {
      id
      address1
    }
    fullDate
    date
    type
  }
`;
export const EventFieldsFragmentDoc = gql`
  fragment EventFields on Event {
    id
    _version
    _deleted
    companyId
    employeeId
    recipientId
    addressId
    referenceEventId
    giftId
    eventDate
    shippingDate
    type
    customType
    notes
    oneOffSource
    brickQuantity
    brickSize
    brickColor
    brickText
    age
    skippedAt
    deliveredAt
    groupedToEventId
    isPaused
    wasPaused
  }
`;
export const RecipientFieldsFragmentDoc = gql`
  fragment RecipientFields on Recipient {
    __typename
    ... on Dependant {
      ...DependantFieldsHydrated
    }
    ... on Employee {
      ...ListAllEmployeesFields
    }
  }
`;
export const EventNewFieldsFragmentDoc = gql`
  fragment EventNewFields on Event {
    ...EventFields
    company {
      ...CompanyFields
    }
    recipient {
      ...RecipientFields
    }
    employee {
      ...ListAllEmployeesFields
    }
    address {
      ...AddressFields
    }
  }
`;
export const ListEventFieldsFragmentDoc = gql`
  fragment ListEventFields on Event {
    id
    companyId
    _version
    addressId
    eventDate
    type
    customType
    notes
    oneOffSource
    brickQuantity
    brickSize
    brickColor
    brickText
    shippingDate
    skippedAt
    wasPaused
    company {
      id
      name
      accountManager
    }
    recipient {
      ... on Dependant {
        id
        fullName
      }
      ... on Employee {
        id
        fullName
      }
    }
    employee {
      id
      fullName
      office {
        id
        name
      }
      isPaused
      pausePeriod {
        fromDate
        toDate
        unpausedAt
      }
    }
    address {
      id
      address1
      address2
      city
      state
      country
      zipCode
      useGoogleAddress
      googleValidated
      addressFromGoogle {
        address1
        address2
        city
        state
        country
        zipCode
      }
    }
  }
`;
export const GiftPackageFieldsFragmentDoc = gql`
  fragment GiftPackageFields on GiftPackage {
    id
    _version
    _deleted
    createdAt
    updatedAt
    companyId
    company {
      id
      name
    }
    name
    type
    subType
    isDefault
    products
    hydratedProducts
  }
`;
export const BaseGiftFieldsFragmentDoc = gql`
  fragment BaseGiftFields on Gift {
    id
    _version
    _deleted
    companyId
    employeeId
    recipientId
    addressId
    eventId
    shipmentId
    status
    type
    customType
    oneOffSource
    brickQuantity
    brickSize
    brickColor
    brickText
    eventDate
    shippingDate
    referenceEventDate
    rack
    notes
    group
    doneAt
    isDone
    recreatedFromId
    alerts {
      message
      oldItem
      newItem
      acknowledgedBy
      acknowledgedAt
    }
    recipientData
  }
`;
export const GiftEventFieldsFragmentDoc = gql`
  fragment GiftEventFields on Event {
    age
  }
`;
export const GiftFieldsFragmentDoc = gql`
  fragment GiftFields on Gift {
    ...BaseGiftFields
    event {
      ...GiftEventFields
    }
  }
`;
export const ShipmentFieldsFragmentDoc = gql`
  fragment ShipmentFields on Shipment {
    id
    _version
    _deleted
    companyId
    addressId
    oldAddressId
    addressVerified
    useGoogleAddress
    alerts {
      message
      oldItem
      newItem
      acknowledgedBy
      acknowledgedAt
    }
    status
    giftPacks
    rack
    notes
    actualShippingDate
    shippingDate
    trackingNumber
    trackingURL
    shippedAt
    setForPickupAt
    pickedUpAt
    packageInfo {
      length
      width
      height
      weight
    }
    customsData {
      value
      hsCode
      quantity
      description
      country
      originCriterion
      sku
      manufacturerNsProductId
      manufacturerProductId
      manufacturerProductIdType
    }
    isPrintedPhysically
    isPrintedCUSMA
    label {
      labelFile {
        bucket
        key
        region
        version
      }
      cost
      createdAt
      carrier
      addressData {
        ...AddressFields
      }
      isThirdParty
    }
    history {
      label {
        labelFile {
          bucket
          key
          region
          version
        }
        cost
        createdAt
        carrier
        addressData {
          ...AddressFields
        }
      }
      trackingNumber
      trackingURL
    }
    shipStationOrderId
    shipStationShipmentId
    lastShipStationResyncStartedAt
    shipStationError
    overrideCarrier
    overrideService
  }
`;
export const GiftFieldsHydratedFragmentDoc = gql`
  fragment GiftFieldsHydrated on Gift {
    ...GiftFields
    shipment {
      ...ShipmentFields
    }
  }
`;
export const GiftNewFieldsFragmentDoc = gql`
  fragment GiftNewFields on Gift {
    ...GiftFields
    groupedGifts
  }
`;
export const ShipmentFieldsHydratedFragmentDoc = gql`
  fragment ShipmentFieldsHydrated on Shipment {
    ...ShipmentFields
    gifts {
      items {
        ...BaseGiftFields
        recipient {
          __typename
          ...RecipientFields
        }
      }
    }
  }
`;
export const ShipmentNewFieldsFragmentDoc = gql`
  fragment ShipmentNewFields on Shipment {
    ...ShipmentFieldsHydrated
    addressTypeIcon
    readableAddressType
    recipientName
  }
`;
export const GiftNewFieldsWithShipmentFragmentDoc = gql`
  fragment GiftNewFieldsWithShipment on Gift {
    ...GiftNewFields
    shipment {
      ...ShipmentNewFields
    }
  }
`;
export const GiftNewFieldsAndHydrationFragmentDoc = gql`
  fragment GiftNewFieldsAndHydration on Gift {
    ...GiftNewFields
    company {
      id
      name
      workAnniversaryGiftVariation
      customWorkAnniversaryNotes
      hasCustomOnboardBrick
      tissueColor
      legoColor
      signAs
      specialNote
      swag
      accountManager
    }
    recipient {
      ...RecipientFields
    }
    employee {
      ...ListAllEmployeesFields
    }
    address {
      ...AddressFields
    }
  }
`;
export const LogFieldsFragmentDoc = gql`
  fragment LogFields on Log {
    id
    occurredAt
    arguments
    companyId
    fieldName
    identity
    parentTypeName
    resourceId
    response
    selectionSetGraphQL
    type
    userId
    userType
    variables
    action
    entity
    identityUserName
    identityUserEmail
    company {
      id
      name
    }
    employee {
      id
      firstName
      preferredFirstName
      lastName
      fullName
    }
  }
`;
export const ProductFieldsFragmentDoc = gql`
  fragment ProductFields on Product {
    id
    _version
    _deleted
    createdAt
    updatedAt
    value
    hsCode
    quantity
    description
    country
    originCriterion
    sku
    manufacturerNsProductId
    manufacturerProductId
    manufacturerProductIdType
  }
`;
export const RosterFileFieldsFragmentDoc = gql`
  fragment RosterFileFields on RosterFile {
    id
    _version
    _deleted
    createdAt
    updatedAt
    companyId
    createdBy {
      username
      sub
    }
    file {
      bucket
      region
      key
      version
    }
    headerMapping
    mapping
    officeMapping
    changelog
    changelogFile {
      bucket
      region
      key
      version
    }
    importStartedAt
    impoortEndedAt
    importErrors
  }
`;
export const ShipmentNewFieldsAndHydrationFragmentDoc = gql`
  fragment ShipmentNewFieldsAndHydration on Shipment {
    ...ShipmentNewFields
    address {
      ...AddressFields
    }
    company {
      ...CompanyFields
    }
    office {
      ...OfficeFields
    }
    employee {
      ...ListAllEmployeesFields
    }
    recipient {
      ...RecipientFields
    }
  }
`;
export const UserFieldsFragmentDoc = gql`
  fragment UserFields on User {
    _version
    _deleted
    _lastChangedAt
    email
    companyId
    name
    type
    title
    isCompanyOwner
    userId
  }
`;
export const ListAllAddressesDocument = gql`
  query ListAllAddresses($nextToken: String, $limit: Int, $order: OrderDirection) {
    listAddresses(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...AddressFields
      }
    }
  }
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListAllAddressesQuery__
 *
 * To run a query within a React component, call `useListAllAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllAddressesQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAllAddressesQuery(baseOptions?: Apollo.QueryHookOptions<TListAllAddressesQuery, TListAllAddressesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListAllAddressesQuery, TListAllAddressesQueryVariables>(ListAllAddressesDocument, options);
}
export function useListAllAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListAllAddressesQuery, TListAllAddressesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListAllAddressesQuery, TListAllAddressesQueryVariables>(ListAllAddressesDocument, options);
}
// @ts-ignore
export function useListAllAddressesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListAllAddressesQuery, TListAllAddressesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllAddressesQuery, TListAllAddressesQueryVariables>;
export function useListAllAddressesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllAddressesQuery, TListAllAddressesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllAddressesQuery | undefined, TListAllAddressesQueryVariables>;
export function useListAllAddressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllAddressesQuery, TListAllAddressesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListAllAddressesQuery, TListAllAddressesQueryVariables>(ListAllAddressesDocument, options);
}
export type ListAllAddressesQueryHookResult = ReturnType<typeof useListAllAddressesQuery>;
export type ListAllAddressesLazyQueryHookResult = ReturnType<typeof useListAllAddressesLazyQuery>;
export type ListAllAddressesSuspenseQueryHookResult = ReturnType<typeof useListAllAddressesSuspenseQuery>;
export type ListAllAddressesQueryResult = Apollo.QueryResult<TListAllAddressesQuery, TListAllAddressesQueryVariables>;
export const GetAddressByIdDocument = gql`
  query GetAddressById($id: ID!) {
    getAddressById(id: $id) {
      ...AddressFields
    }
  }
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useGetAddressByIdQuery__
 *
 * To run a query within a React component, call `useGetAddressByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAddressByIdQuery(baseOptions: Apollo.QueryHookOptions<TGetAddressByIdQuery, TGetAddressByIdQueryVariables> & ({ variables: TGetAddressByIdQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetAddressByIdQuery, TGetAddressByIdQueryVariables>(GetAddressByIdDocument, options);
}
export function useGetAddressByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetAddressByIdQuery, TGetAddressByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetAddressByIdQuery, TGetAddressByIdQueryVariables>(GetAddressByIdDocument, options);
}
// @ts-ignore
export function useGetAddressByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetAddressByIdQuery, TGetAddressByIdQueryVariables>): Apollo.UseSuspenseQueryResult<TGetAddressByIdQuery, TGetAddressByIdQueryVariables>;
export function useGetAddressByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetAddressByIdQuery, TGetAddressByIdQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetAddressByIdQuery | undefined, TGetAddressByIdQueryVariables>;
export function useGetAddressByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetAddressByIdQuery, TGetAddressByIdQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetAddressByIdQuery, TGetAddressByIdQueryVariables>(GetAddressByIdDocument, options);
}
export type GetAddressByIdQueryHookResult = ReturnType<typeof useGetAddressByIdQuery>;
export type GetAddressByIdLazyQueryHookResult = ReturnType<typeof useGetAddressByIdLazyQuery>;
export type GetAddressByIdSuspenseQueryHookResult = ReturnType<typeof useGetAddressByIdSuspenseQuery>;
export type GetAddressByIdQueryResult = Apollo.QueryResult<TGetAddressByIdQuery, TGetAddressByIdQueryVariables>;
export const ListAddressesByCompanyIdDocument = gql`
  query ListAddressesByCompanyId($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listAddressesByCompanyId(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...AddressNewFields
      }
    }
  }
  ${AddressNewFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListAddressesByCompanyIdQuery__
 *
 * To run a query within a React component, call `useListAddressesByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAddressesByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAddressesByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAddressesByCompanyIdQuery(
  baseOptions: Apollo.QueryHookOptions<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables> & ({ variables: TListAddressesByCompanyIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables>(ListAddressesByCompanyIdDocument, options);
}
export function useListAddressesByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables>(ListAddressesByCompanyIdDocument, options);
}
// @ts-ignore
export function useListAddressesByCompanyIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables>;
export function useListAddressesByCompanyIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAddressesByCompanyIdQuery | undefined, TListAddressesByCompanyIdQueryVariables>;
export function useListAddressesByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables>(ListAddressesByCompanyIdDocument, options);
}
export type ListAddressesByCompanyIdQueryHookResult = ReturnType<typeof useListAddressesByCompanyIdQuery>;
export type ListAddressesByCompanyIdLazyQueryHookResult = ReturnType<typeof useListAddressesByCompanyIdLazyQuery>;
export type ListAddressesByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useListAddressesByCompanyIdSuspenseQuery>;
export type ListAddressesByCompanyIdQueryResult = Apollo.QueryResult<TListAddressesByCompanyIdQuery, TListAddressesByCompanyIdQueryVariables>;
export const ListOneAddressDocument = gql`
  query ListOneAddress($id: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listOneAddress(id: $id, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...AddressNewFields
      }
    }
  }
  ${AddressNewFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListOneAddressQuery__
 *
 * To run a query within a React component, call `useListOneAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneAddressQuery(baseOptions: Apollo.QueryHookOptions<TListOneAddressQuery, TListOneAddressQueryVariables> & ({ variables: TListOneAddressQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneAddressQuery, TListOneAddressQueryVariables>(ListOneAddressDocument, options);
}
export function useListOneAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneAddressQuery, TListOneAddressQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneAddressQuery, TListOneAddressQueryVariables>(ListOneAddressDocument, options);
}
// @ts-ignore
export function useListOneAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneAddressQuery, TListOneAddressQueryVariables>): Apollo.UseSuspenseQueryResult<TListOneAddressQuery, TListOneAddressQueryVariables>;
export function useListOneAddressSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneAddressQuery, TListOneAddressQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneAddressQuery | undefined, TListOneAddressQueryVariables>;
export function useListOneAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneAddressQuery, TListOneAddressQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneAddressQuery, TListOneAddressQueryVariables>(ListOneAddressDocument, options);
}
export type ListOneAddressQueryHookResult = ReturnType<typeof useListOneAddressQuery>;
export type ListOneAddressLazyQueryHookResult = ReturnType<typeof useListOneAddressLazyQuery>;
export type ListOneAddressSuspenseQueryHookResult = ReturnType<typeof useListOneAddressSuspenseQuery>;
export type ListOneAddressQueryResult = Apollo.QueryResult<TListOneAddressQuery, TListOneAddressQueryVariables>;
export const GetCompanyDocument = gql`
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      ...CompanyFields
    }
  }
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<TGetCompanyQuery, TGetCompanyQueryVariables> & ({ variables: TGetCompanyQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetCompanyQuery, TGetCompanyQueryVariables>(GetCompanyDocument, options);
}
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetCompanyQuery, TGetCompanyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetCompanyQuery, TGetCompanyQueryVariables>(GetCompanyDocument, options);
}
// @ts-ignore
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetCompanyQuery, TGetCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<TGetCompanyQuery, TGetCompanyQueryVariables>;
export function useGetCompanySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetCompanyQuery, TGetCompanyQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetCompanyQuery | undefined, TGetCompanyQueryVariables>;
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetCompanyQuery, TGetCompanyQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetCompanyQuery, TGetCompanyQueryVariables>(GetCompanyDocument, options);
}
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<TGetCompanyQuery, TGetCompanyQueryVariables>;
export const CreateCompanyDocument = gql`
  mutation CreateCompany($input: CreateCompanyMutationInput!) {
    createCompany(input: $input) {
      ...CompanyFields
    }
  }
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TCreateCompanyMutationFn = Apollo.MutationFunction<TCreateCompanyMutation, TCreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<TCreateCompanyMutation, TCreateCompanyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateCompanyMutation, TCreateCompanyMutationVariables>(CreateCompanyDocument, options);
}
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<TCreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<TCreateCompanyMutation, TCreateCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
  mutation UpdateCompany($id: ID!, $_version: Int!, $input: UpdateCompanyMutationInput!) {
    updateCompany(id: $id, _version: $_version, input: $input) {
      ...CompanyFields
    }
  }
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TUpdateCompanyMutationFn = Apollo.MutationFunction<TUpdateCompanyMutation, TUpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _version: // value for '_version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateCompanyMutation, TUpdateCompanyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateCompanyMutation, TUpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
}
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<TUpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<TUpdateCompanyMutation, TUpdateCompanyMutationVariables>;
export const DeleteCompanyDocument = gql`
  mutation DeleteCompany($id: ID!, $_version: Int!) {
    deleteCompany(id: $id, _version: $_version) {
      ...CompanyFields
    }
  }
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TDeleteCompanyMutationFn = Apollo.MutationFunction<TDeleteCompanyMutation, TDeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _version: // value for '_version'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteCompanyMutation, TDeleteCompanyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteCompanyMutation, TDeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
}
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<TDeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<TDeleteCompanyMutation, TDeleteCompanyMutationVariables>;
export const OnAnyCompanyChangedDocument = gql`
  subscription OnAnyCompanyChanged {
    onAnyCompanyChanged {
      ...CompanyFields
    }
  }
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useOnAnyCompanyChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyCompanyChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyCompanyChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyCompanyChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyCompanyChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyCompanyChangedSubscription, TOnAnyCompanyChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyCompanyChangedSubscription, TOnAnyCompanyChangedSubscriptionVariables>(OnAnyCompanyChangedDocument, options);
}
export type OnAnyCompanyChangedSubscriptionHookResult = ReturnType<typeof useOnAnyCompanyChangedSubscription>;
export type OnAnyCompanyChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyCompanyChangedSubscription>;
export const ListAllCompaniesDocument = gql`
  query ListAllCompanies($nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection, $isScan: Boolean) {
    listAllCompanies(nextToken: $nextToken, limit: $limit, filter: $filter, order: $order, isScan: $isScan) {
      items {
        ...ListAllCompaniesFields
      }
      nextToken
    }
  }
  ${ListAllCompaniesFieldsFragmentDoc}
`;

/**
 * __useListAllCompaniesQuery__
 *
 * To run a query within a React component, call `useListAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllCompaniesQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      isScan: // value for 'isScan'
 *   },
 * });
 */
export function useListAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>(ListAllCompaniesDocument, options);
}
export function useListAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>(ListAllCompaniesDocument, options);
}
// @ts-ignore
export function useListAllCompaniesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>;
export function useListAllCompaniesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllCompaniesQuery | undefined, TListAllCompaniesQueryVariables>;
export function useListAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>(ListAllCompaniesDocument, options);
}
export type ListAllCompaniesQueryHookResult = ReturnType<typeof useListAllCompaniesQuery>;
export type ListAllCompaniesLazyQueryHookResult = ReturnType<typeof useListAllCompaniesLazyQuery>;
export type ListAllCompaniesSuspenseQueryHookResult = ReturnType<typeof useListAllCompaniesSuspenseQuery>;
export type ListAllCompaniesQueryResult = Apollo.QueryResult<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>;
export const ListAllCompaniesOptionsDocument = gql`
  query ListAllCompaniesOptions($nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection, $isScan: Boolean) {
    listAllCompanies(nextToken: $nextToken, limit: $limit, filter: $filter, order: $order, isScan: $isScan) {
      items {
        ...ListAllCompaniesOptionsFields
      }
      nextToken
    }
  }
  ${ListAllCompaniesOptionsFieldsFragmentDoc}
`;

/**
 * __useListAllCompaniesOptionsQuery__
 *
 * To run a query within a React component, call `useListAllCompaniesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllCompaniesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllCompaniesOptionsQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      isScan: // value for 'isScan'
 *   },
 * });
 */
export function useListAllCompaniesOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>(ListAllCompaniesOptionsDocument, options);
}
export function useListAllCompaniesOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>(ListAllCompaniesOptionsDocument, options);
}
// @ts-ignore
export function useListAllCompaniesOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>;
export function useListAllCompaniesOptionsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllCompaniesOptionsQuery | undefined, TListAllCompaniesOptionsQueryVariables>;
export function useListAllCompaniesOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>(ListAllCompaniesOptionsDocument, options);
}
export type ListAllCompaniesOptionsQueryHookResult = ReturnType<typeof useListAllCompaniesOptionsQuery>;
export type ListAllCompaniesOptionsLazyQueryHookResult = ReturnType<typeof useListAllCompaniesOptionsLazyQuery>;
export type ListAllCompaniesOptionsSuspenseQueryHookResult = ReturnType<typeof useListAllCompaniesOptionsSuspenseQuery>;
export type ListAllCompaniesOptionsQueryResult = Apollo.QueryResult<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>;
export const ListOneCompanyDocument = gql`
  query ListOneCompany($id: ID!, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection, $isScan: Boolean) {
    listOneCompany(id: $id, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order, isScan: $isScan) {
      items {
        ...ListOneCompanyFields
      }
      nextToken
    }
  }
  ${ListOneCompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListOneCompanyQuery__
 *
 * To run a query within a React component, call `useListOneCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      isScan: // value for 'isScan'
 *   },
 * });
 */
export function useListOneCompanyQuery(baseOptions: Apollo.QueryHookOptions<TListOneCompanyQuery, TListOneCompanyQueryVariables> & ({ variables: TListOneCompanyQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneCompanyQuery, TListOneCompanyQueryVariables>(ListOneCompanyDocument, options);
}
export function useListOneCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneCompanyQuery, TListOneCompanyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneCompanyQuery, TListOneCompanyQueryVariables>(ListOneCompanyDocument, options);
}
// @ts-ignore
export function useListOneCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneCompanyQuery, TListOneCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<TListOneCompanyQuery, TListOneCompanyQueryVariables>;
export function useListOneCompanySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneCompanyQuery, TListOneCompanyQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneCompanyQuery | undefined, TListOneCompanyQueryVariables>;
export function useListOneCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneCompanyQuery, TListOneCompanyQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneCompanyQuery, TListOneCompanyQueryVariables>(ListOneCompanyDocument, options);
}
export type ListOneCompanyQueryHookResult = ReturnType<typeof useListOneCompanyQuery>;
export type ListOneCompanyLazyQueryHookResult = ReturnType<typeof useListOneCompanyLazyQuery>;
export type ListOneCompanySuspenseQueryHookResult = ReturnType<typeof useListOneCompanySuspenseQuery>;
export type ListOneCompanyQueryResult = Apollo.QueryResult<TListOneCompanyQuery, TListOneCompanyQueryVariables>;
export const SoftDeleteCompanyDocument = gql`
  mutation SoftDeleteCompany($id: ID!, $_version: Int!) {
    softDeleteCompany(id: $id, _version: $_version) {
      ...CompanyFields
    }
  }
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TSoftDeleteCompanyMutationFn = Apollo.MutationFunction<TSoftDeleteCompanyMutation, TSoftDeleteCompanyMutationVariables>;

/**
 * __useSoftDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useSoftDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteCompanyMutation, { data, loading, error }] = useSoftDeleteCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _version: // value for '_version'
 *   },
 * });
 */
export function useSoftDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<TSoftDeleteCompanyMutation, TSoftDeleteCompanyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TSoftDeleteCompanyMutation, TSoftDeleteCompanyMutationVariables>(SoftDeleteCompanyDocument, options);
}
export type SoftDeleteCompanyMutationHookResult = ReturnType<typeof useSoftDeleteCompanyMutation>;
export type SoftDeleteCompanyMutationResult = Apollo.MutationResult<TSoftDeleteCompanyMutation>;
export type SoftDeleteCompanyMutationOptions = Apollo.BaseMutationOptions<TSoftDeleteCompanyMutation, TSoftDeleteCompanyMutationVariables>;
export const RefreshCompanyEmployeeCountDocument = gql`
  mutation RefreshCompanyEmployeeCount($id: ID!) {
    refreshCompanyEmployeeCount(id: $id) {
      id
      _version
      employeeCount
    }
  }
`;
export type TRefreshCompanyEmployeeCountMutationFn = Apollo.MutationFunction<TRefreshCompanyEmployeeCountMutation, TRefreshCompanyEmployeeCountMutationVariables>;

/**
 * __useRefreshCompanyEmployeeCountMutation__
 *
 * To run a mutation, you first call `useRefreshCompanyEmployeeCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCompanyEmployeeCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCompanyEmployeeCountMutation, { data, loading, error }] = useRefreshCompanyEmployeeCountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshCompanyEmployeeCountMutation(baseOptions?: Apollo.MutationHookOptions<TRefreshCompanyEmployeeCountMutation, TRefreshCompanyEmployeeCountMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TRefreshCompanyEmployeeCountMutation, TRefreshCompanyEmployeeCountMutationVariables>(RefreshCompanyEmployeeCountDocument, options);
}
export type RefreshCompanyEmployeeCountMutationHookResult = ReturnType<typeof useRefreshCompanyEmployeeCountMutation>;
export type RefreshCompanyEmployeeCountMutationResult = Apollo.MutationResult<TRefreshCompanyEmployeeCountMutation>;
export type RefreshCompanyEmployeeCountMutationOptions = Apollo.BaseMutationOptions<TRefreshCompanyEmployeeCountMutation, TRefreshCompanyEmployeeCountMutationVariables>;
export const ListDependantsDocument = gql`
  query ListDependants($nextToken: String, $limit: Int, $order: OrderDirection) {
    listDependants(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...DependantFields
      }
    }
  }
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useListDependantsQuery__
 *
 * To run a query within a React component, call `useListDependantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDependantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDependantsQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListDependantsQuery(baseOptions?: Apollo.QueryHookOptions<TListDependantsQuery, TListDependantsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListDependantsQuery, TListDependantsQueryVariables>(ListDependantsDocument, options);
}
export function useListDependantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListDependantsQuery, TListDependantsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListDependantsQuery, TListDependantsQueryVariables>(ListDependantsDocument, options);
}
// @ts-ignore
export function useListDependantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListDependantsQuery, TListDependantsQueryVariables>): Apollo.UseSuspenseQueryResult<TListDependantsQuery, TListDependantsQueryVariables>;
export function useListDependantsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListDependantsQuery, TListDependantsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListDependantsQuery | undefined, TListDependantsQueryVariables>;
export function useListDependantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListDependantsQuery, TListDependantsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListDependantsQuery, TListDependantsQueryVariables>(ListDependantsDocument, options);
}
export type ListDependantsQueryHookResult = ReturnType<typeof useListDependantsQuery>;
export type ListDependantsLazyQueryHookResult = ReturnType<typeof useListDependantsLazyQuery>;
export type ListDependantsSuspenseQueryHookResult = ReturnType<typeof useListDependantsSuspenseQuery>;
export type ListDependantsQueryResult = Apollo.QueryResult<TListDependantsQuery, TListDependantsQueryVariables>;
export const ListEmployeeDependantsDocument = gql`
  query ListEmployeeDependants($companyId: ID!, $employeeId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listEmployeeDependants(companyId: $companyId, employeeId: $employeeId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...DependantFields
      }
    }
  }
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useListEmployeeDependantsQuery__
 *
 * To run a query within a React component, call `useListEmployeeDependantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeeDependantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeeDependantsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      employeeId: // value for 'employeeId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListEmployeeDependantsQuery(
  baseOptions: Apollo.QueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables> & ({ variables: TListEmployeeDependantsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>(ListEmployeeDependantsDocument, options);
}
export function useListEmployeeDependantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>(ListEmployeeDependantsDocument, options);
}
// @ts-ignore
export function useListEmployeeDependantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>;
export function useListEmployeeDependantsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeDependantsQuery | undefined, TListEmployeeDependantsQueryVariables>;
export function useListEmployeeDependantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>(ListEmployeeDependantsDocument, options);
}
export type ListEmployeeDependantsQueryHookResult = ReturnType<typeof useListEmployeeDependantsQuery>;
export type ListEmployeeDependantsLazyQueryHookResult = ReturnType<typeof useListEmployeeDependantsLazyQuery>;
export type ListEmployeeDependantsSuspenseQueryHookResult = ReturnType<typeof useListEmployeeDependantsSuspenseQuery>;
export type ListEmployeeDependantsQueryResult = Apollo.QueryResult<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>;
export const OnAnyDependantChangedDocument = gql`
  subscription OnAnyDependantChanged {
    onAnyDependantChanged {
      ...DependantFields
    }
  }
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useOnAnyDependantChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyDependantChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyDependantChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyDependantChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyDependantChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyDependantChangedSubscription, TOnAnyDependantChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyDependantChangedSubscription, TOnAnyDependantChangedSubscriptionVariables>(OnAnyDependantChangedDocument, options);
}
export type OnAnyDependantChangedSubscriptionHookResult = ReturnType<typeof useOnAnyDependantChangedSubscription>;
export type OnAnyDependantChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyDependantChangedSubscription>;
export const GetEmployeeDocument = gql`
  query GetEmployee($id: ID!, $companyId: ID!) {
    getEmployee(id: $id, companyId: $companyId) {
      ...EmployeeFieldsHydrated
    }
  }
  ${EmployeeFieldsHydratedFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables> & ({ variables: TGetEmployeeQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetEmployeeQuery, TGetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetEmployeeQuery, TGetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
// @ts-ignore
export function useGetEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<TGetEmployeeQuery, TGetEmployeeQueryVariables>;
export function useGetEmployeeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetEmployeeQuery | undefined, TGetEmployeeQueryVariables>;
export function useGetEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetEmployeeQuery, TGetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeSuspenseQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<TGetEmployeeQuery, TGetEmployeeQueryVariables>;
export const OnAnyEmployeeChangedDocument = gql`
  subscription OnAnyEmployeeChanged {
    onAnyEmployeeChanged {
      ...EmployeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useOnAnyEmployeeChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyEmployeeChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyEmployeeChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyEmployeeChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyEmployeeChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyEmployeeChangedSubscription, TOnAnyEmployeeChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyEmployeeChangedSubscription, TOnAnyEmployeeChangedSubscriptionVariables>(OnAnyEmployeeChangedDocument, options);
}
export type OnAnyEmployeeChangedSubscriptionHookResult = ReturnType<typeof useOnAnyEmployeeChangedSubscription>;
export type OnAnyEmployeeChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyEmployeeChangedSubscription>;
export const ListAllEmployeesDocument = gql`
  query ListAllEmployees($isScan: Boolean, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listAllEmployees(isScan: $isScan, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...ListAllEmployeesFields
        dependants {
          items {
            ...DependantFields
          }
        }
      }
    }
  }
  ${ListAllEmployeesFieldsFragmentDoc}
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useListAllEmployeesQuery__
 *
 * To run a query within a React component, call `useListAllEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllEmployeesQuery({
 *   variables: {
 *      isScan: // value for 'isScan'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAllEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>(ListAllEmployeesDocument, options);
}
export function useListAllEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>(ListAllEmployeesDocument, options);
}
// @ts-ignore
export function useListAllEmployeesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>;
export function useListAllEmployeesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllEmployeesQuery | undefined, TListAllEmployeesQueryVariables>;
export function useListAllEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>(ListAllEmployeesDocument, options);
}
export type ListAllEmployeesQueryHookResult = ReturnType<typeof useListAllEmployeesQuery>;
export type ListAllEmployeesLazyQueryHookResult = ReturnType<typeof useListAllEmployeesLazyQuery>;
export type ListAllEmployeesSuspenseQueryHookResult = ReturnType<typeof useListAllEmployeesSuspenseQuery>;
export type ListAllEmployeesQueryResult = Apollo.QueryResult<TListAllEmployeesQuery, TListAllEmployeesQueryVariables>;
export const ListOneEmployeeDocument = gql`
  query ListOneEmployee($id: ID!, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listOneEmployee(id: $id, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...ListOneEmployeeFields
      }
    }
  }
  ${ListOneEmployeeFieldsFragmentDoc}
`;

/**
 * __useListOneEmployeeQuery__
 *
 * To run a query within a React component, call `useListOneEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneEmployeeQuery(baseOptions: Apollo.QueryHookOptions<TListOneEmployeeQuery, TListOneEmployeeQueryVariables> & ({ variables: TListOneEmployeeQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneEmployeeQuery, TListOneEmployeeQueryVariables>(ListOneEmployeeDocument, options);
}
export function useListOneEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneEmployeeQuery, TListOneEmployeeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneEmployeeQuery, TListOneEmployeeQueryVariables>(ListOneEmployeeDocument, options);
}
// @ts-ignore
export function useListOneEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneEmployeeQuery, TListOneEmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<TListOneEmployeeQuery, TListOneEmployeeQueryVariables>;
export function useListOneEmployeeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneEmployeeQuery, TListOneEmployeeQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneEmployeeQuery | undefined, TListOneEmployeeQueryVariables>;
export function useListOneEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneEmployeeQuery, TListOneEmployeeQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneEmployeeQuery, TListOneEmployeeQueryVariables>(ListOneEmployeeDocument, options);
}
export type ListOneEmployeeQueryHookResult = ReturnType<typeof useListOneEmployeeQuery>;
export type ListOneEmployeeLazyQueryHookResult = ReturnType<typeof useListOneEmployeeLazyQuery>;
export type ListOneEmployeeSuspenseQueryHookResult = ReturnType<typeof useListOneEmployeeSuspenseQuery>;
export type ListOneEmployeeQueryResult = Apollo.QueryResult<TListOneEmployeeQuery, TListOneEmployeeQueryVariables>;
export const ListOneOfficeEmployeesDocument = gql`
  query ListOneOfficeEmployees($officeId: ID!, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listOneOfficeEmployees(officeId: $officeId, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...ListOneOfficeEmployeesFields
      }
    }
  }
  ${ListOneOfficeEmployeesFieldsFragmentDoc}
`;

/**
 * __useListOneOfficeEmployeesQuery__
 *
 * To run a query within a React component, call `useListOneOfficeEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneOfficeEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneOfficeEmployeesQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneOfficeEmployeesQuery(
  baseOptions: Apollo.QueryHookOptions<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables> & ({ variables: TListOneOfficeEmployeesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables>(ListOneOfficeEmployeesDocument, options);
}
export function useListOneOfficeEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables>(ListOneOfficeEmployeesDocument, options);
}
// @ts-ignore
export function useListOneOfficeEmployeesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables>;
export function useListOneOfficeEmployeesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneOfficeEmployeesQuery | undefined, TListOneOfficeEmployeesQueryVariables>;
export function useListOneOfficeEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables>(ListOneOfficeEmployeesDocument, options);
}
export type ListOneOfficeEmployeesQueryHookResult = ReturnType<typeof useListOneOfficeEmployeesQuery>;
export type ListOneOfficeEmployeesLazyQueryHookResult = ReturnType<typeof useListOneOfficeEmployeesLazyQuery>;
export type ListOneOfficeEmployeesSuspenseQueryHookResult = ReturnType<typeof useListOneOfficeEmployeesSuspenseQuery>;
export type ListOneOfficeEmployeesQueryResult = Apollo.QueryResult<TListOneOfficeEmployeesQuery, TListOneOfficeEmployeesQueryVariables>;
export const ListOneCompanyEmployeesDocument = gql`
  query ListOneCompanyEmployees($companyId: ID!, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listOneCompanyEmployees(companyId: $companyId, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...ListOneCompanyEmployeesFields
      }
    }
  }
  ${ListOneCompanyEmployeesFieldsFragmentDoc}
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useListOneCompanyEmployeesQuery__
 *
 * To run a query within a React component, call `useListOneCompanyEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneCompanyEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneCompanyEmployeesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneCompanyEmployeesQuery(
  baseOptions: Apollo.QueryHookOptions<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables> & ({ variables: TListOneCompanyEmployeesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables>(ListOneCompanyEmployeesDocument, options);
}
export function useListOneCompanyEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables>(ListOneCompanyEmployeesDocument, options);
}
// @ts-ignore
export function useListOneCompanyEmployeesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables>;
export function useListOneCompanyEmployeesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneCompanyEmployeesQuery | undefined, TListOneCompanyEmployeesQueryVariables>;
export function useListOneCompanyEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables>(ListOneCompanyEmployeesDocument, options);
}
export type ListOneCompanyEmployeesQueryHookResult = ReturnType<typeof useListOneCompanyEmployeesQuery>;
export type ListOneCompanyEmployeesLazyQueryHookResult = ReturnType<typeof useListOneCompanyEmployeesLazyQuery>;
export type ListOneCompanyEmployeesSuspenseQueryHookResult = ReturnType<typeof useListOneCompanyEmployeesSuspenseQuery>;
export type ListOneCompanyEmployeesQueryResult = Apollo.QueryResult<TListOneCompanyEmployeesQuery, TListOneCompanyEmployeesQueryVariables>;
export const GetEventDocument = gql`
  query GetEvent($id: ID!, $companyId: ID!) {
    getEvent(id: $id, companyId: $companyId) {
      ...EventFields
    }
  }
  ${EventFieldsFragmentDoc}
`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<TGetEventQuery, TGetEventQueryVariables> & ({ variables: TGetEventQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetEventQuery, TGetEventQueryVariables>(GetEventDocument, options);
}
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetEventQuery, TGetEventQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetEventQuery, TGetEventQueryVariables>(GetEventDocument, options);
}
// @ts-ignore
export function useGetEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetEventQuery, TGetEventQueryVariables>): Apollo.UseSuspenseQueryResult<TGetEventQuery, TGetEventQueryVariables>;
export function useGetEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetEventQuery, TGetEventQueryVariables>): Apollo.UseSuspenseQueryResult<TGetEventQuery | undefined, TGetEventQueryVariables>;
export function useGetEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetEventQuery, TGetEventQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetEventQuery, TGetEventQueryVariables>(GetEventDocument, options);
}
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventSuspenseQueryHookResult = ReturnType<typeof useGetEventSuspenseQuery>;
export type GetEventQueryResult = Apollo.QueryResult<TGetEventQuery, TGetEventQueryVariables>;
export const ListNotSkippedEventsWithoutGiftDocument = gql`
  query ListNotSkippedEventsWithoutGift($nextToken: String, $limit: Int, $order: OrderDirection) {
    listNotSkippedEventsWithoutGift(nextToken: $nextToken, limit: $limit, order: $order) @connection(key: "listOpenEvents", filter: []) {
      nextToken
      items {
        ...EventFields
      }
    }
  }
  ${EventFieldsFragmentDoc}
`;

/**
 * __useListNotSkippedEventsWithoutGiftQuery__
 *
 * To run a query within a React component, call `useListNotSkippedEventsWithoutGiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotSkippedEventsWithoutGiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotSkippedEventsWithoutGiftQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListNotSkippedEventsWithoutGiftQuery(baseOptions?: Apollo.QueryHookOptions<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>(ListNotSkippedEventsWithoutGiftDocument, options);
}
export function useListNotSkippedEventsWithoutGiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>(ListNotSkippedEventsWithoutGiftDocument, options);
}
// @ts-ignore
export function useListNotSkippedEventsWithoutGiftSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>
): Apollo.UseSuspenseQueryResult<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>;
export function useListNotSkippedEventsWithoutGiftSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>
): Apollo.UseSuspenseQueryResult<TListNotSkippedEventsWithoutGiftQuery | undefined, TListNotSkippedEventsWithoutGiftQueryVariables>;
export function useListNotSkippedEventsWithoutGiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>(ListNotSkippedEventsWithoutGiftDocument, options);
}
export type ListNotSkippedEventsWithoutGiftQueryHookResult = ReturnType<typeof useListNotSkippedEventsWithoutGiftQuery>;
export type ListNotSkippedEventsWithoutGiftLazyQueryHookResult = ReturnType<typeof useListNotSkippedEventsWithoutGiftLazyQuery>;
export type ListNotSkippedEventsWithoutGiftSuspenseQueryHookResult = ReturnType<typeof useListNotSkippedEventsWithoutGiftSuspenseQuery>;
export type ListNotSkippedEventsWithoutGiftQueryResult = Apollo.QueryResult<TListNotSkippedEventsWithoutGiftQuery, TListNotSkippedEventsWithoutGiftQueryVariables>;
export const ListSkippedEventsDocument = gql`
  query ListSkippedEvents($nextToken: String, $limit: Int, $order: OrderDirection) {
    listSkippedEvents(nextToken: $nextToken, limit: $limit, order: $order) @connection(key: "listSkippedEvents", filter: []) {
      nextToken
      items {
        ...EventFields
      }
    }
  }
  ${EventFieldsFragmentDoc}
`;

/**
 * __useListSkippedEventsQuery__
 *
 * To run a query within a React component, call `useListSkippedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSkippedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSkippedEventsQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListSkippedEventsQuery(baseOptions?: Apollo.QueryHookOptions<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>(ListSkippedEventsDocument, options);
}
export function useListSkippedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>(ListSkippedEventsDocument, options);
}
// @ts-ignore
export function useListSkippedEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>;
export function useListSkippedEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListSkippedEventsQuery | undefined, TListSkippedEventsQueryVariables>;
export function useListSkippedEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>(ListSkippedEventsDocument, options);
}
export type ListSkippedEventsQueryHookResult = ReturnType<typeof useListSkippedEventsQuery>;
export type ListSkippedEventsLazyQueryHookResult = ReturnType<typeof useListSkippedEventsLazyQuery>;
export type ListSkippedEventsSuspenseQueryHookResult = ReturnType<typeof useListSkippedEventsSuspenseQuery>;
export type ListSkippedEventsQueryResult = Apollo.QueryResult<TListSkippedEventsQuery, TListSkippedEventsQueryVariables>;
export const ListEmployeeReferenceEventsDocument = gql`
  query ListEmployeeReferenceEvents($employeeId: ID!, $companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listEmployeeReferenceEvents(employeeId: $employeeId, companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      items {
        ...ReferenceEventFields
      }
    }
  }
  ${ReferenceEventFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;

/**
 * __useListEmployeeReferenceEventsQuery__
 *
 * To run a query within a React component, call `useListEmployeeReferenceEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeeReferenceEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeeReferenceEventsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListEmployeeReferenceEventsQuery(
  baseOptions: Apollo.QueryHookOptions<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables> & ({ variables: TListEmployeeReferenceEventsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables>(ListEmployeeReferenceEventsDocument, options);
}
export function useListEmployeeReferenceEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables>(ListEmployeeReferenceEventsDocument, options);
}
// @ts-ignore
export function useListEmployeeReferenceEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables>;
export function useListEmployeeReferenceEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeReferenceEventsQuery | undefined, TListEmployeeReferenceEventsQueryVariables>;
export function useListEmployeeReferenceEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables>(ListEmployeeReferenceEventsDocument, options);
}
export type ListEmployeeReferenceEventsQueryHookResult = ReturnType<typeof useListEmployeeReferenceEventsQuery>;
export type ListEmployeeReferenceEventsLazyQueryHookResult = ReturnType<typeof useListEmployeeReferenceEventsLazyQuery>;
export type ListEmployeeReferenceEventsSuspenseQueryHookResult = ReturnType<typeof useListEmployeeReferenceEventsSuspenseQuery>;
export type ListEmployeeReferenceEventsQueryResult = Apollo.QueryResult<TListEmployeeReferenceEventsQuery, TListEmployeeReferenceEventsQueryVariables>;
export const CreateEventDocument = gql`
  mutation CreateEvent($input: CreateEventMutationInput!) {
    createEvent(input: $input) {
      ...EventFields
    }
  }
  ${EventFieldsFragmentDoc}
`;
export type TCreateEventMutationFn = Apollo.MutationFunction<TCreateEventMutation, TCreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<TCreateEventMutation, TCreateEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateEventMutation, TCreateEventMutationVariables>(CreateEventDocument, options);
}
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<TCreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<TCreateEventMutation, TCreateEventMutationVariables>;
export const DeleteEventDocument = gql`
  mutation DeleteEvent($id: ID!, $companyId: ID!, $version: Int!) {
    deleteEvent(id: $id, companyId: $companyId, _version: $version) {
      ...EventFields
    }
  }
  ${EventFieldsFragmentDoc}
`;
export type TDeleteEventMutationFn = Apollo.MutationFunction<TDeleteEventMutation, TDeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteEventMutation, TDeleteEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteEventMutation, TDeleteEventMutationVariables>(DeleteEventDocument, options);
}
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<TDeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<TDeleteEventMutation, TDeleteEventMutationVariables>;
export const CreateReferenceEventDocument = gql`
  mutation CreateReferenceEvent($input: CreateReferenceEventMutationInput!) {
    createReferenceEvent(input: $input) {
      ...ReferenceEventFields
    }
  }
  ${ReferenceEventFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;
export type TCreateReferenceEventMutationFn = Apollo.MutationFunction<TCreateReferenceEventMutation, TCreateReferenceEventMutationVariables>;

/**
 * __useCreateReferenceEventMutation__
 *
 * To run a mutation, you first call `useCreateReferenceEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferenceEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferenceEventMutation, { data, loading, error }] = useCreateReferenceEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReferenceEventMutation(baseOptions?: Apollo.MutationHookOptions<TCreateReferenceEventMutation, TCreateReferenceEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateReferenceEventMutation, TCreateReferenceEventMutationVariables>(CreateReferenceEventDocument, options);
}
export type CreateReferenceEventMutationHookResult = ReturnType<typeof useCreateReferenceEventMutation>;
export type CreateReferenceEventMutationResult = Apollo.MutationResult<TCreateReferenceEventMutation>;
export type CreateReferenceEventMutationOptions = Apollo.BaseMutationOptions<TCreateReferenceEventMutation, TCreateReferenceEventMutationVariables>;
export const SkipEventDocument = gql`
  mutation SkipEvent($id: ID!, $companyId: ID!, $version: Int!) {
    skipEvent(id: $id, companyId: $companyId, _version: $version) {
      ...EventFields
    }
  }
  ${EventFieldsFragmentDoc}
`;
export type TSkipEventMutationFn = Apollo.MutationFunction<TSkipEventMutation, TSkipEventMutationVariables>;

/**
 * __useSkipEventMutation__
 *
 * To run a mutation, you first call `useSkipEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipEventMutation, { data, loading, error }] = useSkipEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSkipEventMutation(baseOptions?: Apollo.MutationHookOptions<TSkipEventMutation, TSkipEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TSkipEventMutation, TSkipEventMutationVariables>(SkipEventDocument, options);
}
export type SkipEventMutationHookResult = ReturnType<typeof useSkipEventMutation>;
export type SkipEventMutationResult = Apollo.MutationResult<TSkipEventMutation>;
export type SkipEventMutationOptions = Apollo.BaseMutationOptions<TSkipEventMutation, TSkipEventMutationVariables>;
export const UnskipEventDocument = gql`
  mutation UnskipEvent($id: ID!, $companyId: ID!, $version: Int!) {
    unskipEvent(id: $id, companyId: $companyId, _version: $version) {
      ...EventFields
    }
  }
  ${EventFieldsFragmentDoc}
`;
export type TUnskipEventMutationFn = Apollo.MutationFunction<TUnskipEventMutation, TUnskipEventMutationVariables>;

/**
 * __useUnskipEventMutation__
 *
 * To run a mutation, you first call `useUnskipEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnskipEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unskipEventMutation, { data, loading, error }] = useUnskipEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUnskipEventMutation(baseOptions?: Apollo.MutationHookOptions<TUnskipEventMutation, TUnskipEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUnskipEventMutation, TUnskipEventMutationVariables>(UnskipEventDocument, options);
}
export type UnskipEventMutationHookResult = ReturnType<typeof useUnskipEventMutation>;
export type UnskipEventMutationResult = Apollo.MutationResult<TUnskipEventMutation>;
export type UnskipEventMutationOptions = Apollo.BaseMutationOptions<TUnskipEventMutation, TUnskipEventMutationVariables>;
export const OnAnyEventChangedDocument = gql`
  subscription OnAnyEventChanged {
    onAnyEventChanged {
      ...EventFields
    }
  }
  ${EventFieldsFragmentDoc}
`;

/**
 * __useOnAnyEventChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyEventChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyEventChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyEventChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyEventChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyEventChangedSubscription, TOnAnyEventChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyEventChangedSubscription, TOnAnyEventChangedSubscriptionVariables>(OnAnyEventChangedDocument, options);
}
export type OnAnyEventChangedSubscriptionHookResult = ReturnType<typeof useOnAnyEventChangedSubscription>;
export type OnAnyEventChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyEventChangedSubscription>;
export const CreateOneOffEventDocument = gql`
  mutation createOneOffEvent($input: AWSJSON!) {
    createOneOffEvent(input: $input) {
      status
      error
      message
      data
    }
  }
`;
export type TCreateOneOffEventMutationFn = Apollo.MutationFunction<TCreateOneOffEventMutation, TCreateOneOffEventMutationVariables>;

/**
 * __useCreateOneOffEventMutation__
 *
 * To run a mutation, you first call `useCreateOneOffEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneOffEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneOffEventMutation, { data, loading, error }] = useCreateOneOffEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneOffEventMutation(baseOptions?: Apollo.MutationHookOptions<TCreateOneOffEventMutation, TCreateOneOffEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateOneOffEventMutation, TCreateOneOffEventMutationVariables>(CreateOneOffEventDocument, options);
}
export type CreateOneOffEventMutationHookResult = ReturnType<typeof useCreateOneOffEventMutation>;
export type CreateOneOffEventMutationResult = Apollo.MutationResult<TCreateOneOffEventMutation>;
export type CreateOneOffEventMutationOptions = Apollo.BaseMutationOptions<TCreateOneOffEventMutation, TCreateOneOffEventMutationVariables>;
export const ListEventsDocument = gql`
  query ListEvents($type: String!, $eventPage: String!, $nextToken: String, $includingLastDays: Int, $includingNextDays: Int, $limit: Int, $order: OrderDirection) {
    listEvents(type: $type, eventPage: $eventPage, includingLastDays: $includingLastDays, includingNextDays: $includingNextDays, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...ListEventFields
      }
    }
  }
  ${ListEventFieldsFragmentDoc}
`;

/**
 * __useListEventsQuery__
 *
 * To run a query within a React component, call `useListEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      eventPage: // value for 'eventPage'
 *      nextToken: // value for 'nextToken'
 *      includingLastDays: // value for 'includingLastDays'
 *      includingNextDays: // value for 'includingNextDays'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListEventsQuery(baseOptions: Apollo.QueryHookOptions<TListEventsQuery, TListEventsQueryVariables> & ({ variables: TListEventsQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListEventsQuery, TListEventsQueryVariables>(ListEventsDocument, options);
}
export function useListEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListEventsQuery, TListEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListEventsQuery, TListEventsQueryVariables>(ListEventsDocument, options);
}
// @ts-ignore
export function useListEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListEventsQuery, TListEventsQueryVariables>): Apollo.UseSuspenseQueryResult<TListEventsQuery, TListEventsQueryVariables>;
export function useListEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEventsQuery, TListEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEventsQuery | undefined, TListEventsQueryVariables>;
export function useListEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEventsQuery, TListEventsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListEventsQuery, TListEventsQueryVariables>(ListEventsDocument, options);
}
export type ListEventsQueryHookResult = ReturnType<typeof useListEventsQuery>;
export type ListEventsLazyQueryHookResult = ReturnType<typeof useListEventsLazyQuery>;
export type ListEventsSuspenseQueryHookResult = ReturnType<typeof useListEventsSuspenseQuery>;
export type ListEventsQueryResult = Apollo.QueryResult<TListEventsQuery, TListEventsQueryVariables>;
export const ListClientOneOffEventsDocument = gql`
  query ListClientOneOffEvents($eventPage: String!, $nextToken: String, $includingLastDays: Int, $includingNextDays: Int, $filter: FilterInput, $limit: Int, $order: OrderDirection) {
    listClientOneOffEvents(eventPage: $eventPage, nextToken: $nextToken, includingLastDays: $includingLastDays, includingNextDays: $includingNextDays, filter: $filter, limit: $limit, order: $order) {
      nextToken
      items {
        ...ListEventFields
      }
    }
  }
  ${ListEventFieldsFragmentDoc}
`;

/**
 * __useListClientOneOffEventsQuery__
 *
 * To run a query within a React component, call `useListClientOneOffEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClientOneOffEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClientOneOffEventsQuery({
 *   variables: {
 *      eventPage: // value for 'eventPage'
 *      nextToken: // value for 'nextToken'
 *      includingLastDays: // value for 'includingLastDays'
 *      includingNextDays: // value for 'includingNextDays'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListClientOneOffEventsQuery(
  baseOptions: Apollo.QueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables> & ({ variables: TListClientOneOffEventsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>(ListClientOneOffEventsDocument, options);
}
export function useListClientOneOffEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>(ListClientOneOffEventsDocument, options);
}
// @ts-ignore
export function useListClientOneOffEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>;
export function useListClientOneOffEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListClientOneOffEventsQuery | undefined, TListClientOneOffEventsQueryVariables>;
export function useListClientOneOffEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>(ListClientOneOffEventsDocument, options);
}
export type ListClientOneOffEventsQueryHookResult = ReturnType<typeof useListClientOneOffEventsQuery>;
export type ListClientOneOffEventsLazyQueryHookResult = ReturnType<typeof useListClientOneOffEventsLazyQuery>;
export type ListClientOneOffEventsSuspenseQueryHookResult = ReturnType<typeof useListClientOneOffEventsSuspenseQuery>;
export type ListClientOneOffEventsQueryResult = Apollo.QueryResult<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>;
export const ListSkippedEventsNewDocument = gql`
  query ListSkippedEventsNew($eventPage: String!, $includingLastDays: Int, $includingNextDays: Int, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listSkippedEventsNew(eventPage: $eventPage, includingLastDays: $includingLastDays, includingNextDays: $includingNextDays, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...ListEventFields
      }
    }
  }
  ${ListEventFieldsFragmentDoc}
`;

/**
 * __useListSkippedEventsNewQuery__
 *
 * To run a query within a React component, call `useListSkippedEventsNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSkippedEventsNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSkippedEventsNewQuery({
 *   variables: {
 *      eventPage: // value for 'eventPage'
 *      includingLastDays: // value for 'includingLastDays'
 *      includingNextDays: // value for 'includingNextDays'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListSkippedEventsNewQuery(baseOptions: Apollo.QueryHookOptions<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables> & ({ variables: TListSkippedEventsNewQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables>(ListSkippedEventsNewDocument, options);
}
export function useListSkippedEventsNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables>(ListSkippedEventsNewDocument, options);
}
// @ts-ignore
export function useListSkippedEventsNewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables>
): Apollo.UseSuspenseQueryResult<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables>;
export function useListSkippedEventsNewSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables>
): Apollo.UseSuspenseQueryResult<TListSkippedEventsNewQuery | undefined, TListSkippedEventsNewQueryVariables>;
export function useListSkippedEventsNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables>(ListSkippedEventsNewDocument, options);
}
export type ListSkippedEventsNewQueryHookResult = ReturnType<typeof useListSkippedEventsNewQuery>;
export type ListSkippedEventsNewLazyQueryHookResult = ReturnType<typeof useListSkippedEventsNewLazyQuery>;
export type ListSkippedEventsNewSuspenseQueryHookResult = ReturnType<typeof useListSkippedEventsNewSuspenseQuery>;
export type ListSkippedEventsNewQueryResult = Apollo.QueryResult<TListSkippedEventsNewQuery, TListSkippedEventsNewQueryVariables>;
export const SearchEventsByRecipientDocument = gql`
  query SearchEventsByRecipient($companyId: ID, $recipientName: String!, $eventPage: String, $type: String, $includingLastDays: Int, $includingNextDays: Int) {
    searchEventsByRecipient(companyId: $companyId, recipientName: $recipientName, eventPage: $eventPage, type: $type, includingLastDays: $includingLastDays, includingNextDays: $includingNextDays) {
      nextToken
      items {
        ...ListEventFields
      }
    }
  }
  ${ListEventFieldsFragmentDoc}
`;

/**
 * __useSearchEventsByRecipientQuery__
 *
 * To run a query within a React component, call `useSearchEventsByRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventsByRecipientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventsByRecipientQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      recipientName: // value for 'recipientName'
 *      eventPage: // value for 'eventPage'
 *      type: // value for 'type'
 *      includingLastDays: // value for 'includingLastDays'
 *      includingNextDays: // value for 'includingNextDays'
 *   },
 * });
 */
export function useSearchEventsByRecipientQuery(
  baseOptions: Apollo.QueryHookOptions<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables> & ({ variables: TSearchEventsByRecipientQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables>(SearchEventsByRecipientDocument, options);
}
export function useSearchEventsByRecipientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables>(SearchEventsByRecipientDocument, options);
}
// @ts-ignore
export function useSearchEventsByRecipientSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables>
): Apollo.UseSuspenseQueryResult<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables>;
export function useSearchEventsByRecipientSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables>
): Apollo.UseSuspenseQueryResult<TSearchEventsByRecipientQuery | undefined, TSearchEventsByRecipientQueryVariables>;
export function useSearchEventsByRecipientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables>(SearchEventsByRecipientDocument, options);
}
export type SearchEventsByRecipientQueryHookResult = ReturnType<typeof useSearchEventsByRecipientQuery>;
export type SearchEventsByRecipientLazyQueryHookResult = ReturnType<typeof useSearchEventsByRecipientLazyQuery>;
export type SearchEventsByRecipientSuspenseQueryHookResult = ReturnType<typeof useSearchEventsByRecipientSuspenseQuery>;
export type SearchEventsByRecipientQueryResult = Apollo.QueryResult<TSearchEventsByRecipientQuery, TSearchEventsByRecipientQueryVariables>;
export const GetGiftPackageDocument = gql`
  query GetGiftPackage($id: ID!) {
    getGiftPackage(id: $id) {
      ...GiftPackageFields
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;

/**
 * __useGetGiftPackageQuery__
 *
 * To run a query within a React component, call `useGetGiftPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGiftPackageQuery(baseOptions: Apollo.QueryHookOptions<TGetGiftPackageQuery, TGetGiftPackageQueryVariables> & ({ variables: TGetGiftPackageQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetGiftPackageQuery, TGetGiftPackageQueryVariables>(GetGiftPackageDocument, options);
}
export function useGetGiftPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetGiftPackageQuery, TGetGiftPackageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetGiftPackageQuery, TGetGiftPackageQueryVariables>(GetGiftPackageDocument, options);
}
// @ts-ignore
export function useGetGiftPackageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetGiftPackageQuery, TGetGiftPackageQueryVariables>): Apollo.UseSuspenseQueryResult<TGetGiftPackageQuery, TGetGiftPackageQueryVariables>;
export function useGetGiftPackageSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetGiftPackageQuery, TGetGiftPackageQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetGiftPackageQuery | undefined, TGetGiftPackageQueryVariables>;
export function useGetGiftPackageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetGiftPackageQuery, TGetGiftPackageQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetGiftPackageQuery, TGetGiftPackageQueryVariables>(GetGiftPackageDocument, options);
}
export type GetGiftPackageQueryHookResult = ReturnType<typeof useGetGiftPackageQuery>;
export type GetGiftPackageLazyQueryHookResult = ReturnType<typeof useGetGiftPackageLazyQuery>;
export type GetGiftPackageSuspenseQueryHookResult = ReturnType<typeof useGetGiftPackageSuspenseQuery>;
export type GetGiftPackageQueryResult = Apollo.QueryResult<TGetGiftPackageQuery, TGetGiftPackageQueryVariables>;
export const CreateGiftPackageDocument = gql`
  mutation CreateGiftPackage($input: CreateGiftPackageMutationInput!) {
    createGiftPackage(input: $input) {
      ...GiftPackageFields
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;
export type TCreateGiftPackageMutationFn = Apollo.MutationFunction<TCreateGiftPackageMutation, TCreateGiftPackageMutationVariables>;

/**
 * __useCreateGiftPackageMutation__
 *
 * To run a mutation, you first call `useCreateGiftPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftPackageMutation, { data, loading, error }] = useCreateGiftPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGiftPackageMutation(baseOptions?: Apollo.MutationHookOptions<TCreateGiftPackageMutation, TCreateGiftPackageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateGiftPackageMutation, TCreateGiftPackageMutationVariables>(CreateGiftPackageDocument, options);
}
export type CreateGiftPackageMutationHookResult = ReturnType<typeof useCreateGiftPackageMutation>;
export type CreateGiftPackageMutationResult = Apollo.MutationResult<TCreateGiftPackageMutation>;
export type CreateGiftPackageMutationOptions = Apollo.BaseMutationOptions<TCreateGiftPackageMutation, TCreateGiftPackageMutationVariables>;
export const UpdateGiftPackageDocument = gql`
  mutation UpdateGiftPackage($id: ID!, $version: Int!, $input: UpdateGiftPackageMutationInput!) {
    updateGiftPackage(id: $id, _version: $version, input: $input) {
      ...GiftPackageFields
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;
export type TUpdateGiftPackageMutationFn = Apollo.MutationFunction<TUpdateGiftPackageMutation, TUpdateGiftPackageMutationVariables>;

/**
 * __useUpdateGiftPackageMutation__
 *
 * To run a mutation, you first call `useUpdateGiftPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGiftPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGiftPackageMutation, { data, loading, error }] = useUpdateGiftPackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGiftPackageMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateGiftPackageMutation, TUpdateGiftPackageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateGiftPackageMutation, TUpdateGiftPackageMutationVariables>(UpdateGiftPackageDocument, options);
}
export type UpdateGiftPackageMutationHookResult = ReturnType<typeof useUpdateGiftPackageMutation>;
export type UpdateGiftPackageMutationResult = Apollo.MutationResult<TUpdateGiftPackageMutation>;
export type UpdateGiftPackageMutationOptions = Apollo.BaseMutationOptions<TUpdateGiftPackageMutation, TUpdateGiftPackageMutationVariables>;
export const DeleteGiftPackageDocument = gql`
  mutation DeleteGiftPackage($id: ID!, $version: Int!) {
    deleteGiftPackage(id: $id, _version: $version) {
      ...GiftPackageFields
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;
export type TDeleteGiftPackageMutationFn = Apollo.MutationFunction<TDeleteGiftPackageMutation, TDeleteGiftPackageMutationVariables>;

/**
 * __useDeleteGiftPackageMutation__
 *
 * To run a mutation, you first call `useDeleteGiftPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGiftPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGiftPackageMutation, { data, loading, error }] = useDeleteGiftPackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteGiftPackageMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteGiftPackageMutation, TDeleteGiftPackageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteGiftPackageMutation, TDeleteGiftPackageMutationVariables>(DeleteGiftPackageDocument, options);
}
export type DeleteGiftPackageMutationHookResult = ReturnType<typeof useDeleteGiftPackageMutation>;
export type DeleteGiftPackageMutationResult = Apollo.MutationResult<TDeleteGiftPackageMutation>;
export type DeleteGiftPackageMutationOptions = Apollo.BaseMutationOptions<TDeleteGiftPackageMutation, TDeleteGiftPackageMutationVariables>;
export const OnAnyGiftPackageChangedDocument = gql`
  subscription OnAnyGiftPackageChanged {
    onAnyGiftPackageChanged {
      ...GiftPackageFields
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;

/**
 * __useOnAnyGiftPackageChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyGiftPackageChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyGiftPackageChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyGiftPackageChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyGiftPackageChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyGiftPackageChangedSubscription, TOnAnyGiftPackageChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyGiftPackageChangedSubscription, TOnAnyGiftPackageChangedSubscriptionVariables>(OnAnyGiftPackageChangedDocument, options);
}
export type OnAnyGiftPackageChangedSubscriptionHookResult = ReturnType<typeof useOnAnyGiftPackageChangedSubscription>;
export type OnAnyGiftPackageChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyGiftPackageChangedSubscription>;
export const ListGiftPackagesDocument = gql`
  query ListGiftPackages($isScan: Boolean, $filter: FilterInput, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listGiftPackages(isScan: $isScan, filter: $filter, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftPackageFields
      }
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;

/**
 * __useListGiftPackagesQuery__
 *
 * To run a query within a React component, call `useListGiftPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGiftPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGiftPackagesQuery({
 *   variables: {
 *      isScan: // value for 'isScan'
 *      filter: // value for 'filter'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListGiftPackagesQuery(baseOptions?: Apollo.QueryHookOptions<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>(ListGiftPackagesDocument, options);
}
export function useListGiftPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>(ListGiftPackagesDocument, options);
}
// @ts-ignore
export function useListGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>;
export function useListGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListGiftPackagesQuery | undefined, TListGiftPackagesQueryVariables>;
export function useListGiftPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>(ListGiftPackagesDocument, options);
}
export type ListGiftPackagesQueryHookResult = ReturnType<typeof useListGiftPackagesQuery>;
export type ListGiftPackagesLazyQueryHookResult = ReturnType<typeof useListGiftPackagesLazyQuery>;
export type ListGiftPackagesSuspenseQueryHookResult = ReturnType<typeof useListGiftPackagesSuspenseQuery>;
export type ListGiftPackagesQueryResult = Apollo.QueryResult<TListGiftPackagesQuery, TListGiftPackagesQueryVariables>;
export const ListDefaultGiftPackagesDocument = gql`
  query ListDefaultGiftPackages($filter: FilterInput, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listDefaultGiftPackages(filter: $filter, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftPackageFields
      }
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;

/**
 * __useListDefaultGiftPackagesQuery__
 *
 * To run a query within a React component, call `useListDefaultGiftPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDefaultGiftPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDefaultGiftPackagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListDefaultGiftPackagesQuery(baseOptions?: Apollo.QueryHookOptions<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>(ListDefaultGiftPackagesDocument, options);
}
export function useListDefaultGiftPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>(ListDefaultGiftPackagesDocument, options);
}
// @ts-ignore
export function useListDefaultGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>;
export function useListDefaultGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListDefaultGiftPackagesQuery | undefined, TListDefaultGiftPackagesQueryVariables>;
export function useListDefaultGiftPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>(ListDefaultGiftPackagesDocument, options);
}
export type ListDefaultGiftPackagesQueryHookResult = ReturnType<typeof useListDefaultGiftPackagesQuery>;
export type ListDefaultGiftPackagesLazyQueryHookResult = ReturnType<typeof useListDefaultGiftPackagesLazyQuery>;
export type ListDefaultGiftPackagesSuspenseQueryHookResult = ReturnType<typeof useListDefaultGiftPackagesSuspenseQuery>;
export type ListDefaultGiftPackagesQueryResult = Apollo.QueryResult<TListDefaultGiftPackagesQuery, TListDefaultGiftPackagesQueryVariables>;
export const ListOneGiftPackageDocument = gql`
  query ListOneGiftPackage($id: ID!, $filter: FilterInput, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listOneGiftPackage(id: $id, filter: $filter, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftPackageFields
      }
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;

/**
 * __useListOneGiftPackageQuery__
 *
 * To run a query within a React component, call `useListOneGiftPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneGiftPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneGiftPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneGiftPackageQuery(baseOptions: Apollo.QueryHookOptions<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables> & ({ variables: TListOneGiftPackageQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables>(ListOneGiftPackageDocument, options);
}
export function useListOneGiftPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables>(ListOneGiftPackageDocument, options);
}
// @ts-ignore
export function useListOneGiftPackageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables>;
export function useListOneGiftPackageSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneGiftPackageQuery | undefined, TListOneGiftPackageQueryVariables>;
export function useListOneGiftPackageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables>(ListOneGiftPackageDocument, options);
}
export type ListOneGiftPackageQueryHookResult = ReturnType<typeof useListOneGiftPackageQuery>;
export type ListOneGiftPackageLazyQueryHookResult = ReturnType<typeof useListOneGiftPackageLazyQuery>;
export type ListOneGiftPackageSuspenseQueryHookResult = ReturnType<typeof useListOneGiftPackageSuspenseQuery>;
export type ListOneGiftPackageQueryResult = Apollo.QueryResult<TListOneGiftPackageQuery, TListOneGiftPackageQueryVariables>;
export const ListOneCompanyGiftPackagesDocument = gql`
  query ListOneCompanyGiftPackages($companyId: ID!, $filter: FilterInput, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listOneCompanyGiftPackages(companyId: $companyId, filter: $filter, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftPackageFields
      }
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;

/**
 * __useListOneCompanyGiftPackagesQuery__
 *
 * To run a query within a React component, call `useListOneCompanyGiftPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneCompanyGiftPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneCompanyGiftPackagesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filter: // value for 'filter'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneCompanyGiftPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables> & ({ variables: TListOneCompanyGiftPackagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables>(ListOneCompanyGiftPackagesDocument, options);
}
export function useListOneCompanyGiftPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables>(ListOneCompanyGiftPackagesDocument, options);
}
// @ts-ignore
export function useListOneCompanyGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables>;
export function useListOneCompanyGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneCompanyGiftPackagesQuery | undefined, TListOneCompanyGiftPackagesQueryVariables>;
export function useListOneCompanyGiftPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables>(ListOneCompanyGiftPackagesDocument, options);
}
export type ListOneCompanyGiftPackagesQueryHookResult = ReturnType<typeof useListOneCompanyGiftPackagesQuery>;
export type ListOneCompanyGiftPackagesLazyQueryHookResult = ReturnType<typeof useListOneCompanyGiftPackagesLazyQuery>;
export type ListOneCompanyGiftPackagesSuspenseQueryHookResult = ReturnType<typeof useListOneCompanyGiftPackagesSuspenseQuery>;
export type ListOneCompanyGiftPackagesQueryResult = Apollo.QueryResult<TListOneCompanyGiftPackagesQuery, TListOneCompanyGiftPackagesQueryVariables>;
export const ListOneTypeGiftPackagesDocument = gql`
  query ListOneTypeGiftPackages($type: String!, $filter: FilterInput, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listOneTypeGiftPackages(type: $type, filter: $filter, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftPackageFields
      }
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;

/**
 * __useListOneTypeGiftPackagesQuery__
 *
 * To run a query within a React component, call `useListOneTypeGiftPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneTypeGiftPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneTypeGiftPackagesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      filter: // value for 'filter'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneTypeGiftPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables> & ({ variables: TListOneTypeGiftPackagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables>(ListOneTypeGiftPackagesDocument, options);
}
export function useListOneTypeGiftPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables>(ListOneTypeGiftPackagesDocument, options);
}
// @ts-ignore
export function useListOneTypeGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables>;
export function useListOneTypeGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneTypeGiftPackagesQuery | undefined, TListOneTypeGiftPackagesQueryVariables>;
export function useListOneTypeGiftPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables>(ListOneTypeGiftPackagesDocument, options);
}
export type ListOneTypeGiftPackagesQueryHookResult = ReturnType<typeof useListOneTypeGiftPackagesQuery>;
export type ListOneTypeGiftPackagesLazyQueryHookResult = ReturnType<typeof useListOneTypeGiftPackagesLazyQuery>;
export type ListOneTypeGiftPackagesSuspenseQueryHookResult = ReturnType<typeof useListOneTypeGiftPackagesSuspenseQuery>;
export type ListOneTypeGiftPackagesQueryResult = Apollo.QueryResult<TListOneTypeGiftPackagesQuery, TListOneTypeGiftPackagesQueryVariables>;
export const ListOneSubTypeGiftPackagesDocument = gql`
  query ListOneSubTypeGiftPackages($subType: String!, $filter: FilterInput, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listOneSubTypeGiftPackages(subType: $subType, filter: $filter, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftPackageFields
      }
    }
  }
  ${GiftPackageFieldsFragmentDoc}
`;

/**
 * __useListOneSubTypeGiftPackagesQuery__
 *
 * To run a query within a React component, call `useListOneSubTypeGiftPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneSubTypeGiftPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneSubTypeGiftPackagesQuery({
 *   variables: {
 *      subType: // value for 'subType'
 *      filter: // value for 'filter'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneSubTypeGiftPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables> & ({ variables: TListOneSubTypeGiftPackagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables>(ListOneSubTypeGiftPackagesDocument, options);
}
export function useListOneSubTypeGiftPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables>(ListOneSubTypeGiftPackagesDocument, options);
}
// @ts-ignore
export function useListOneSubTypeGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables>;
export function useListOneSubTypeGiftPackagesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneSubTypeGiftPackagesQuery | undefined, TListOneSubTypeGiftPackagesQueryVariables>;
export function useListOneSubTypeGiftPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables>(ListOneSubTypeGiftPackagesDocument, options);
}
export type ListOneSubTypeGiftPackagesQueryHookResult = ReturnType<typeof useListOneSubTypeGiftPackagesQuery>;
export type ListOneSubTypeGiftPackagesLazyQueryHookResult = ReturnType<typeof useListOneSubTypeGiftPackagesLazyQuery>;
export type ListOneSubTypeGiftPackagesSuspenseQueryHookResult = ReturnType<typeof useListOneSubTypeGiftPackagesSuspenseQuery>;
export type ListOneSubTypeGiftPackagesQueryResult = Apollo.QueryResult<TListOneSubTypeGiftPackagesQuery, TListOneSubTypeGiftPackagesQueryVariables>;
export const ListEmployeeAndDependatsGiftsDocument = gql`
  query ListEmployeeAndDependatsGifts($employeeId: ID!, $companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listEmployeeAndDependatsGifts(employeeId: $employeeId, companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftFieldsHydrated
      }
    }
  }
  ${GiftFieldsHydratedFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListEmployeeAndDependatsGiftsQuery__
 *
 * To run a query within a React component, call `useListEmployeeAndDependatsGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeeAndDependatsGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeeAndDependatsGiftsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListEmployeeAndDependatsGiftsQuery(
  baseOptions: Apollo.QueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables> & ({ variables: TListEmployeeAndDependatsGiftsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>(ListEmployeeAndDependatsGiftsDocument, options);
}
export function useListEmployeeAndDependatsGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>(ListEmployeeAndDependatsGiftsDocument, options);
}
// @ts-ignore
export function useListEmployeeAndDependatsGiftsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>;
export function useListEmployeeAndDependatsGiftsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeAndDependatsGiftsQuery | undefined, TListEmployeeAndDependatsGiftsQueryVariables>;
export function useListEmployeeAndDependatsGiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>(ListEmployeeAndDependatsGiftsDocument, options);
}
export type ListEmployeeAndDependatsGiftsQueryHookResult = ReturnType<typeof useListEmployeeAndDependatsGiftsQuery>;
export type ListEmployeeAndDependatsGiftsLazyQueryHookResult = ReturnType<typeof useListEmployeeAndDependatsGiftsLazyQuery>;
export type ListEmployeeAndDependatsGiftsSuspenseQueryHookResult = ReturnType<typeof useListEmployeeAndDependatsGiftsSuspenseQuery>;
export type ListEmployeeAndDependatsGiftsQueryResult = Apollo.QueryResult<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>;
export const ListNotDoneGiftsDocument = gql`
  query ListNotDoneGifts($nextToken: String, $limit: Int, $order: OrderDirection) {
    listNotDoneGifts(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftFields
      }
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;

/**
 * __useListNotDoneGiftsQuery__
 *
 * To run a query within a React component, call `useListNotDoneGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotDoneGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotDoneGiftsQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListNotDoneGiftsQuery(baseOptions?: Apollo.QueryHookOptions<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>(ListNotDoneGiftsDocument, options);
}
export function useListNotDoneGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>(ListNotDoneGiftsDocument, options);
}
// @ts-ignore
export function useListNotDoneGiftsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>;
export function useListNotDoneGiftsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListNotDoneGiftsQuery | undefined, TListNotDoneGiftsQueryVariables>;
export function useListNotDoneGiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>(ListNotDoneGiftsDocument, options);
}
export type ListNotDoneGiftsQueryHookResult = ReturnType<typeof useListNotDoneGiftsQuery>;
export type ListNotDoneGiftsLazyQueryHookResult = ReturnType<typeof useListNotDoneGiftsLazyQuery>;
export type ListNotDoneGiftsSuspenseQueryHookResult = ReturnType<typeof useListNotDoneGiftsSuspenseQuery>;
export type ListNotDoneGiftsQueryResult = Apollo.QueryResult<TListNotDoneGiftsQuery, TListNotDoneGiftsQueryVariables>;
export const ListRecentlyDoneGiftsDocument = gql`
  query ListRecentlyDoneGifts($nextToken: String, $limit: Int, $order: OrderDirection) {
    listRecentlyDoneGifts(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftFields
      }
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;

/**
 * __useListRecentlyDoneGiftsQuery__
 *
 * To run a query within a React component, call `useListRecentlyDoneGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRecentlyDoneGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRecentlyDoneGiftsQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListRecentlyDoneGiftsQuery(baseOptions?: Apollo.QueryHookOptions<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>(ListRecentlyDoneGiftsDocument, options);
}
export function useListRecentlyDoneGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>(ListRecentlyDoneGiftsDocument, options);
}
// @ts-ignore
export function useListRecentlyDoneGiftsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>;
export function useListRecentlyDoneGiftsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListRecentlyDoneGiftsQuery | undefined, TListRecentlyDoneGiftsQueryVariables>;
export function useListRecentlyDoneGiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>(ListRecentlyDoneGiftsDocument, options);
}
export type ListRecentlyDoneGiftsQueryHookResult = ReturnType<typeof useListRecentlyDoneGiftsQuery>;
export type ListRecentlyDoneGiftsLazyQueryHookResult = ReturnType<typeof useListRecentlyDoneGiftsLazyQuery>;
export type ListRecentlyDoneGiftsSuspenseQueryHookResult = ReturnType<typeof useListRecentlyDoneGiftsSuspenseQuery>;
export type ListRecentlyDoneGiftsQueryResult = Apollo.QueryResult<TListRecentlyDoneGiftsQuery, TListRecentlyDoneGiftsQueryVariables>;
export const ListShipmentGiftsDocument = gql`
  query ListShipmentGifts($shipmentId: ID!, $companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listShipmentGifts(shipmentId: $shipmentId, companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftFields
      }
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;

/**
 * __useListShipmentGiftsQuery__
 *
 * To run a query within a React component, call `useListShipmentGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShipmentGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShipmentGiftsQuery({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListShipmentGiftsQuery(baseOptions: Apollo.QueryHookOptions<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables> & ({ variables: TListShipmentGiftsQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables>(ListShipmentGiftsDocument, options);
}
export function useListShipmentGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables>(ListShipmentGiftsDocument, options);
}
// @ts-ignore
export function useListShipmentGiftsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables>;
export function useListShipmentGiftsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShipmentGiftsQuery | undefined, TListShipmentGiftsQueryVariables>;
export function useListShipmentGiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables>(ListShipmentGiftsDocument, options);
}
export type ListShipmentGiftsQueryHookResult = ReturnType<typeof useListShipmentGiftsQuery>;
export type ListShipmentGiftsLazyQueryHookResult = ReturnType<typeof useListShipmentGiftsLazyQuery>;
export type ListShipmentGiftsSuspenseQueryHookResult = ReturnType<typeof useListShipmentGiftsSuspenseQuery>;
export type ListShipmentGiftsQueryResult = Apollo.QueryResult<TListShipmentGiftsQuery, TListShipmentGiftsQueryVariables>;
export const GetGiftDocument = gql`
  query GetGift($id: ID!, $companyId: ID!) {
    getGift(id: $id, companyId: $companyId) {
      ...GiftFields
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;

/**
 * __useGetGiftQuery__
 *
 * To run a query within a React component, call `useGetGiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetGiftQuery(baseOptions: Apollo.QueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables> & ({ variables: TGetGiftQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetGiftQuery, TGetGiftQueryVariables>(GetGiftDocument, options);
}
export function useGetGiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetGiftQuery, TGetGiftQueryVariables>(GetGiftDocument, options);
}
// @ts-ignore
export function useGetGiftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables>): Apollo.UseSuspenseQueryResult<TGetGiftQuery, TGetGiftQueryVariables>;
export function useGetGiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables>): Apollo.UseSuspenseQueryResult<TGetGiftQuery | undefined, TGetGiftQueryVariables>;
export function useGetGiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetGiftQuery, TGetGiftQueryVariables>(GetGiftDocument, options);
}
export type GetGiftQueryHookResult = ReturnType<typeof useGetGiftQuery>;
export type GetGiftLazyQueryHookResult = ReturnType<typeof useGetGiftLazyQuery>;
export type GetGiftSuspenseQueryHookResult = ReturnType<typeof useGetGiftSuspenseQuery>;
export type GetGiftQueryResult = Apollo.QueryResult<TGetGiftQuery, TGetGiftQueryVariables>;
export const CreateEventGiftDocument = gql`
  mutation CreateEventGift($eventId: ID!, $companyId: ID!, $eventVersion: Int!, $group: String, $shippingDate: AWSDate, $referenceEventDate: AWSDate) {
    createEventGift(eventId: $eventId, companyId: $companyId, _eventVersion: $eventVersion, group: $group, shippingDate: $shippingDate, referenceEventDate: $referenceEventDate) {
      companyId
      event {
        ...EventFields
      }
      gift {
        ...GiftFields
      }
    }
  }
  ${EventFieldsFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;
export type TCreateEventGiftMutationFn = Apollo.MutationFunction<TCreateEventGiftMutation, TCreateEventGiftMutationVariables>;

/**
 * __useCreateEventGiftMutation__
 *
 * To run a mutation, you first call `useCreateEventGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventGiftMutation, { data, loading, error }] = useCreateEventGiftMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      companyId: // value for 'companyId'
 *      eventVersion: // value for 'eventVersion'
 *      group: // value for 'group'
 *      shippingDate: // value for 'shippingDate'
 *      referenceEventDate: // value for 'referenceEventDate'
 *   },
 * });
 */
export function useCreateEventGiftMutation(baseOptions?: Apollo.MutationHookOptions<TCreateEventGiftMutation, TCreateEventGiftMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateEventGiftMutation, TCreateEventGiftMutationVariables>(CreateEventGiftDocument, options);
}
export type CreateEventGiftMutationHookResult = ReturnType<typeof useCreateEventGiftMutation>;
export type CreateEventGiftMutationResult = Apollo.MutationResult<TCreateEventGiftMutation>;
export type CreateEventGiftMutationOptions = Apollo.BaseMutationOptions<TCreateEventGiftMutation, TCreateEventGiftMutationVariables>;
export const MoveGiftDocument = gql`
  mutation MoveGift($id: ID!, $companyId: ID!, $version: Int!, $input: MoveGiftMutationInput!) {
    moveGift(id: $id, companyId: $companyId, _version: $version, input: $input) {
      ...GiftFields
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;
export type TMoveGiftMutationFn = Apollo.MutationFunction<TMoveGiftMutation, TMoveGiftMutationVariables>;

/**
 * __useMoveGiftMutation__
 *
 * To run a mutation, you first call `useMoveGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveGiftMutation, { data, loading, error }] = useMoveGiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveGiftMutation(baseOptions?: Apollo.MutationHookOptions<TMoveGiftMutation, TMoveGiftMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TMoveGiftMutation, TMoveGiftMutationVariables>(MoveGiftDocument, options);
}
export type MoveGiftMutationHookResult = ReturnType<typeof useMoveGiftMutation>;
export type MoveGiftMutationResult = Apollo.MutationResult<TMoveGiftMutation>;
export type MoveGiftMutationOptions = Apollo.BaseMutationOptions<TMoveGiftMutation, TMoveGiftMutationVariables>;
export const UpdateGiftDocument = gql`
  mutation UpdateGift($id: ID!, $companyId: ID!, $version: Int!, $input: UpdateGiftMutationInput!) {
    updateGift(id: $id, companyId: $companyId, _version: $version, input: $input) {
      ...GiftFields
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;
export type TUpdateGiftMutationFn = Apollo.MutationFunction<TUpdateGiftMutation, TUpdateGiftMutationVariables>;

/**
 * __useUpdateGiftMutation__
 *
 * To run a mutation, you first call `useUpdateGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGiftMutation, { data, loading, error }] = useUpdateGiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGiftMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateGiftMutation, TUpdateGiftMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateGiftMutation, TUpdateGiftMutationVariables>(UpdateGiftDocument, options);
}
export type UpdateGiftMutationHookResult = ReturnType<typeof useUpdateGiftMutation>;
export type UpdateGiftMutationResult = Apollo.MutationResult<TUpdateGiftMutation>;
export type UpdateGiftMutationOptions = Apollo.BaseMutationOptions<TUpdateGiftMutation, TUpdateGiftMutationVariables>;
export const RemoveGiftFromGroupDocument = gql`
  mutation RemoveGiftFromGroup($id: ID!, $companyId: ID!, $version: Int!) {
    removeGiftFromGroup(id: $id, companyId: $companyId, _version: $version) {
      items {
        ...GiftFields
      }
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;
export type TRemoveGiftFromGroupMutationFn = Apollo.MutationFunction<TRemoveGiftFromGroupMutation, TRemoveGiftFromGroupMutationVariables>;

/**
 * __useRemoveGiftFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveGiftFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGiftFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGiftFromGroupMutation, { data, loading, error }] = useRemoveGiftFromGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useRemoveGiftFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<TRemoveGiftFromGroupMutation, TRemoveGiftFromGroupMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TRemoveGiftFromGroupMutation, TRemoveGiftFromGroupMutationVariables>(RemoveGiftFromGroupDocument, options);
}
export type RemoveGiftFromGroupMutationHookResult = ReturnType<typeof useRemoveGiftFromGroupMutation>;
export type RemoveGiftFromGroupMutationResult = Apollo.MutationResult<TRemoveGiftFromGroupMutation>;
export type RemoveGiftFromGroupMutationOptions = Apollo.BaseMutationOptions<TRemoveGiftFromGroupMutation, TRemoveGiftFromGroupMutationVariables>;
export const DeleteGiftDocument = gql`
  mutation DeleteGift($id: ID!, $companyId: ID!, $version: Int!) {
    deleteGift(id: $id, companyId: $companyId, _version: $version) {
      ...GiftFields
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;
export type TDeleteGiftMutationFn = Apollo.MutationFunction<TDeleteGiftMutation, TDeleteGiftMutationVariables>;

/**
 * __useDeleteGiftMutation__
 *
 * To run a mutation, you first call `useDeleteGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGiftMutation, { data, loading, error }] = useDeleteGiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteGiftMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteGiftMutation, TDeleteGiftMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteGiftMutation, TDeleteGiftMutationVariables>(DeleteGiftDocument, options);
}
export type DeleteGiftMutationHookResult = ReturnType<typeof useDeleteGiftMutation>;
export type DeleteGiftMutationResult = Apollo.MutationResult<TDeleteGiftMutation>;
export type DeleteGiftMutationOptions = Apollo.BaseMutationOptions<TDeleteGiftMutation, TDeleteGiftMutationVariables>;
export const NotifyNewHiresDocument = gql`
  mutation NotifyNewHires($events: [NotifyNewHireMutationInput]!) {
    notifyNewHires(events: $events)
  }
`;
export type TNotifyNewHiresMutationFn = Apollo.MutationFunction<TNotifyNewHiresMutation, TNotifyNewHiresMutationVariables>;

/**
 * __useNotifyNewHiresMutation__
 *
 * To run a mutation, you first call `useNotifyNewHiresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyNewHiresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyNewHiresMutation, { data, loading, error }] = useNotifyNewHiresMutation({
 *   variables: {
 *      events: // value for 'events'
 *   },
 * });
 */
export function useNotifyNewHiresMutation(baseOptions?: Apollo.MutationHookOptions<TNotifyNewHiresMutation, TNotifyNewHiresMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TNotifyNewHiresMutation, TNotifyNewHiresMutationVariables>(NotifyNewHiresDocument, options);
}
export type NotifyNewHiresMutationHookResult = ReturnType<typeof useNotifyNewHiresMutation>;
export type NotifyNewHiresMutationResult = Apollo.MutationResult<TNotifyNewHiresMutation>;
export type NotifyNewHiresMutationOptions = Apollo.BaseMutationOptions<TNotifyNewHiresMutation, TNotifyNewHiresMutationVariables>;
export const OnAnyEventGiftCreatedDocument = gql`
  subscription OnAnyEventGiftCreated {
    onAnyEventGiftCreated {
      event {
        ...EventFields
      }
      gift {
        ...GiftFields
      }
    }
  }
  ${EventFieldsFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;

/**
 * __useOnAnyEventGiftCreatedSubscription__
 *
 * To run a query within a React component, call `useOnAnyEventGiftCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyEventGiftCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyEventGiftCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyEventGiftCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyEventGiftCreatedSubscription, TOnAnyEventGiftCreatedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyEventGiftCreatedSubscription, TOnAnyEventGiftCreatedSubscriptionVariables>(OnAnyEventGiftCreatedDocument, options);
}
export type OnAnyEventGiftCreatedSubscriptionHookResult = ReturnType<typeof useOnAnyEventGiftCreatedSubscription>;
export type OnAnyEventGiftCreatedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyEventGiftCreatedSubscription>;
export const OnAnyGiftRemovedFromGroupDocument = gql`
  subscription OnAnyGiftRemovedFromGroup {
    onAnyGiftRemovedFromGroup {
      items {
        ...GiftFields
      }
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;

/**
 * __useOnAnyGiftRemovedFromGroupSubscription__
 *
 * To run a query within a React component, call `useOnAnyGiftRemovedFromGroupSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyGiftRemovedFromGroupSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyGiftRemovedFromGroupSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyGiftRemovedFromGroupSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyGiftRemovedFromGroupSubscription, TOnAnyGiftRemovedFromGroupSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyGiftRemovedFromGroupSubscription, TOnAnyGiftRemovedFromGroupSubscriptionVariables>(OnAnyGiftRemovedFromGroupDocument, options);
}
export type OnAnyGiftRemovedFromGroupSubscriptionHookResult = ReturnType<typeof useOnAnyGiftRemovedFromGroupSubscription>;
export type OnAnyGiftRemovedFromGroupSubscriptionResult = Apollo.SubscriptionResult<TOnAnyGiftRemovedFromGroupSubscription>;
export const OnAnyGiftChangedDocument = gql`
  subscription OnAnyGiftChanged {
    onAnyGiftChanged {
      ...GiftFields
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
`;

/**
 * __useOnAnyGiftChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyGiftChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyGiftChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyGiftChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyGiftChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyGiftChangedSubscription, TOnAnyGiftChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyGiftChangedSubscription, TOnAnyGiftChangedSubscriptionVariables>(OnAnyGiftChangedDocument, options);
}
export type OnAnyGiftChangedSubscriptionHookResult = ReturnType<typeof useOnAnyGiftChangedSubscription>;
export type OnAnyGiftChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyGiftChangedSubscription>;
export const ListGiftsAssemblingDocument = gql`
  query ListGiftsAssembling($type: String, $isDone: Int, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listGiftsAssembling(type: $type, isDone: $isDone, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...GiftNewFieldsAndHydration
      }
    }
  }
  ${GiftNewFieldsAndHydrationFragmentDoc}
  ${GiftNewFieldsFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListGiftsAssemblingQuery__
 *
 * To run a query within a React component, call `useListGiftsAssemblingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGiftsAssemblingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGiftsAssemblingQuery({
 *   variables: {
 *      type: // value for 'type'
 *      isDone: // value for 'isDone'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListGiftsAssemblingQuery(baseOptions?: Apollo.QueryHookOptions<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>(ListGiftsAssemblingDocument, options);
}
export function useListGiftsAssemblingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>(ListGiftsAssemblingDocument, options);
}
// @ts-ignore
export function useListGiftsAssemblingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>
): Apollo.UseSuspenseQueryResult<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>;
export function useListGiftsAssemblingSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>
): Apollo.UseSuspenseQueryResult<TListGiftsAssemblingQuery | undefined, TListGiftsAssemblingQueryVariables>;
export function useListGiftsAssemblingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>(ListGiftsAssemblingDocument, options);
}
export type ListGiftsAssemblingQueryHookResult = ReturnType<typeof useListGiftsAssemblingQuery>;
export type ListGiftsAssemblingLazyQueryHookResult = ReturnType<typeof useListGiftsAssemblingLazyQuery>;
export type ListGiftsAssemblingSuspenseQueryHookResult = ReturnType<typeof useListGiftsAssemblingSuspenseQuery>;
export type ListGiftsAssemblingQueryResult = Apollo.QueryResult<TListGiftsAssemblingQuery, TListGiftsAssemblingQueryVariables>;
export const ListOneGiftDocument = gql`
  query ListOneGift($id: ID!, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listOneGift(id: $id, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...GiftNewFieldsAndHydration
      }
    }
  }
  ${GiftNewFieldsAndHydrationFragmentDoc}
  ${GiftNewFieldsFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListOneGiftQuery__
 *
 * To run a query within a React component, call `useListOneGiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneGiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneGiftQuery({
 *   variables: {
 *      id: // value for 'id'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneGiftQuery(baseOptions: Apollo.QueryHookOptions<TListOneGiftQuery, TListOneGiftQueryVariables> & ({ variables: TListOneGiftQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneGiftQuery, TListOneGiftQueryVariables>(ListOneGiftDocument, options);
}
export function useListOneGiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneGiftQuery, TListOneGiftQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneGiftQuery, TListOneGiftQueryVariables>(ListOneGiftDocument, options);
}
// @ts-ignore
export function useListOneGiftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneGiftQuery, TListOneGiftQueryVariables>): Apollo.UseSuspenseQueryResult<TListOneGiftQuery, TListOneGiftQueryVariables>;
export function useListOneGiftSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneGiftQuery, TListOneGiftQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneGiftQuery | undefined, TListOneGiftQueryVariables>;
export function useListOneGiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneGiftQuery, TListOneGiftQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneGiftQuery, TListOneGiftQueryVariables>(ListOneGiftDocument, options);
}
export type ListOneGiftQueryHookResult = ReturnType<typeof useListOneGiftQuery>;
export type ListOneGiftLazyQueryHookResult = ReturnType<typeof useListOneGiftLazyQuery>;
export type ListOneGiftSuspenseQueryHookResult = ReturnType<typeof useListOneGiftSuspenseQuery>;
export type ListOneGiftQueryResult = Apollo.QueryResult<TListOneGiftQuery, TListOneGiftQueryVariables>;
export const ListOneShipmentGiftsDocument = gql`
  query ListOneShipmentGifts($shipmentId: ID!, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listOneShipmentGifts(shipmentId: $shipmentId, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...GiftNewFieldsAndHydration
      }
    }
  }
  ${GiftNewFieldsAndHydrationFragmentDoc}
  ${GiftNewFieldsFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListOneShipmentGiftsQuery__
 *
 * To run a query within a React component, call `useListOneShipmentGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneShipmentGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneShipmentGiftsQuery({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneShipmentGiftsQuery(baseOptions: Apollo.QueryHookOptions<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables> & ({ variables: TListOneShipmentGiftsQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables>(ListOneShipmentGiftsDocument, options);
}
export function useListOneShipmentGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables>(ListOneShipmentGiftsDocument, options);
}
// @ts-ignore
export function useListOneShipmentGiftsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables>;
export function useListOneShipmentGiftsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneShipmentGiftsQuery | undefined, TListOneShipmentGiftsQueryVariables>;
export function useListOneShipmentGiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables>(ListOneShipmentGiftsDocument, options);
}
export type ListOneShipmentGiftsQueryHookResult = ReturnType<typeof useListOneShipmentGiftsQuery>;
export type ListOneShipmentGiftsLazyQueryHookResult = ReturnType<typeof useListOneShipmentGiftsLazyQuery>;
export type ListOneShipmentGiftsSuspenseQueryHookResult = ReturnType<typeof useListOneShipmentGiftsSuspenseQuery>;
export type ListOneShipmentGiftsQueryResult = Apollo.QueryResult<TListOneShipmentGiftsQuery, TListOneShipmentGiftsQueryVariables>;
export const ListAllLogsDocument = gql`
  query ListAllLogs($userType: String!, $occurredAt: String, $userPoolId: String, $filter: FilterInput, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listAllLogs(userType: $userType, occurredAt: $occurredAt, userPoolId: $userPoolId, filter: $filter, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...LogFields
      }
    }
  }
  ${LogFieldsFragmentDoc}
`;

/**
 * __useListAllLogsQuery__
 *
 * To run a query within a React component, call `useListAllLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllLogsQuery({
 *   variables: {
 *      userType: // value for 'userType'
 *      occurredAt: // value for 'occurredAt'
 *      userPoolId: // value for 'userPoolId'
 *      filter: // value for 'filter'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAllLogsQuery(baseOptions: Apollo.QueryHookOptions<TListAllLogsQuery, TListAllLogsQueryVariables> & ({ variables: TListAllLogsQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListAllLogsQuery, TListAllLogsQueryVariables>(ListAllLogsDocument, options);
}
export function useListAllLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListAllLogsQuery, TListAllLogsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListAllLogsQuery, TListAllLogsQueryVariables>(ListAllLogsDocument, options);
}
// @ts-ignore
export function useListAllLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListAllLogsQuery, TListAllLogsQueryVariables>): Apollo.UseSuspenseQueryResult<TListAllLogsQuery, TListAllLogsQueryVariables>;
export function useListAllLogsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllLogsQuery, TListAllLogsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllLogsQuery | undefined, TListAllLogsQueryVariables>;
export function useListAllLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllLogsQuery, TListAllLogsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListAllLogsQuery, TListAllLogsQueryVariables>(ListAllLogsDocument, options);
}
export type ListAllLogsQueryHookResult = ReturnType<typeof useListAllLogsQuery>;
export type ListAllLogsLazyQueryHookResult = ReturnType<typeof useListAllLogsLazyQuery>;
export type ListAllLogsSuspenseQueryHookResult = ReturnType<typeof useListAllLogsSuspenseQuery>;
export type ListAllLogsQueryResult = Apollo.QueryResult<TListAllLogsQuery, TListAllLogsQueryVariables>;
export const GetOfficeDocument = gql`
  query GetOffice($id: ID!, $companyId: ID!) {
    getOffice(id: $id, companyId: $companyId) {
      ...OfficeFields
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useGetOfficeQuery__
 *
 * To run a query within a React component, call `useGetOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetOfficeQuery(baseOptions: Apollo.QueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables> & ({ variables: TGetOfficeQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetOfficeQuery, TGetOfficeQueryVariables>(GetOfficeDocument, options);
}
export function useGetOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetOfficeQuery, TGetOfficeQueryVariables>(GetOfficeDocument, options);
}
// @ts-ignore
export function useGetOfficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables>): Apollo.UseSuspenseQueryResult<TGetOfficeQuery, TGetOfficeQueryVariables>;
export function useGetOfficeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables>): Apollo.UseSuspenseQueryResult<TGetOfficeQuery | undefined, TGetOfficeQueryVariables>;
export function useGetOfficeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetOfficeQuery, TGetOfficeQueryVariables>(GetOfficeDocument, options);
}
export type GetOfficeQueryHookResult = ReturnType<typeof useGetOfficeQuery>;
export type GetOfficeLazyQueryHookResult = ReturnType<typeof useGetOfficeLazyQuery>;
export type GetOfficeSuspenseQueryHookResult = ReturnType<typeof useGetOfficeSuspenseQuery>;
export type GetOfficeQueryResult = Apollo.QueryResult<TGetOfficeQuery, TGetOfficeQueryVariables>;
export const ListAllOfficesDocument = gql`
  query ListAllOffices($nextToken: String, $limit: Int, $order: OrderDirection) {
    listAllOffices(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...OfficeFields
      }
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListAllOfficesQuery__
 *
 * To run a query within a React component, call `useListAllOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllOfficesQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAllOfficesQuery(baseOptions?: Apollo.QueryHookOptions<TListAllOfficesQuery, TListAllOfficesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListAllOfficesQuery, TListAllOfficesQueryVariables>(ListAllOfficesDocument, options);
}
export function useListAllOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListAllOfficesQuery, TListAllOfficesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListAllOfficesQuery, TListAllOfficesQueryVariables>(ListAllOfficesDocument, options);
}
// @ts-ignore
export function useListAllOfficesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListAllOfficesQuery, TListAllOfficesQueryVariables>): Apollo.UseSuspenseQueryResult<TListAllOfficesQuery, TListAllOfficesQueryVariables>;
export function useListAllOfficesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllOfficesQuery, TListAllOfficesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAllOfficesQuery | undefined, TListAllOfficesQueryVariables>;
export function useListAllOfficesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAllOfficesQuery, TListAllOfficesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListAllOfficesQuery, TListAllOfficesQueryVariables>(ListAllOfficesDocument, options);
}
export type ListAllOfficesQueryHookResult = ReturnType<typeof useListAllOfficesQuery>;
export type ListAllOfficesLazyQueryHookResult = ReturnType<typeof useListAllOfficesLazyQuery>;
export type ListAllOfficesSuspenseQueryHookResult = ReturnType<typeof useListAllOfficesSuspenseQuery>;
export type ListAllOfficesQueryResult = Apollo.QueryResult<TListAllOfficesQuery, TListAllOfficesQueryVariables>;
export const ListCompanyOfficesDocument = gql`
  query ListCompanyOffices($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listOffices(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...OfficeFields
      }
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListCompanyOfficesQuery__
 *
 * To run a query within a React component, call `useListCompanyOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyOfficesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListCompanyOfficesQuery(baseOptions: Apollo.QueryHookOptions<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables> & ({ variables: TListCompanyOfficesQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables>(ListCompanyOfficesDocument, options);
}
export function useListCompanyOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables>(ListCompanyOfficesDocument, options);
}
// @ts-ignore
export function useListCompanyOfficesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables>;
export function useListCompanyOfficesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListCompanyOfficesQuery | undefined, TListCompanyOfficesQueryVariables>;
export function useListCompanyOfficesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables>(ListCompanyOfficesDocument, options);
}
export type ListCompanyOfficesQueryHookResult = ReturnType<typeof useListCompanyOfficesQuery>;
export type ListCompanyOfficesLazyQueryHookResult = ReturnType<typeof useListCompanyOfficesLazyQuery>;
export type ListCompanyOfficesSuspenseQueryHookResult = ReturnType<typeof useListCompanyOfficesSuspenseQuery>;
export type ListCompanyOfficesQueryResult = Apollo.QueryResult<TListCompanyOfficesQuery, TListCompanyOfficesQueryVariables>;
export const OnAnyOfficeChangedDocument = gql`
  subscription OnAnyOfficeChanged {
    onAnyOfficeChanged {
      ...OfficeFields
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useOnAnyOfficeChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyOfficeChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyOfficeChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyOfficeChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyOfficeChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyOfficeChangedSubscription, TOnAnyOfficeChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyOfficeChangedSubscription, TOnAnyOfficeChangedSubscriptionVariables>(OnAnyOfficeChangedDocument, options);
}
export type OnAnyOfficeChangedSubscriptionHookResult = ReturnType<typeof useOnAnyOfficeChangedSubscription>;
export type OnAnyOfficeChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyOfficeChangedSubscription>;
export const ListProductsDocument = gql`
  query ListProducts($nextToken: String, $limit: Int, $order: OrderDirection) {
    listProducts(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...ProductFields
      }
    }
  }
  ${ProductFieldsFragmentDoc}
`;

/**
 * __useListProductsQuery__
 *
 * To run a query within a React component, call `useListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductsQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListProductsQuery(baseOptions?: Apollo.QueryHookOptions<TListProductsQuery, TListProductsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListProductsQuery, TListProductsQueryVariables>(ListProductsDocument, options);
}
export function useListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListProductsQuery, TListProductsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListProductsQuery, TListProductsQueryVariables>(ListProductsDocument, options);
}
// @ts-ignore
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListProductsQuery, TListProductsQueryVariables>): Apollo.UseSuspenseQueryResult<TListProductsQuery, TListProductsQueryVariables>;
export function useListProductsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListProductsQuery, TListProductsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListProductsQuery | undefined, TListProductsQueryVariables>;
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListProductsQuery, TListProductsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListProductsQuery, TListProductsQueryVariables>(ListProductsDocument, options);
}
export type ListProductsQueryHookResult = ReturnType<typeof useListProductsQuery>;
export type ListProductsLazyQueryHookResult = ReturnType<typeof useListProductsLazyQuery>;
export type ListProductsSuspenseQueryHookResult = ReturnType<typeof useListProductsSuspenseQuery>;
export type ListProductsQueryResult = Apollo.QueryResult<TListProductsQuery, TListProductsQueryVariables>;
export const GetProductDocument = gql`
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      ...ProductFields
    }
  }
  ${ProductFieldsFragmentDoc}
`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<TGetProductQuery, TGetProductQueryVariables> & ({ variables: TGetProductQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetProductQuery, TGetProductQueryVariables>(GetProductDocument, options);
}
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetProductQuery, TGetProductQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetProductQuery, TGetProductQueryVariables>(GetProductDocument, options);
}
// @ts-ignore
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetProductQuery, TGetProductQueryVariables>): Apollo.UseSuspenseQueryResult<TGetProductQuery, TGetProductQueryVariables>;
export function useGetProductSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetProductQuery, TGetProductQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetProductQuery | undefined, TGetProductQueryVariables>;
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetProductQuery, TGetProductQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetProductQuery, TGetProductQueryVariables>(GetProductDocument, options);
}
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<TGetProductQuery, TGetProductQueryVariables>;
export const CreateProductDocument = gql`
  mutation CreateProduct($input: CreateProductMutationInput!) {
    createProduct(input: $input) {
      ...ProductFields
    }
  }
  ${ProductFieldsFragmentDoc}
`;
export type TCreateProductMutationFn = Apollo.MutationFunction<TCreateProductMutation, TCreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<TCreateProductMutation, TCreateProductMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateProductMutation, TCreateProductMutationVariables>(CreateProductDocument, options);
}
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<TCreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<TCreateProductMutation, TCreateProductMutationVariables>;
export const UpdateProductDocument = gql`
  mutation UpdateProduct($id: ID!, $version: Int!, $input: UpdateProductMutationInput!) {
    updateProduct(id: $id, _version: $version, input: $input) {
      ...ProductFields
    }
  }
  ${ProductFieldsFragmentDoc}
`;
export type TUpdateProductMutationFn = Apollo.MutationFunction<TUpdateProductMutation, TUpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateProductMutation, TUpdateProductMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateProductMutation, TUpdateProductMutationVariables>(UpdateProductDocument, options);
}
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<TUpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<TUpdateProductMutation, TUpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
  mutation DeleteProduct($id: ID!, $version: Int!) {
    deleteProduct(id: $id, _version: $version) {
      ...ProductFields
    }
  }
  ${ProductFieldsFragmentDoc}
`;
export type TDeleteProductMutationFn = Apollo.MutationFunction<TDeleteProductMutation, TDeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteProductMutation, TDeleteProductMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteProductMutation, TDeleteProductMutationVariables>(DeleteProductDocument, options);
}
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<TDeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<TDeleteProductMutation, TDeleteProductMutationVariables>;
export const OnAnyProductChangedDocument = gql`
  subscription OnAnyProductChanged {
    onAnyProductChanged {
      ...ProductFields
    }
  }
  ${ProductFieldsFragmentDoc}
`;

/**
 * __useOnAnyProductChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyProductChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyProductChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyProductChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyProductChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyProductChangedSubscription, TOnAnyProductChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyProductChangedSubscription, TOnAnyProductChangedSubscriptionVariables>(OnAnyProductChangedDocument, options);
}
export type OnAnyProductChangedSubscriptionHookResult = ReturnType<typeof useOnAnyProductChangedSubscription>;
export type OnAnyProductChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyProductChangedSubscription>;
export const GetRecipientDocument = gql`
  query GetRecipient($id: ID!, $companyId: ID!) {
    getRecipient(id: $id, companyId: $companyId) {
      ...RecipientFields
    }
  }
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;

/**
 * __useGetRecipientQuery__
 *
 * To run a query within a React component, call `useGetRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetRecipientQuery(baseOptions: Apollo.QueryHookOptions<TGetRecipientQuery, TGetRecipientQueryVariables> & ({ variables: TGetRecipientQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetRecipientQuery, TGetRecipientQueryVariables>(GetRecipientDocument, options);
}
export function useGetRecipientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetRecipientQuery, TGetRecipientQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetRecipientQuery, TGetRecipientQueryVariables>(GetRecipientDocument, options);
}
// @ts-ignore
export function useGetRecipientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetRecipientQuery, TGetRecipientQueryVariables>): Apollo.UseSuspenseQueryResult<TGetRecipientQuery, TGetRecipientQueryVariables>;
export function useGetRecipientSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetRecipientQuery, TGetRecipientQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetRecipientQuery | undefined, TGetRecipientQueryVariables>;
export function useGetRecipientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetRecipientQuery, TGetRecipientQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetRecipientQuery, TGetRecipientQueryVariables>(GetRecipientDocument, options);
}
export type GetRecipientQueryHookResult = ReturnType<typeof useGetRecipientQuery>;
export type GetRecipientLazyQueryHookResult = ReturnType<typeof useGetRecipientLazyQuery>;
export type GetRecipientSuspenseQueryHookResult = ReturnType<typeof useGetRecipientSuspenseQuery>;
export type GetRecipientQueryResult = Apollo.QueryResult<TGetRecipientQuery, TGetRecipientQueryVariables>;
export const FinancialReportDocument = gql`
  query FinancialReport($month: String!, $companyId: ID) {
    financialReport(month: $month, companyId: $companyId) {
      companyId
      companyName
      previousYear
      actual
      forecast
      gifts
      shipmentCost
      clientCost
    }
  }
`;

/**
 * __useFinancialReportQuery__
 *
 * To run a query within a React component, call `useFinancialReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFinancialReportQuery(baseOptions: Apollo.QueryHookOptions<TFinancialReportQuery, TFinancialReportQueryVariables> & ({ variables: TFinancialReportQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TFinancialReportQuery, TFinancialReportQueryVariables>(FinancialReportDocument, options);
}
export function useFinancialReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TFinancialReportQuery, TFinancialReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TFinancialReportQuery, TFinancialReportQueryVariables>(FinancialReportDocument, options);
}
// @ts-ignore
export function useFinancialReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TFinancialReportQuery, TFinancialReportQueryVariables>): Apollo.UseSuspenseQueryResult<TFinancialReportQuery, TFinancialReportQueryVariables>;
export function useFinancialReportSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TFinancialReportQuery, TFinancialReportQueryVariables>
): Apollo.UseSuspenseQueryResult<TFinancialReportQuery | undefined, TFinancialReportQueryVariables>;
export function useFinancialReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TFinancialReportQuery, TFinancialReportQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TFinancialReportQuery, TFinancialReportQueryVariables>(FinancialReportDocument, options);
}
export type FinancialReportQueryHookResult = ReturnType<typeof useFinancialReportQuery>;
export type FinancialReportLazyQueryHookResult = ReturnType<typeof useFinancialReportLazyQuery>;
export type FinancialReportSuspenseQueryHookResult = ReturnType<typeof useFinancialReportSuspenseQuery>;
export type FinancialReportQueryResult = Apollo.QueryResult<TFinancialReportQuery, TFinancialReportQueryVariables>;
export const EventsReportDocument = gql`
  query EventsReport($month: String!, $companyId: ID) {
    eventsReport(month: $month, companyId: $companyId) {
      companyId
      companyName
      eventType
      count
    }
  }
`;

/**
 * __useEventsReportQuery__
 *
 * To run a query within a React component, call `useEventsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useEventsReportQuery(baseOptions: Apollo.QueryHookOptions<TEventsReportQuery, TEventsReportQueryVariables> & ({ variables: TEventsReportQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TEventsReportQuery, TEventsReportQueryVariables>(EventsReportDocument, options);
}
export function useEventsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TEventsReportQuery, TEventsReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TEventsReportQuery, TEventsReportQueryVariables>(EventsReportDocument, options);
}
// @ts-ignore
export function useEventsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TEventsReportQuery, TEventsReportQueryVariables>): Apollo.UseSuspenseQueryResult<TEventsReportQuery, TEventsReportQueryVariables>;
export function useEventsReportSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TEventsReportQuery, TEventsReportQueryVariables>
): Apollo.UseSuspenseQueryResult<TEventsReportQuery | undefined, TEventsReportQueryVariables>;
export function useEventsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TEventsReportQuery, TEventsReportQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TEventsReportQuery, TEventsReportQueryVariables>(EventsReportDocument, options);
}
export type EventsReportQueryHookResult = ReturnType<typeof useEventsReportQuery>;
export type EventsReportLazyQueryHookResult = ReturnType<typeof useEventsReportLazyQuery>;
export type EventsReportSuspenseQueryHookResult = ReturnType<typeof useEventsReportSuspenseQuery>;
export type EventsReportQueryResult = Apollo.QueryResult<TEventsReportQuery, TEventsReportQueryVariables>;
export const GiftsReportDocument = gql`
  query GiftsReport($month: String!, $companyId: ID) {
    giftsReport(month: $month, companyId: $companyId) {
      companyId
      companyName
      isTotal
      newHire
      workAnniversaryDeluxe
      workAnniversaryMini
      workAnniversaryBrickOnly
      workAnniversaryCustom
      workAnniversaryLegoOnly
      employeeBirthday
      dependantBirthday
      babyGift
      bereavement
      wedding
      replacementWorkAnniversary
      replacementEmployeeBirthday
      carePackage
      customBricks
      other
      total
    }
  }
`;

/**
 * __useGiftsReportQuery__
 *
 * To run a query within a React component, call `useGiftsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftsReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGiftsReportQuery(baseOptions: Apollo.QueryHookOptions<TGiftsReportQuery, TGiftsReportQueryVariables> & ({ variables: TGiftsReportQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGiftsReportQuery, TGiftsReportQueryVariables>(GiftsReportDocument, options);
}
export function useGiftsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGiftsReportQuery, TGiftsReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGiftsReportQuery, TGiftsReportQueryVariables>(GiftsReportDocument, options);
}
// @ts-ignore
export function useGiftsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGiftsReportQuery, TGiftsReportQueryVariables>): Apollo.UseSuspenseQueryResult<TGiftsReportQuery, TGiftsReportQueryVariables>;
export function useGiftsReportSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGiftsReportQuery, TGiftsReportQueryVariables>
): Apollo.UseSuspenseQueryResult<TGiftsReportQuery | undefined, TGiftsReportQueryVariables>;
export function useGiftsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGiftsReportQuery, TGiftsReportQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGiftsReportQuery, TGiftsReportQueryVariables>(GiftsReportDocument, options);
}
export type GiftsReportQueryHookResult = ReturnType<typeof useGiftsReportQuery>;
export type GiftsReportLazyQueryHookResult = ReturnType<typeof useGiftsReportLazyQuery>;
export type GiftsReportSuspenseQueryHookResult = ReturnType<typeof useGiftsReportSuspenseQuery>;
export type GiftsReportQueryResult = Apollo.QueryResult<TGiftsReportQuery, TGiftsReportQueryVariables>;
export const ShipmentsReportDocument = gql`
  query ShipmentsReport($month: String!, $companyId: ID) {
    shipmentsReport(month: $month, companyId: $companyId) {
      status
      companyId
      companyName
      giftCount
      shipmentCost
      clientCost
      date
      recipient
      shipmentType
      trackingNumber
      carrier
    }
  }
`;

/**
 * __useShipmentsReportQuery__
 *
 * To run a query within a React component, call `useShipmentsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentsReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useShipmentsReportQuery(baseOptions: Apollo.QueryHookOptions<TShipmentsReportQuery, TShipmentsReportQueryVariables> & ({ variables: TShipmentsReportQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TShipmentsReportQuery, TShipmentsReportQueryVariables>(ShipmentsReportDocument, options);
}
export function useShipmentsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TShipmentsReportQuery, TShipmentsReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TShipmentsReportQuery, TShipmentsReportQueryVariables>(ShipmentsReportDocument, options);
}
// @ts-ignore
export function useShipmentsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TShipmentsReportQuery, TShipmentsReportQueryVariables>): Apollo.UseSuspenseQueryResult<TShipmentsReportQuery, TShipmentsReportQueryVariables>;
export function useShipmentsReportSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TShipmentsReportQuery, TShipmentsReportQueryVariables>
): Apollo.UseSuspenseQueryResult<TShipmentsReportQuery | undefined, TShipmentsReportQueryVariables>;
export function useShipmentsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TShipmentsReportQuery, TShipmentsReportQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TShipmentsReportQuery, TShipmentsReportQueryVariables>(ShipmentsReportDocument, options);
}
export type ShipmentsReportQueryHookResult = ReturnType<typeof useShipmentsReportQuery>;
export type ShipmentsReportLazyQueryHookResult = ReturnType<typeof useShipmentsReportLazyQuery>;
export type ShipmentsReportSuspenseQueryHookResult = ReturnType<typeof useShipmentsReportSuspenseQuery>;
export type ShipmentsReportQueryResult = Apollo.QueryResult<TShipmentsReportQuery, TShipmentsReportQueryVariables>;
export const RosterFilesReportDocument = gql`
  query RosterFilesReport($month: String!, $companyId: ID) {
    rosterFilesReport(month: $month, companyId: $companyId) {
      companyId
      companyName
      createdAt
      createdBy
      file {
        key
        region
        bucket
        version
      }
      changelogFile {
        key
        region
        bucket
        version
      }
      mapping
      changelog
      importStartedAt
      impoortEndedAt
      importErrors
      headerMapping
      officeMapping
    }
  }
`;

/**
 * __useRosterFilesReportQuery__
 *
 * To run a query within a React component, call `useRosterFilesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterFilesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterFilesReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRosterFilesReportQuery(baseOptions: Apollo.QueryHookOptions<TRosterFilesReportQuery, TRosterFilesReportQueryVariables> & ({ variables: TRosterFilesReportQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TRosterFilesReportQuery, TRosterFilesReportQueryVariables>(RosterFilesReportDocument, options);
}
export function useRosterFilesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TRosterFilesReportQuery, TRosterFilesReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TRosterFilesReportQuery, TRosterFilesReportQueryVariables>(RosterFilesReportDocument, options);
}
// @ts-ignore
export function useRosterFilesReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TRosterFilesReportQuery, TRosterFilesReportQueryVariables>
): Apollo.UseSuspenseQueryResult<TRosterFilesReportQuery, TRosterFilesReportQueryVariables>;
export function useRosterFilesReportSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TRosterFilesReportQuery, TRosterFilesReportQueryVariables>
): Apollo.UseSuspenseQueryResult<TRosterFilesReportQuery | undefined, TRosterFilesReportQueryVariables>;
export function useRosterFilesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TRosterFilesReportQuery, TRosterFilesReportQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TRosterFilesReportQuery, TRosterFilesReportQueryVariables>(RosterFilesReportDocument, options);
}
export type RosterFilesReportQueryHookResult = ReturnType<typeof useRosterFilesReportQuery>;
export type RosterFilesReportLazyQueryHookResult = ReturnType<typeof useRosterFilesReportLazyQuery>;
export type RosterFilesReportSuspenseQueryHookResult = ReturnType<typeof useRosterFilesReportSuspenseQuery>;
export type RosterFilesReportQueryResult = Apollo.QueryResult<TRosterFilesReportQuery, TRosterFilesReportQueryVariables>;
export const CustomReportDocument = gql`
  query CustomReport($input: CustomReportInput!) {
    customReport(input: $input) {
      companyId
      companyName
      count
    }
  }
`;

/**
 * __useCustomReportQuery__
 *
 * To run a query within a React component, call `useCustomReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomReportQuery(baseOptions: Apollo.QueryHookOptions<TCustomReportQuery, TCustomReportQueryVariables> & ({ variables: TCustomReportQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TCustomReportQuery, TCustomReportQueryVariables>(CustomReportDocument, options);
}
export function useCustomReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TCustomReportQuery, TCustomReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TCustomReportQuery, TCustomReportQueryVariables>(CustomReportDocument, options);
}
// @ts-ignore
export function useCustomReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TCustomReportQuery, TCustomReportQueryVariables>): Apollo.UseSuspenseQueryResult<TCustomReportQuery, TCustomReportQueryVariables>;
export function useCustomReportSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TCustomReportQuery, TCustomReportQueryVariables>
): Apollo.UseSuspenseQueryResult<TCustomReportQuery | undefined, TCustomReportQueryVariables>;
export function useCustomReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TCustomReportQuery, TCustomReportQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TCustomReportQuery, TCustomReportQueryVariables>(CustomReportDocument, options);
}
export type CustomReportQueryHookResult = ReturnType<typeof useCustomReportQuery>;
export type CustomReportLazyQueryHookResult = ReturnType<typeof useCustomReportLazyQuery>;
export type CustomReportSuspenseQueryHookResult = ReturnType<typeof useCustomReportSuspenseQuery>;
export type CustomReportQueryResult = Apollo.QueryResult<TCustomReportQuery, TCustomReportQueryVariables>;
export const ListRosterFilesDocument = gql`
  query ListRosterFiles($nextToken: String, $limit: Int, $order: OrderDirection) {
    listRosterFiles(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...RosterFileFields
      }
    }
  }
  ${RosterFileFieldsFragmentDoc}
`;

/**
 * __useListRosterFilesQuery__
 *
 * To run a query within a React component, call `useListRosterFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRosterFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRosterFilesQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListRosterFilesQuery(baseOptions?: Apollo.QueryHookOptions<TListRosterFilesQuery, TListRosterFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListRosterFilesQuery, TListRosterFilesQueryVariables>(ListRosterFilesDocument, options);
}
export function useListRosterFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListRosterFilesQuery, TListRosterFilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListRosterFilesQuery, TListRosterFilesQueryVariables>(ListRosterFilesDocument, options);
}
// @ts-ignore
export function useListRosterFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListRosterFilesQuery, TListRosterFilesQueryVariables>): Apollo.UseSuspenseQueryResult<TListRosterFilesQuery, TListRosterFilesQueryVariables>;
export function useListRosterFilesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListRosterFilesQuery, TListRosterFilesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListRosterFilesQuery | undefined, TListRosterFilesQueryVariables>;
export function useListRosterFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListRosterFilesQuery, TListRosterFilesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListRosterFilesQuery, TListRosterFilesQueryVariables>(ListRosterFilesDocument, options);
}
export type ListRosterFilesQueryHookResult = ReturnType<typeof useListRosterFilesQuery>;
export type ListRosterFilesLazyQueryHookResult = ReturnType<typeof useListRosterFilesLazyQuery>;
export type ListRosterFilesSuspenseQueryHookResult = ReturnType<typeof useListRosterFilesSuspenseQuery>;
export type ListRosterFilesQueryResult = Apollo.QueryResult<TListRosterFilesQuery, TListRosterFilesQueryVariables>;
export const ListRosterFilesByCompanyIdDocument = gql`
  query ListRosterFilesByCompanyId($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listRosterFilesByCompanyId(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...RosterFileFields
      }
    }
  }
  ${RosterFileFieldsFragmentDoc}
`;

/**
 * __useListRosterFilesByCompanyIdQuery__
 *
 * To run a query within a React component, call `useListRosterFilesByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRosterFilesByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRosterFilesByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListRosterFilesByCompanyIdQuery(
  baseOptions: Apollo.QueryHookOptions<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables> & ({ variables: TListRosterFilesByCompanyIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables>(ListRosterFilesByCompanyIdDocument, options);
}
export function useListRosterFilesByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables>(ListRosterFilesByCompanyIdDocument, options);
}
// @ts-ignore
export function useListRosterFilesByCompanyIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables>
): Apollo.UseSuspenseQueryResult<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables>;
export function useListRosterFilesByCompanyIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables>
): Apollo.UseSuspenseQueryResult<TListRosterFilesByCompanyIdQuery | undefined, TListRosterFilesByCompanyIdQueryVariables>;
export function useListRosterFilesByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables>(ListRosterFilesByCompanyIdDocument, options);
}
export type ListRosterFilesByCompanyIdQueryHookResult = ReturnType<typeof useListRosterFilesByCompanyIdQuery>;
export type ListRosterFilesByCompanyIdLazyQueryHookResult = ReturnType<typeof useListRosterFilesByCompanyIdLazyQuery>;
export type ListRosterFilesByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useListRosterFilesByCompanyIdSuspenseQuery>;
export type ListRosterFilesByCompanyIdQueryResult = Apollo.QueryResult<TListRosterFilesByCompanyIdQuery, TListRosterFilesByCompanyIdQueryVariables>;
export const CreateRosterFileDocument = gql`
  mutation CreateRosterFile($input: CreateRosterFileInput!) {
    createRosterFile(input: $input) {
      ...RosterFileFields
    }
  }
  ${RosterFileFieldsFragmentDoc}
`;
export type TCreateRosterFileMutationFn = Apollo.MutationFunction<TCreateRosterFileMutation, TCreateRosterFileMutationVariables>;

/**
 * __useCreateRosterFileMutation__
 *
 * To run a mutation, you first call `useCreateRosterFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRosterFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRosterFileMutation, { data, loading, error }] = useCreateRosterFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRosterFileMutation(baseOptions?: Apollo.MutationHookOptions<TCreateRosterFileMutation, TCreateRosterFileMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateRosterFileMutation, TCreateRosterFileMutationVariables>(CreateRosterFileDocument, options);
}
export type CreateRosterFileMutationHookResult = ReturnType<typeof useCreateRosterFileMutation>;
export type CreateRosterFileMutationResult = Apollo.MutationResult<TCreateRosterFileMutation>;
export type CreateRosterFileMutationOptions = Apollo.BaseMutationOptions<TCreateRosterFileMutation, TCreateRosterFileMutationVariables>;
export const OnAnyRosterFileChangedDocument = gql`
  subscription OnAnyRosterFileChanged {
    onAnyRosterFileChanged {
      ...RosterFileFields
    }
  }
  ${RosterFileFieldsFragmentDoc}
`;

/**
 * __useOnAnyRosterFileChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyRosterFileChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyRosterFileChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyRosterFileChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyRosterFileChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyRosterFileChangedSubscription, TOnAnyRosterFileChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyRosterFileChangedSubscription, TOnAnyRosterFileChangedSubscriptionVariables>(OnAnyRosterFileChangedDocument, options);
}
export type OnAnyRosterFileChangedSubscriptionHookResult = ReturnType<typeof useOnAnyRosterFileChangedSubscription>;
export type OnAnyRosterFileChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyRosterFileChangedSubscription>;
export const ListOpenShipmentsDocument = gql`
  query ListOpenShipments($nextToken: String, $limit: Int, $order: OrderDirection) {
    listOpenShipments(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...ShipmentFieldsHydrated
      }
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;

/**
 * __useListOpenShipmentsQuery__
 *
 * To run a query within a React component, call `useListOpenShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOpenShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOpenShipmentsQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOpenShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>(ListOpenShipmentsDocument, options);
}
export function useListOpenShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>(ListOpenShipmentsDocument, options);
}
// @ts-ignore
export function useListOpenShipmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>;
export function useListOpenShipmentsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOpenShipmentsQuery | undefined, TListOpenShipmentsQueryVariables>;
export function useListOpenShipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>(ListOpenShipmentsDocument, options);
}
export type ListOpenShipmentsQueryHookResult = ReturnType<typeof useListOpenShipmentsQuery>;
export type ListOpenShipmentsLazyQueryHookResult = ReturnType<typeof useListOpenShipmentsLazyQuery>;
export type ListOpenShipmentsSuspenseQueryHookResult = ReturnType<typeof useListOpenShipmentsSuspenseQuery>;
export type ListOpenShipmentsQueryResult = Apollo.QueryResult<TListOpenShipmentsQuery, TListOpenShipmentsQueryVariables>;
export const ListShippedShipmentsDocument = gql`
  query ListShippedShipments($nextToken: String, $limit: Int, $order: OrderDirection) {
    listShippedShipments(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...ShipmentFieldsHydrated
      }
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;

/**
 * __useListShippedShipmentsQuery__
 *
 * To run a query within a React component, call `useListShippedShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShippedShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShippedShipmentsQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListShippedShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>(ListShippedShipmentsDocument, options);
}
export function useListShippedShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>(ListShippedShipmentsDocument, options);
}
// @ts-ignore
export function useListShippedShipmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>;
export function useListShippedShipmentsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShippedShipmentsQuery | undefined, TListShippedShipmentsQueryVariables>;
export function useListShippedShipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>(ListShippedShipmentsDocument, options);
}
export type ListShippedShipmentsQueryHookResult = ReturnType<typeof useListShippedShipmentsQuery>;
export type ListShippedShipmentsLazyQueryHookResult = ReturnType<typeof useListShippedShipmentsLazyQuery>;
export type ListShippedShipmentsSuspenseQueryHookResult = ReturnType<typeof useListShippedShipmentsSuspenseQuery>;
export type ListShippedShipmentsQueryResult = Apollo.QueryResult<TListShippedShipmentsQuery, TListShippedShipmentsQueryVariables>;
export const ListSetForPickupShipmentsDocument = gql`
  query ListSetForPickupShipments($nextToken: String, $limit: Int, $order: OrderDirection) {
    listSetForPickupShipments(nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...ShipmentFieldsHydrated
      }
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;

/**
 * __useListSetForPickupShipmentsQuery__
 *
 * To run a query within a React component, call `useListSetForPickupShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSetForPickupShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSetForPickupShipmentsQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListSetForPickupShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>(ListSetForPickupShipmentsDocument, options);
}
export function useListSetForPickupShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>(ListSetForPickupShipmentsDocument, options);
}
// @ts-ignore
export function useListSetForPickupShipmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>;
export function useListSetForPickupShipmentsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListSetForPickupShipmentsQuery | undefined, TListSetForPickupShipmentsQueryVariables>;
export function useListSetForPickupShipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>(ListSetForPickupShipmentsDocument, options);
}
export type ListSetForPickupShipmentsQueryHookResult = ReturnType<typeof useListSetForPickupShipmentsQuery>;
export type ListSetForPickupShipmentsLazyQueryHookResult = ReturnType<typeof useListSetForPickupShipmentsLazyQuery>;
export type ListSetForPickupShipmentsSuspenseQueryHookResult = ReturnType<typeof useListSetForPickupShipmentsSuspenseQuery>;
export type ListSetForPickupShipmentsQueryResult = Apollo.QueryResult<TListSetForPickupShipmentsQuery, TListSetForPickupShipmentsQueryVariables>;
export const ListShipmentsByAddressAndStatusDocument = gql`
  query ListShipmentsByAddressAndStatus($addressId: ID!, $status: ShipmentStatuses!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listShipmentsByAddressAndStatus(addressId: $addressId, status: $status, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...ShipmentFieldsHydrated
      }
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;

/**
 * __useListShipmentsByAddressAndStatusQuery__
 *
 * To run a query within a React component, call `useListShipmentsByAddressAndStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShipmentsByAddressAndStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShipmentsByAddressAndStatusQuery({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      status: // value for 'status'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListShipmentsByAddressAndStatusQuery(
  baseOptions: Apollo.QueryHookOptions<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables> & ({ variables: TListShipmentsByAddressAndStatusQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables>(ListShipmentsByAddressAndStatusDocument, options);
}
export function useListShipmentsByAddressAndStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables>(ListShipmentsByAddressAndStatusDocument, options);
}
// @ts-ignore
export function useListShipmentsByAddressAndStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables>;
export function useListShipmentsByAddressAndStatusSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShipmentsByAddressAndStatusQuery | undefined, TListShipmentsByAddressAndStatusQueryVariables>;
export function useListShipmentsByAddressAndStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables>(ListShipmentsByAddressAndStatusDocument, options);
}
export type ListShipmentsByAddressAndStatusQueryHookResult = ReturnType<typeof useListShipmentsByAddressAndStatusQuery>;
export type ListShipmentsByAddressAndStatusLazyQueryHookResult = ReturnType<typeof useListShipmentsByAddressAndStatusLazyQuery>;
export type ListShipmentsByAddressAndStatusSuspenseQueryHookResult = ReturnType<typeof useListShipmentsByAddressAndStatusSuspenseQuery>;
export type ListShipmentsByAddressAndStatusQueryResult = Apollo.QueryResult<TListShipmentsByAddressAndStatusQuery, TListShipmentsByAddressAndStatusQueryVariables>;
export const GetShipmentDocument = gql`
  query GetShipment($id: ID!, $companyId: ID!) {
    getShipment(id: $id, companyId: $companyId) {
      ...ShipmentFieldsHydrated
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;

/**
 * __useGetShipmentQuery__
 *
 * To run a query within a React component, call `useGetShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetShipmentQuery(baseOptions: Apollo.QueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables> & ({ variables: TGetShipmentQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetShipmentQuery, TGetShipmentQueryVariables>(GetShipmentDocument, options);
}
export function useGetShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetShipmentQuery, TGetShipmentQueryVariables>(GetShipmentDocument, options);
}
// @ts-ignore
export function useGetShipmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables>): Apollo.UseSuspenseQueryResult<TGetShipmentQuery, TGetShipmentQueryVariables>;
export function useGetShipmentSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetShipmentQuery | undefined, TGetShipmentQueryVariables>;
export function useGetShipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetShipmentQuery, TGetShipmentQueryVariables>(GetShipmentDocument, options);
}
export type GetShipmentQueryHookResult = ReturnType<typeof useGetShipmentQuery>;
export type GetShipmentLazyQueryHookResult = ReturnType<typeof useGetShipmentLazyQuery>;
export type GetShipmentSuspenseQueryHookResult = ReturnType<typeof useGetShipmentSuspenseQuery>;
export type GetShipmentQueryResult = Apollo.QueryResult<TGetShipmentQuery, TGetShipmentQueryVariables>;
export const CreateShipmentWithGiftsDocument = gql`
  mutation CreateShipmentWithGifts($input: CreateShipmentWithGiftsMutationInput!) {
    createShipmentWithGifts(input: $input) {
      ...ShipmentFieldsHydrated
      gifts {
        items {
          ...BaseGiftFields
        }
      }
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;
export type TCreateShipmentWithGiftsMutationFn = Apollo.MutationFunction<TCreateShipmentWithGiftsMutation, TCreateShipmentWithGiftsMutationVariables>;

/**
 * __useCreateShipmentWithGiftsMutation__
 *
 * To run a mutation, you first call `useCreateShipmentWithGiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentWithGiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentWithGiftsMutation, { data, loading, error }] = useCreateShipmentWithGiftsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipmentWithGiftsMutation(baseOptions?: Apollo.MutationHookOptions<TCreateShipmentWithGiftsMutation, TCreateShipmentWithGiftsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateShipmentWithGiftsMutation, TCreateShipmentWithGiftsMutationVariables>(CreateShipmentWithGiftsDocument, options);
}
export type CreateShipmentWithGiftsMutationHookResult = ReturnType<typeof useCreateShipmentWithGiftsMutation>;
export type CreateShipmentWithGiftsMutationResult = Apollo.MutationResult<TCreateShipmentWithGiftsMutation>;
export type CreateShipmentWithGiftsMutationOptions = Apollo.BaseMutationOptions<TCreateShipmentWithGiftsMutation, TCreateShipmentWithGiftsMutationVariables>;
export const AddGiftsToShipmentDocument = gql`
  mutation AddGiftsToShipment($shipmentId: ID!, $companyId: ID!, $giftsIds: [ID!]!) {
    addGiftsToShipment(shipmentId: $shipmentId, companyId: $companyId, giftsIds: $giftsIds) {
      ...ShipmentFieldsHydrated
      gifts {
        items {
          ...BaseGiftFields
        }
      }
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;
export type TAddGiftsToShipmentMutationFn = Apollo.MutationFunction<TAddGiftsToShipmentMutation, TAddGiftsToShipmentMutationVariables>;

/**
 * __useAddGiftsToShipmentMutation__
 *
 * To run a mutation, you first call `useAddGiftsToShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGiftsToShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGiftsToShipmentMutation, { data, loading, error }] = useAddGiftsToShipmentMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      companyId: // value for 'companyId'
 *      giftsIds: // value for 'giftsIds'
 *   },
 * });
 */
export function useAddGiftsToShipmentMutation(baseOptions?: Apollo.MutationHookOptions<TAddGiftsToShipmentMutation, TAddGiftsToShipmentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TAddGiftsToShipmentMutation, TAddGiftsToShipmentMutationVariables>(AddGiftsToShipmentDocument, options);
}
export type AddGiftsToShipmentMutationHookResult = ReturnType<typeof useAddGiftsToShipmentMutation>;
export type AddGiftsToShipmentMutationResult = Apollo.MutationResult<TAddGiftsToShipmentMutation>;
export type AddGiftsToShipmentMutationOptions = Apollo.BaseMutationOptions<TAddGiftsToShipmentMutation, TAddGiftsToShipmentMutationVariables>;
export const UpdateShipmentDocument = gql`
  mutation UpdateShipment($id: ID!, $companyId: ID!, $version: Int!, $input: UpdateShipmentMutationInput!) {
    updateShipment(id: $id, companyId: $companyId, _version: $version, input: $input) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TUpdateShipmentMutationFn = Apollo.MutationFunction<TUpdateShipmentMutation, TUpdateShipmentMutationVariables>;

/**
 * __useUpdateShipmentMutation__
 *
 * To run a mutation, you first call `useUpdateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentMutation, { data, loading, error }] = useUpdateShipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateShipmentMutation, TUpdateShipmentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateShipmentMutation, TUpdateShipmentMutationVariables>(UpdateShipmentDocument, options);
}
export type UpdateShipmentMutationHookResult = ReturnType<typeof useUpdateShipmentMutation>;
export type UpdateShipmentMutationResult = Apollo.MutationResult<TUpdateShipmentMutation>;
export type UpdateShipmentMutationOptions = Apollo.BaseMutationOptions<TUpdateShipmentMutation, TUpdateShipmentMutationVariables>;
export const SetShipmentForPickupDocument = gql`
  mutation SetShipmentForPickup($id: ID!, $companyId: ID!, $version: Int!) {
    setShipmentForPickup(id: $id, companyId: $companyId, _version: $version) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TSetShipmentForPickupMutationFn = Apollo.MutationFunction<TSetShipmentForPickupMutation, TSetShipmentForPickupMutationVariables>;

/**
 * __useSetShipmentForPickupMutation__
 *
 * To run a mutation, you first call `useSetShipmentForPickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentForPickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentForPickupMutation, { data, loading, error }] = useSetShipmentForPickupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSetShipmentForPickupMutation(baseOptions?: Apollo.MutationHookOptions<TSetShipmentForPickupMutation, TSetShipmentForPickupMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TSetShipmentForPickupMutation, TSetShipmentForPickupMutationVariables>(SetShipmentForPickupDocument, options);
}
export type SetShipmentForPickupMutationHookResult = ReturnType<typeof useSetShipmentForPickupMutation>;
export type SetShipmentForPickupMutationResult = Apollo.MutationResult<TSetShipmentForPickupMutation>;
export type SetShipmentForPickupMutationOptions = Apollo.BaseMutationOptions<TSetShipmentForPickupMutation, TSetShipmentForPickupMutationVariables>;
export const SetShipmentAsPickedUpDocument = gql`
  mutation SetShipmentAsPickedUp($id: ID!, $companyId: ID!, $version: Int!) {
    setShipmentAsPickedUp(id: $id, companyId: $companyId, _version: $version) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TSetShipmentAsPickedUpMutationFn = Apollo.MutationFunction<TSetShipmentAsPickedUpMutation, TSetShipmentAsPickedUpMutationVariables>;

/**
 * __useSetShipmentAsPickedUpMutation__
 *
 * To run a mutation, you first call `useSetShipmentAsPickedUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentAsPickedUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentAsPickedUpMutation, { data, loading, error }] = useSetShipmentAsPickedUpMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSetShipmentAsPickedUpMutation(baseOptions?: Apollo.MutationHookOptions<TSetShipmentAsPickedUpMutation, TSetShipmentAsPickedUpMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TSetShipmentAsPickedUpMutation, TSetShipmentAsPickedUpMutationVariables>(SetShipmentAsPickedUpDocument, options);
}
export type SetShipmentAsPickedUpMutationHookResult = ReturnType<typeof useSetShipmentAsPickedUpMutation>;
export type SetShipmentAsPickedUpMutationResult = Apollo.MutationResult<TSetShipmentAsPickedUpMutation>;
export type SetShipmentAsPickedUpMutationOptions = Apollo.BaseMutationOptions<TSetShipmentAsPickedUpMutation, TSetShipmentAsPickedUpMutationVariables>;
export const CancelShipmentForPickupDocument = gql`
  mutation CancelShipmentForPickup($id: ID!, $companyId: ID!, $version: Int!) {
    cancelShipmentForPickup(id: $id, companyId: $companyId, _version: $version) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TCancelShipmentForPickupMutationFn = Apollo.MutationFunction<TCancelShipmentForPickupMutation, TCancelShipmentForPickupMutationVariables>;

/**
 * __useCancelShipmentForPickupMutation__
 *
 * To run a mutation, you first call `useCancelShipmentForPickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelShipmentForPickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelShipmentForPickupMutation, { data, loading, error }] = useCancelShipmentForPickupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useCancelShipmentForPickupMutation(baseOptions?: Apollo.MutationHookOptions<TCancelShipmentForPickupMutation, TCancelShipmentForPickupMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCancelShipmentForPickupMutation, TCancelShipmentForPickupMutationVariables>(CancelShipmentForPickupDocument, options);
}
export type CancelShipmentForPickupMutationHookResult = ReturnType<typeof useCancelShipmentForPickupMutation>;
export type CancelShipmentForPickupMutationResult = Apollo.MutationResult<TCancelShipmentForPickupMutation>;
export type CancelShipmentForPickupMutationOptions = Apollo.BaseMutationOptions<TCancelShipmentForPickupMutation, TCancelShipmentForPickupMutationVariables>;
export const SetShipmentAsReadyToShipDocument = gql`
  mutation SetShipmentAsReadyToShip($id: ID!, $companyId: ID!, $version: Int!, $input: SetShipmentAsReadyToShipMutationInput!) {
    setShipmentAsReadyToShip(id: $id, companyId: $companyId, _version: $version, input: $input) {
      ...ShipmentNewFieldsAndHydration
    }
  }
  ${ShipmentNewFieldsAndHydrationFragmentDoc}
  ${ShipmentNewFieldsFragmentDoc}
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
`;
export type TSetShipmentAsReadyToShipMutationFn = Apollo.MutationFunction<TSetShipmentAsReadyToShipMutation, TSetShipmentAsReadyToShipMutationVariables>;

/**
 * __useSetShipmentAsReadyToShipMutation__
 *
 * To run a mutation, you first call `useSetShipmentAsReadyToShipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentAsReadyToShipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentAsReadyToShipMutation, { data, loading, error }] = useSetShipmentAsReadyToShipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetShipmentAsReadyToShipMutation(baseOptions?: Apollo.MutationHookOptions<TSetShipmentAsReadyToShipMutation, TSetShipmentAsReadyToShipMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TSetShipmentAsReadyToShipMutation, TSetShipmentAsReadyToShipMutationVariables>(SetShipmentAsReadyToShipDocument, options);
}
export type SetShipmentAsReadyToShipMutationHookResult = ReturnType<typeof useSetShipmentAsReadyToShipMutation>;
export type SetShipmentAsReadyToShipMutationResult = Apollo.MutationResult<TSetShipmentAsReadyToShipMutation>;
export type SetShipmentAsReadyToShipMutationOptions = Apollo.BaseMutationOptions<TSetShipmentAsReadyToShipMutation, TSetShipmentAsReadyToShipMutationVariables>;
export const PrintShipmentLabelDocument = gql`
  mutation PrintShipmentLabel($id: ID!, $companyId: ID!, $version: Int!, $input: PrintShipmentLabelMutationInput!) {
    printShipmentLabel(id: $id, companyId: $companyId, _version: $version, input: $input) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TPrintShipmentLabelMutationFn = Apollo.MutationFunction<TPrintShipmentLabelMutation, TPrintShipmentLabelMutationVariables>;

/**
 * __usePrintShipmentLabelMutation__
 *
 * To run a mutation, you first call `usePrintShipmentLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintShipmentLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printShipmentLabelMutation, { data, loading, error }] = usePrintShipmentLabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintShipmentLabelMutation(baseOptions?: Apollo.MutationHookOptions<TPrintShipmentLabelMutation, TPrintShipmentLabelMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TPrintShipmentLabelMutation, TPrintShipmentLabelMutationVariables>(PrintShipmentLabelDocument, options);
}
export type PrintShipmentLabelMutationHookResult = ReturnType<typeof usePrintShipmentLabelMutation>;
export type PrintShipmentLabelMutationResult = Apollo.MutationResult<TPrintShipmentLabelMutation>;
export type PrintShipmentLabelMutationOptions = Apollo.BaseMutationOptions<TPrintShipmentLabelMutation, TPrintShipmentLabelMutationVariables>;
export const SetShipmentAsShippedDocument = gql`
  mutation SetShipmentAsShipped($id: ID!, $companyId: ID!, $version: Int!) {
    setShipmentAsShipped(id: $id, companyId: $companyId, _version: $version) {
      ...ShipmentFieldsHydrated
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
`;
export type TSetShipmentAsShippedMutationFn = Apollo.MutationFunction<TSetShipmentAsShippedMutation, TSetShipmentAsShippedMutationVariables>;

/**
 * __useSetShipmentAsShippedMutation__
 *
 * To run a mutation, you first call `useSetShipmentAsShippedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShipmentAsShippedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShipmentAsShippedMutation, { data, loading, error }] = useSetShipmentAsShippedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSetShipmentAsShippedMutation(baseOptions?: Apollo.MutationHookOptions<TSetShipmentAsShippedMutation, TSetShipmentAsShippedMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TSetShipmentAsShippedMutation, TSetShipmentAsShippedMutationVariables>(SetShipmentAsShippedDocument, options);
}
export type SetShipmentAsShippedMutationHookResult = ReturnType<typeof useSetShipmentAsShippedMutation>;
export type SetShipmentAsShippedMutationResult = Apollo.MutationResult<TSetShipmentAsShippedMutation>;
export type SetShipmentAsShippedMutationOptions = Apollo.BaseMutationOptions<TSetShipmentAsShippedMutation, TSetShipmentAsShippedMutationVariables>;
export const DeleteShipmentDocument = gql`
  mutation DeleteShipment($id: ID!, $companyId: ID!, $version: Int!) {
    deleteShipment(id: $id, companyId: $companyId, _version: $version) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TDeleteShipmentMutationFn = Apollo.MutationFunction<TDeleteShipmentMutation, TDeleteShipmentMutationVariables>;

/**
 * __useDeleteShipmentMutation__
 *
 * To run a mutation, you first call `useDeleteShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipmentMutation, { data, loading, error }] = useDeleteShipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteShipmentMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteShipmentMutation, TDeleteShipmentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteShipmentMutation, TDeleteShipmentMutationVariables>(DeleteShipmentDocument, options);
}
export type DeleteShipmentMutationHookResult = ReturnType<typeof useDeleteShipmentMutation>;
export type DeleteShipmentMutationResult = Apollo.MutationResult<TDeleteShipmentMutation>;
export type DeleteShipmentMutationOptions = Apollo.BaseMutationOptions<TDeleteShipmentMutation, TDeleteShipmentMutationVariables>;
export const RecreateShipmentDocument = gql`
  mutation RecreateShipment($id: ID!, $companyId: ID!) {
    recreateShipment(id: $id, companyId: $companyId) {
      companyId
      items {
        ...BaseGiftFields
      }
    }
  }
  ${BaseGiftFieldsFragmentDoc}
`;
export type TRecreateShipmentMutationFn = Apollo.MutationFunction<TRecreateShipmentMutation, TRecreateShipmentMutationVariables>;

/**
 * __useRecreateShipmentMutation__
 *
 * To run a mutation, you first call `useRecreateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecreateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recreateShipmentMutation, { data, loading, error }] = useRecreateShipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRecreateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<TRecreateShipmentMutation, TRecreateShipmentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TRecreateShipmentMutation, TRecreateShipmentMutationVariables>(RecreateShipmentDocument, options);
}
export type RecreateShipmentMutationHookResult = ReturnType<typeof useRecreateShipmentMutation>;
export type RecreateShipmentMutationResult = Apollo.MutationResult<TRecreateShipmentMutation>;
export type RecreateShipmentMutationOptions = Apollo.BaseMutationOptions<TRecreateShipmentMutation, TRecreateShipmentMutationVariables>;
export const ReshipShipmentDocument = gql`
  mutation ReshipShipment($id: ID!, $companyId: ID!, $version: Int!) {
    reshipShipment(id: $id, companyId: $companyId, _version: $version) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TReshipShipmentMutationFn = Apollo.MutationFunction<TReshipShipmentMutation, TReshipShipmentMutationVariables>;

/**
 * __useReshipShipmentMutation__
 *
 * To run a mutation, you first call `useReshipShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReshipShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reshipShipmentMutation, { data, loading, error }] = useReshipShipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useReshipShipmentMutation(baseOptions?: Apollo.MutationHookOptions<TReshipShipmentMutation, TReshipShipmentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TReshipShipmentMutation, TReshipShipmentMutationVariables>(ReshipShipmentDocument, options);
}
export type ReshipShipmentMutationHookResult = ReturnType<typeof useReshipShipmentMutation>;
export type ReshipShipmentMutationResult = Apollo.MutationResult<TReshipShipmentMutation>;
export type ReshipShipmentMutationOptions = Apollo.BaseMutationOptions<TReshipShipmentMutation, TReshipShipmentMutationVariables>;
export const ResyncShipmentWithShipStationDocument = gql`
  mutation ResyncShipmentWithShipStation($id: ID!, $companyId: ID!, $version: Int!) {
    resyncShipmentWithShipStation(id: $id, companyId: $companyId, _version: $version) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TResyncShipmentWithShipStationMutationFn = Apollo.MutationFunction<TResyncShipmentWithShipStationMutation, TResyncShipmentWithShipStationMutationVariables>;

/**
 * __useResyncShipmentWithShipStationMutation__
 *
 * To run a mutation, you first call `useResyncShipmentWithShipStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncShipmentWithShipStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncShipmentWithShipStationMutation, { data, loading, error }] = useResyncShipmentWithShipStationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useResyncShipmentWithShipStationMutation(baseOptions?: Apollo.MutationHookOptions<TResyncShipmentWithShipStationMutation, TResyncShipmentWithShipStationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TResyncShipmentWithShipStationMutation, TResyncShipmentWithShipStationMutationVariables>(ResyncShipmentWithShipStationDocument, options);
}
export type ResyncShipmentWithShipStationMutationHookResult = ReturnType<typeof useResyncShipmentWithShipStationMutation>;
export type ResyncShipmentWithShipStationMutationResult = Apollo.MutationResult<TResyncShipmentWithShipStationMutation>;
export type ResyncShipmentWithShipStationMutationOptions = Apollo.BaseMutationOptions<TResyncShipmentWithShipStationMutation, TResyncShipmentWithShipStationMutationVariables>;
export const PrintLabelPhysicallyDocument = gql`
  mutation PrintLabelPhysically($id: ID!, $companyId: ID!, $version: Int!) {
    printLabelPhysically(id: $id, companyId: $companyId, _version: $version) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TPrintLabelPhysicallyMutationFn = Apollo.MutationFunction<TPrintLabelPhysicallyMutation, TPrintLabelPhysicallyMutationVariables>;

/**
 * __usePrintLabelPhysicallyMutation__
 *
 * To run a mutation, you first call `usePrintLabelPhysicallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintLabelPhysicallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printLabelPhysicallyMutation, { data, loading, error }] = usePrintLabelPhysicallyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function usePrintLabelPhysicallyMutation(baseOptions?: Apollo.MutationHookOptions<TPrintLabelPhysicallyMutation, TPrintLabelPhysicallyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TPrintLabelPhysicallyMutation, TPrintLabelPhysicallyMutationVariables>(PrintLabelPhysicallyDocument, options);
}
export type PrintLabelPhysicallyMutationHookResult = ReturnType<typeof usePrintLabelPhysicallyMutation>;
export type PrintLabelPhysicallyMutationResult = Apollo.MutationResult<TPrintLabelPhysicallyMutation>;
export type PrintLabelPhysicallyMutationOptions = Apollo.BaseMutationOptions<TPrintLabelPhysicallyMutation, TPrintLabelPhysicallyMutationVariables>;
export const PrintCusmaDocument = gql`
  mutation PrintCUSMA($id: ID!, $companyId: ID!, $version: Int!) {
    printCUSMA(id: $id, companyId: $companyId, _version: $version) {
      ...ShipmentFields
    }
  }
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TPrintCusmaMutationFn = Apollo.MutationFunction<TPrintCusmaMutation, TPrintCusmaMutationVariables>;

/**
 * __usePrintCusmaMutation__
 *
 * To run a mutation, you first call `usePrintCusmaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintCusmaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printCusmaMutation, { data, loading, error }] = usePrintCusmaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function usePrintCusmaMutation(baseOptions?: Apollo.MutationHookOptions<TPrintCusmaMutation, TPrintCusmaMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TPrintCusmaMutation, TPrintCusmaMutationVariables>(PrintCusmaDocument, options);
}
export type PrintCusmaMutationHookResult = ReturnType<typeof usePrintCusmaMutation>;
export type PrintCusmaMutationResult = Apollo.MutationResult<TPrintCusmaMutation>;
export type PrintCusmaMutationOptions = Apollo.BaseMutationOptions<TPrintCusmaMutation, TPrintCusmaMutationVariables>;
export const OnAnyShipmentChangedDocument = gql`
  subscription OnAnyShipmentChanged {
    onAnyShipmentChanged {
      ...ShipmentNewFieldsAndHydration
    }
  }
  ${ShipmentNewFieldsAndHydrationFragmentDoc}
  ${ShipmentNewFieldsFragmentDoc}
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
`;

/**
 * __useOnAnyShipmentChangedSubscription__
 *
 * To run a query within a React component, call `useOnAnyShipmentChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyShipmentChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyShipmentChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyShipmentChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyShipmentChangedSubscription, TOnAnyShipmentChangedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyShipmentChangedSubscription, TOnAnyShipmentChangedSubscriptionVariables>(OnAnyShipmentChangedDocument, options);
}
export type OnAnyShipmentChangedSubscriptionHookResult = ReturnType<typeof useOnAnyShipmentChangedSubscription>;
export type OnAnyShipmentChangedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyShipmentChangedSubscription>;
export const OnAnyShipmentRecreatedDocument = gql`
  subscription OnAnyShipmentRecreated {
    onAnyShipmentRecreated {
      companyId
      items {
        ...BaseGiftFields
      }
    }
  }
  ${BaseGiftFieldsFragmentDoc}
`;

/**
 * __useOnAnyShipmentRecreatedSubscription__
 *
 * To run a query within a React component, call `useOnAnyShipmentRecreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyShipmentRecreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyShipmentRecreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyShipmentRecreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TOnAnyShipmentRecreatedSubscription, TOnAnyShipmentRecreatedSubscriptionVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnAnyShipmentRecreatedSubscription, TOnAnyShipmentRecreatedSubscriptionVariables>(OnAnyShipmentRecreatedDocument, options);
}
export type OnAnyShipmentRecreatedSubscriptionHookResult = ReturnType<typeof useOnAnyShipmentRecreatedSubscription>;
export type OnAnyShipmentRecreatedSubscriptionResult = Apollo.SubscriptionResult<TOnAnyShipmentRecreatedSubscription>;
export const ListOpenShipmentsNewDocument = gql`
  query ListOpenShipmentsNEW($nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listOpenShipmentsNEW(nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...ShipmentNewFieldsAndHydration
      }
    }
  }
  ${ShipmentNewFieldsAndHydrationFragmentDoc}
  ${ShipmentNewFieldsFragmentDoc}
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
`;

/**
 * __useListOpenShipmentsNewQuery__
 *
 * To run a query within a React component, call `useListOpenShipmentsNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOpenShipmentsNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOpenShipmentsNewQuery({
 *   variables: {
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOpenShipmentsNewQuery(baseOptions?: Apollo.QueryHookOptions<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>(ListOpenShipmentsNewDocument, options);
}
export function useListOpenShipmentsNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>(ListOpenShipmentsNewDocument, options);
}
// @ts-ignore
export function useListOpenShipmentsNewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>;
export function useListOpenShipmentsNewSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOpenShipmentsNewQuery | undefined, TListOpenShipmentsNewQueryVariables>;
export function useListOpenShipmentsNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>(ListOpenShipmentsNewDocument, options);
}
export type ListOpenShipmentsNewQueryHookResult = ReturnType<typeof useListOpenShipmentsNewQuery>;
export type ListOpenShipmentsNewLazyQueryHookResult = ReturnType<typeof useListOpenShipmentsNewLazyQuery>;
export type ListOpenShipmentsNewSuspenseQueryHookResult = ReturnType<typeof useListOpenShipmentsNewSuspenseQuery>;
export type ListOpenShipmentsNewQueryResult = Apollo.QueryResult<TListOpenShipmentsNewQuery, TListOpenShipmentsNewQueryVariables>;
export const ListShipmentsTrackingNewDocument = gql`
  query ListShipmentsTrackingNEW($shippedAt: String, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listShipmentsTrackingNEW(shippedAt: $shippedAt, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...ShipmentNewFieldsAndHydration
      }
    }
  }
  ${ShipmentNewFieldsAndHydrationFragmentDoc}
  ${ShipmentNewFieldsFragmentDoc}
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
`;

/**
 * __useListShipmentsTrackingNewQuery__
 *
 * To run a query within a React component, call `useListShipmentsTrackingNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShipmentsTrackingNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShipmentsTrackingNewQuery({
 *   variables: {
 *      shippedAt: // value for 'shippedAt'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListShipmentsTrackingNewQuery(baseOptions?: Apollo.QueryHookOptions<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>(ListShipmentsTrackingNewDocument, options);
}
export function useListShipmentsTrackingNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>(ListShipmentsTrackingNewDocument, options);
}
// @ts-ignore
export function useListShipmentsTrackingNewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>;
export function useListShipmentsTrackingNewSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShipmentsTrackingNewQuery | undefined, TListShipmentsTrackingNewQueryVariables>;
export function useListShipmentsTrackingNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>(ListShipmentsTrackingNewDocument, options);
}
export type ListShipmentsTrackingNewQueryHookResult = ReturnType<typeof useListShipmentsTrackingNewQuery>;
export type ListShipmentsTrackingNewLazyQueryHookResult = ReturnType<typeof useListShipmentsTrackingNewLazyQuery>;
export type ListShipmentsTrackingNewSuspenseQueryHookResult = ReturnType<typeof useListShipmentsTrackingNewSuspenseQuery>;
export type ListShipmentsTrackingNewQueryResult = Apollo.QueryResult<TListShipmentsTrackingNewQuery, TListShipmentsTrackingNewQueryVariables>;
export const ListShipmentsPickupNewDocument = gql`
  query ListShipmentsPickupNEW($setForPickupAt: String, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listShipmentsPickupNEW(setForPickupAt: $setForPickupAt, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...ShipmentNewFieldsAndHydration
      }
    }
  }
  ${ShipmentNewFieldsAndHydrationFragmentDoc}
  ${ShipmentNewFieldsFragmentDoc}
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
`;

/**
 * __useListShipmentsPickupNewQuery__
 *
 * To run a query within a React component, call `useListShipmentsPickupNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShipmentsPickupNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShipmentsPickupNewQuery({
 *   variables: {
 *      setForPickupAt: // value for 'setForPickupAt'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListShipmentsPickupNewQuery(baseOptions?: Apollo.QueryHookOptions<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>(ListShipmentsPickupNewDocument, options);
}
export function useListShipmentsPickupNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>(ListShipmentsPickupNewDocument, options);
}
// @ts-ignore
export function useListShipmentsPickupNewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>;
export function useListShipmentsPickupNewSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShipmentsPickupNewQuery | undefined, TListShipmentsPickupNewQueryVariables>;
export function useListShipmentsPickupNewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>(ListShipmentsPickupNewDocument, options);
}
export type ListShipmentsPickupNewQueryHookResult = ReturnType<typeof useListShipmentsPickupNewQuery>;
export type ListShipmentsPickupNewLazyQueryHookResult = ReturnType<typeof useListShipmentsPickupNewLazyQuery>;
export type ListShipmentsPickupNewSuspenseQueryHookResult = ReturnType<typeof useListShipmentsPickupNewSuspenseQuery>;
export type ListShipmentsPickupNewQueryResult = Apollo.QueryResult<TListShipmentsPickupNewQuery, TListShipmentsPickupNewQueryVariables>;
export const ListOneShipmentDocument = gql`
  query ListOneShipment($id: ID!, $nextToken: String, $limit: Int, $filter: FilterInput, $order: OrderDirection) {
    listOneShipment(id: $id, nextToken: $nextToken, limit: $limit, filter: $filter, order: $order) {
      nextToken
      items {
        ...ShipmentNewFieldsAndHydration
      }
    }
  }
  ${ShipmentNewFieldsAndHydrationFragmentDoc}
  ${ShipmentNewFieldsFragmentDoc}
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${BaseGiftFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${ListAllEmployeesFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
`;

/**
 * __useListOneShipmentQuery__
 *
 * To run a query within a React component, call `useListOneShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOneShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOneShipmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOneShipmentQuery(baseOptions: Apollo.QueryHookOptions<TListOneShipmentQuery, TListOneShipmentQueryVariables> & ({ variables: TListOneShipmentQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOneShipmentQuery, TListOneShipmentQueryVariables>(ListOneShipmentDocument, options);
}
export function useListOneShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOneShipmentQuery, TListOneShipmentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOneShipmentQuery, TListOneShipmentQueryVariables>(ListOneShipmentDocument, options);
}
// @ts-ignore
export function useListOneShipmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListOneShipmentQuery, TListOneShipmentQueryVariables>): Apollo.UseSuspenseQueryResult<TListOneShipmentQuery, TListOneShipmentQueryVariables>;
export function useListOneShipmentSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneShipmentQuery, TListOneShipmentQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOneShipmentQuery | undefined, TListOneShipmentQueryVariables>;
export function useListOneShipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOneShipmentQuery, TListOneShipmentQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOneShipmentQuery, TListOneShipmentQueryVariables>(ListOneShipmentDocument, options);
}
export type ListOneShipmentQueryHookResult = ReturnType<typeof useListOneShipmentQuery>;
export type ListOneShipmentLazyQueryHookResult = ReturnType<typeof useListOneShipmentLazyQuery>;
export type ListOneShipmentSuspenseQueryHookResult = ReturnType<typeof useListOneShipmentSuspenseQuery>;
export type ListOneShipmentQueryResult = Apollo.QueryResult<TListOneShipmentQuery, TListOneShipmentQueryVariables>;
export const ListUsersDocument = gql`
  query ListUsers($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listUsers(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...UserFields
      }
    }
  }
  ${UserFieldsFragmentDoc}
`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions: Apollo.QueryHookOptions<TListUsersQuery, TListUsersQueryVariables> & ({ variables: TListUsersQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListUsersQuery, TListUsersQueryVariables>(ListUsersDocument, options);
}
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListUsersQuery, TListUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListUsersQuery, TListUsersQueryVariables>(ListUsersDocument, options);
}
// @ts-ignore
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListUsersQuery, TListUsersQueryVariables>): Apollo.UseSuspenseQueryResult<TListUsersQuery, TListUsersQueryVariables>;
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListUsersQuery, TListUsersQueryVariables>): Apollo.UseSuspenseQueryResult<TListUsersQuery | undefined, TListUsersQueryVariables>;
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListUsersQuery, TListUsersQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListUsersQuery, TListUsersQueryVariables>(ListUsersDocument, options);
}
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<TListUsersQuery, TListUsersQueryVariables>;
export const ListUsersIncludingCsUsersDocument = gql`
  query ListUsersIncludingCSUsers($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listUsersIncludingCSUsers(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...UserFields
      }
    }
  }
  ${UserFieldsFragmentDoc}
`;

/**
 * __useListUsersIncludingCsUsersQuery__
 *
 * To run a query within a React component, call `useListUsersIncludingCsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersIncludingCsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersIncludingCsUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListUsersIncludingCsUsersQuery(
  baseOptions: Apollo.QueryHookOptions<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables> & ({ variables: TListUsersIncludingCsUsersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables>(ListUsersIncludingCsUsersDocument, options);
}
export function useListUsersIncludingCsUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables>(ListUsersIncludingCsUsersDocument, options);
}
// @ts-ignore
export function useListUsersIncludingCsUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables>;
export function useListUsersIncludingCsUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<TListUsersIncludingCsUsersQuery | undefined, TListUsersIncludingCsUsersQueryVariables>;
export function useListUsersIncludingCsUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables>(ListUsersIncludingCsUsersDocument, options);
}
export type ListUsersIncludingCsUsersQueryHookResult = ReturnType<typeof useListUsersIncludingCsUsersQuery>;
export type ListUsersIncludingCsUsersLazyQueryHookResult = ReturnType<typeof useListUsersIncludingCsUsersLazyQuery>;
export type ListUsersIncludingCsUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersIncludingCsUsersSuspenseQuery>;
export type ListUsersIncludingCsUsersQueryResult = Apollo.QueryResult<TListUsersIncludingCsUsersQuery, TListUsersIncludingCsUsersQueryVariables>;
export const CreateUserDocument = gql`
  mutation CreateUser($input: CreateUserMutationInput!) {
    createUser(input: $input) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type TCreateUserMutationFn = Apollo.MutationFunction<TCreateUserMutation, TCreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<TCreateUserMutation, TCreateUserMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateUserMutation, TCreateUserMutationVariables>(CreateUserDocument, options);
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<TCreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<TCreateUserMutation, TCreateUserMutationVariables>;
export const DeleteUserDocument = gql`
  mutation DeleteUser($email: AWSEmail!, $companyId: ID!, $version: Int!) {
    deleteUser(email: $email, companyId: $companyId, _version: $version) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type TDeleteUserMutationFn = Apollo.MutationFunction<TDeleteUserMutation, TDeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteUserMutation, TDeleteUserMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteUserMutation, TDeleteUserMutationVariables>(DeleteUserDocument, options);
}
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<TDeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<TDeleteUserMutation, TDeleteUserMutationVariables>;
export const ListAdminCognitoUsersDocument = gql`
  query ListAdminCognitoUsers($userPoolId: String!, $onlyCS: Boolean) {
    listAdminCognitoUsers(userPoolId: $userPoolId, onlyCS: $onlyCS)
  }
`;

/**
 * __useListAdminCognitoUsersQuery__
 *
 * To run a query within a React component, call `useListAdminCognitoUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminCognitoUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminCognitoUsersQuery({
 *   variables: {
 *      userPoolId: // value for 'userPoolId'
 *      onlyCS: // value for 'onlyCS'
 *   },
 * });
 */
export function useListAdminCognitoUsersQuery(
  baseOptions: Apollo.QueryHookOptions<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables> & ({ variables: TListAdminCognitoUsersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>(ListAdminCognitoUsersDocument, options);
}
export function useListAdminCognitoUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>(ListAdminCognitoUsersDocument, options);
}
// @ts-ignore
export function useListAdminCognitoUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>;
export function useListAdminCognitoUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<TListAdminCognitoUsersQuery | undefined, TListAdminCognitoUsersQueryVariables>;
export function useListAdminCognitoUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>(ListAdminCognitoUsersDocument, options);
}
export type ListAdminCognitoUsersQueryHookResult = ReturnType<typeof useListAdminCognitoUsersQuery>;
export type ListAdminCognitoUsersLazyQueryHookResult = ReturnType<typeof useListAdminCognitoUsersLazyQuery>;
export type ListAdminCognitoUsersSuspenseQueryHookResult = ReturnType<typeof useListAdminCognitoUsersSuspenseQuery>;
export type ListAdminCognitoUsersQueryResult = Apollo.QueryResult<TListAdminCognitoUsersQuery, TListAdminCognitoUsersQueryVariables>;
export const OnCompanyUserChangedDocument = gql`
  subscription OnCompanyUserChanged($companyId: ID!) {
    onCompanyUserChanged(companyId: $companyId) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;

/**
 * __useOnCompanyUserChangedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyUserChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyUserChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyUserChangedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyUserChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyUserChangedSubscription, TOnCompanyUserChangedSubscriptionVariables> & ({ variables: TOnCompanyUserChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyUserChangedSubscription, TOnCompanyUserChangedSubscriptionVariables>(OnCompanyUserChangedDocument, options);
}
export type OnCompanyUserChangedSubscriptionHookResult = ReturnType<typeof useOnCompanyUserChangedSubscription>;
export type OnCompanyUserChangedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyUserChangedSubscription>;
